//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import { trace, context, TraceFlags, Span } from '@opentelemetry/api';

import { ClientBase } from './client-base';
import { inject } from 'aurelia-framework';
import { HttpClient, RequestInit } from 'aurelia-fetch-client';

export class TransactionClientBase extends ClientBase {
  getBaseUrl(_defaultUrl: string, _baseUrl: string) {
    return this.apiService.getServiceUrl('transaction-api');
  }
}

@inject(String, HttpClient)
export class CategoriesClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CategoriesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async getSecCategories(companyIdentityId: number, categoryTypeId: number | null | undefined): Promise<CategoryViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Categories", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "categoryTypeId": categoryTypeId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Categories?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (categoryTypeId !== undefined && categoryTypeId !== null)
            url_ += "categoryTypeId=" + encodeURIComponent("" + categoryTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetSecCategories(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetSecCategories(response: Response): Promise<CategoryViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryViewModel[]>(null as any);
    }

    async post(companyIdentityId: number, request: CategoryViewModel): Promise<Category> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Categories", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Categories";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<Category> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Category.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Category>(null as any);
    }

    async instrumentCategories(companyIdentityId: number): Promise<CategoryViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Categories/InstrumentCategories", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Categories/InstrumentCategories";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processInstrumentCategories(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processInstrumentCategories(response: Response): Promise<CategoryViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryViewModel[]>(null as any);
    }

    async transactionCategories(companyIdentityId: number): Promise<CategoryViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Categories/TransactionCategories", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Categories/TransactionCategories";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processTransactionCategories(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processTransactionCategories(response: Response): Promise<CategoryViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryViewModel[]>(null as any);
    }

    async delete(companyIdentityId: number, categoryId: number): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}/Categories/{categoryId}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "categoryId": categoryId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Categories/{categoryId}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (categoryId === undefined || categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async postWithoutCompany(companyIdentityId: number, request: CategoryViewModel): Promise<Category> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Categories/PostWithoutCompany", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Categories/PostWithoutCompany";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPostWithoutCompany(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPostWithoutCompany(response: Response): Promise<Category> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Category.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Category>(null as any);
    }

    async hasInstrumentCategories(companyIdentityId: number, id: number | undefined): Promise<boolean> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Categories/HasInstrumentCategories", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Categories/HasInstrumentCategories?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processHasInstrumentCategories(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processHasInstrumentCategories(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

@inject(String, HttpClient)
export class CommittedCapitalsClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CommittedCapitalsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async get(companyId: number, instrumentId: number | undefined): Promise<CommittedCapital[]> {
        const span = this.tracer.startSpan("GET /companies/{companyId}/CommittedCapitals", {
            attributes: {
                "companyId": companyId,
                "instrumentId": instrumentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyId}/CommittedCapitals?";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' cannot be null.");
        else if (instrumentId !== undefined)
            url_ += "instrumentId=" + encodeURIComponent("" + instrumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<CommittedCapital[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommittedCapital.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommittedCapital[]>(null as any);
    }

    async post(companyId: number, request: CommittedCapital): Promise<CommittedCapital> {
        const span = this.tracer.startSpan("POST /companies/{companyId}/CommittedCapitals", {
            attributes: {
                "companyId": companyId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyId}/CommittedCapitals";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<CommittedCapital> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommittedCapital.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommittedCapital>(null as any);
    }

    async patch(companyId: number, request: CommittedCapital): Promise<CommittedCapital> {
        const span = this.tracer.startSpan("PATCH /companies/{companyId}/CommittedCapitals", {
            attributes: {
                "companyId": companyId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyId}/CommittedCapitals";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatch(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatch(response: Response): Promise<CommittedCapital> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommittedCapital.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommittedCapital>(null as any);
    }

    async delete(companyId: number, id: number): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyId}/CommittedCapitals/{id}", {
            attributes: {
                "companyId": companyId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyId}/CommittedCapitals/{id}";
        if (companyId === undefined || companyId === null)
            throw new globalThis.Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class CompanyStocksClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CompanyStocksClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async get(companyIdentityId: number, postedData: AgGridPageRequest): Promise<AgGridResponseOfCompanyStockValueUpdatedEvent> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/CompanyStocks/Get", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CompanyStocks/Get";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postedData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<AgGridResponseOfCompanyStockValueUpdatedEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgGridResponseOfCompanyStockValueUpdatedEvent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgGridResponseOfCompanyStockValueUpdatedEvent>(null as any);
    }

    async post(companyIdentityId: number): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/CompanyStocks", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CompanyStocks";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async patch(companyIdentityId: number, postedData: CompanyStockValueUpdatedEvent): Promise<void> {
        const span = this.tracer.startSpan("PATCH /companies/{companyIdentityId}/CompanyStocks", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CompanyStocks";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postedData);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatch(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatch(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async delete(companyIdentityId: number, id: number): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}/CompanyStocks/{id}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CompanyStocks/{id}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class CurrenciesClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CurrenciesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async get(): Promise<CurrencyCodeViewModel[]> {
        const span = this.tracer.startSpan("GET /Currencies", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Currencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<CurrencyCodeViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CurrencyCodeViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrencyCodeViewModel[]>(null as any);
    }
}

@inject(String, HttpClient)
export class CustomerGlAccountDefaultsClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CustomerGlAccountDefaultsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async get(companyIdentityId: number): Promise<CustomerGlAccountDefault[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/CustomerGlAccountDefaults", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CustomerGlAccountDefaults";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<CustomerGlAccountDefault[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerGlAccountDefault.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerGlAccountDefault[]>(null as any);
    }

    async post(companyIdentityId: number, request: CustomerGlAccountDefault): Promise<CustomerGlAccountDefault> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/CustomerGlAccountDefaults", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CustomerGlAccountDefaults";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<CustomerGlAccountDefault> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerGlAccountDefault.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerGlAccountDefault>(null as any);
    }

    async patch(companyIdentityId: number, request: CustomerGlAccountDefault): Promise<CustomerGlAccountDefault> {
        const span = this.tracer.startSpan("PATCH /companies/{companyIdentityId}/CustomerGlAccountDefaults", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CustomerGlAccountDefaults";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatch(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatch(response: Response): Promise<CustomerGlAccountDefault> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerGlAccountDefault.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerGlAccountDefault>(null as any);
    }

    async bank(companyIdentityId: number): Promise<CustomerGlAccountDefault[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/CustomerGlAccountDefaults/Bank", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CustomerGlAccountDefaults/Bank";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processBank(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processBank(response: Response): Promise<CustomerGlAccountDefault[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerGlAccountDefault.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerGlAccountDefault[]>(null as any);
    }

    async postBank(companyIdentityId: number, request: CustomerGlAccountDefault[]): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/CustomerGlAccountDefaults/PostBank", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CustomerGlAccountDefaults/PostBank";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPostBank(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPostBank(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async delete(companyIdentityId: number, id: number): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}/CustomerGlAccountDefaults/{id}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CustomerGlAccountDefaults/{id}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class CustomerGlAccountsClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CustomerGlAccountsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async get(companyIdentityId: number): Promise<CustomerGlAccountViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/CustomerGlAccounts", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CustomerGlAccounts";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<CustomerGlAccountViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerGlAccountViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerGlAccountViewModel[]>(null as any);
    }

    async put(companyIdentityId: number, account: CustomerGlAccountViewModel): Promise<CustomerGlAccountViewModel> {
        const span = this.tracer.startSpan("PUT /companies/{companyIdentityId}/CustomerGlAccounts", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CustomerGlAccounts";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(account);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPut(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPut(response: Response): Promise<CustomerGlAccountViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerGlAccountViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerGlAccountViewModel>(null as any);
    }

    async post(companyIdentityId: number, account: CustomerGlAccountViewModel): Promise<CustomerGlAccountViewModel> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/CustomerGlAccounts", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CustomerGlAccounts";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(account);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<CustomerGlAccountViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerGlAccountViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerGlAccountViewModel>(null as any);
    }

    async delete(companyIdentityId: number, accountId: number): Promise<number> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}/CustomerGlAccounts/{accountId}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "accountId": accountId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CustomerGlAccounts/{accountId}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

@inject(String, HttpClient)
export class CustomerSettingsClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("CustomerSettingsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async get(companyIdentityId: number): Promise<CustomerSettingsViewModel> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/settings", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/settings";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<CustomerSettingsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerSettingsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerSettingsViewModel>(null as any);
    }

    async post(companyIdentityId: number, customerSettings: CustomerSettingsViewModel): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/settings", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/settings";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerSettings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class EnumAndTypesClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("EnumAndTypesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async getInstrumentTypes(companyId: number | undefined): Promise<InstrumentTypeViewModel[]> {
        const span = this.tracer.startSpan("GET /enums/instrumentTypes", {
            attributes: {
                "companyId": companyId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/enums/instrumentTypes?";
        if (companyId === null)
            throw new globalThis.Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetInstrumentTypes(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetInstrumentTypes(response: Response): Promise<InstrumentTypeViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentTypeViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentTypeViewModel[]>(null as any);
    }
}

@inject(String, HttpClient)
export class ExcelReportsClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("ExcelReportsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async glPostingsReport(companyIdentityId: number, fromDate: string | undefined, toDate: string | undefined): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/ExcelReports/GlPostingsReport", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "fromDate": fromDate,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ExcelReports/GlPostingsReport?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGlPostingsReport(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGlPostingsReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    async dynamicsGlExport(companyIdentityId: number, fromDate: string | undefined, toDate: string | undefined): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/ExcelReports/DynamicsGlExport", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "fromDate": fromDate,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ExcelReports/DynamicsGlExport?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDynamicsGlExport(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDynamicsGlExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    async visma(companyIdentityId: number, fromDate: string | undefined, toDate: string | undefined): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/ExcelReports/Visma", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "fromDate": fromDate,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ExcelReports/Visma?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processVisma(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processVisma(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Export Visma Global report
     * @param companyIdentityId Company identifier
     * @param fromDate (optional) From date
     * @param toDate (optional) To date
     * @return An excel workbook with exported GL transactions
     */
    async vismaGlobal(companyIdentityId: number, fromDate: string | undefined, toDate: string | undefined): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/ExcelReports/VismaGlobal", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "fromDate": fromDate,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ExcelReports/VismaGlobal?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processVismaGlobal(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processVismaGlobal(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

@inject(String, HttpClient)
export class GlAccountTypesClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("GlAccountTypesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async get(): Promise<GlAccountType[]> {
        const span = this.tracer.startSpan("GET /GlAccountTypes", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/GlAccountTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<GlAccountType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlAccountType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlAccountType[]>(null as any);
    }
}

@inject(String, HttpClient)
export class GlTransactionsInsightClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("GlTransactionsInsightClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async byTransactionIds(companyIdentityId: number, instrumentTransactionIds: number[]): Promise<GlTransactionInsight[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/GlTransactionsInsight/ByTransactionIds", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/GlTransactionsInsight/ByTransactionIds";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instrumentTransactionIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processByTransactionIds(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processByTransactionIds(response: Response): Promise<GlTransactionInsight[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlTransactionInsight.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlTransactionInsight[]>(null as any);
    }

    /**
     * Same as ByTransactionIds but keyed on the voucher, so callers that only know which vouchers
    they are looking at do not have to carry their transaction ids around. An empty result means the vouchers
    have no GL transactions yet.
     */
    async byVoucherIds(companyIdentityId: number, voucherIds: string[]): Promise<GlTransactionInsight[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/GlTransactionsInsight/ByVoucherIds", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/GlTransactionsInsight/ByVoucherIds";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(voucherIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processByVoucherIds(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processByVoucherIds(response: Response): Promise<GlTransactionInsight[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlTransactionInsight.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlTransactionInsight[]>(null as any);
    }

    async getAll(companyIdentityId: number, agGridPageRequest: AgGridPageRequest): Promise<AgGridResponseOfGlTransactionInsight> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/GlTransactionsInsight/GetAll", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/GlTransactionsInsight/GetAll";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agGridPageRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetAll(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetAll(response: Response): Promise<AgGridResponseOfGlTransactionInsight> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgGridResponseOfGlTransactionInsight.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgGridResponseOfGlTransactionInsight>(null as any);
    }
}

@inject(String, HttpClient)
export class InstrumentAccountingValueDocumentsClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("InstrumentAccountingValueDocumentsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async getAll(companyIdentityId: number, instrumentId: string, instrumentAccountingValueStateId: string): Promise<InstrumentAccountingValueStateDocument[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues/{instrumentAccountingValueStateId}/documents", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "instrumentAccountingValueStateId": instrumentAccountingValueStateId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues/{instrumentAccountingValueStateId}/documents";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (instrumentAccountingValueStateId === undefined || instrumentAccountingValueStateId === null)
            throw new globalThis.Error("The parameter 'instrumentAccountingValueStateId' must be defined.");
        url_ = url_.replace("{instrumentAccountingValueStateId}", encodeURIComponent("" + instrumentAccountingValueStateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetAll(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetAll(response: Response): Promise<InstrumentAccountingValueStateDocument[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentAccountingValueStateDocument.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentAccountingValueStateDocument[]>(null as any);
    }

    async post(companyIdentityId: number, instrumentId: string, instrumentAccountingValueStateId: string, files: FileParameter[] | null | undefined): Promise<InstrumentAccountingValueStateDocument[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues/{instrumentAccountingValueStateId}/documents", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "instrumentAccountingValueStateId": instrumentAccountingValueStateId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues/{instrumentAccountingValueStateId}/documents";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (instrumentAccountingValueStateId === undefined || instrumentAccountingValueStateId === null)
            throw new globalThis.Error("The parameter 'instrumentAccountingValueStateId' must be defined.");
        url_ = url_.replace("{instrumentAccountingValueStateId}", encodeURIComponent("" + instrumentAccountingValueStateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<InstrumentAccountingValueStateDocument[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentAccountingValueStateDocument.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentAccountingValueStateDocument[]>(null as any);
    }

    async get(companyIdentityId: number, instrumentId: string, instrumentAccountingValueStateId: string, id: string): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues/{instrumentAccountingValueStateId}/documents/{id}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "instrumentAccountingValueStateId": instrumentAccountingValueStateId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues/{instrumentAccountingValueStateId}/documents/{id}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (instrumentAccountingValueStateId === undefined || instrumentAccountingValueStateId === null)
            throw new globalThis.Error("The parameter 'instrumentAccountingValueStateId' must be defined.");
        url_ = url_.replace("{instrumentAccountingValueStateId}", encodeURIComponent("" + instrumentAccountingValueStateId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    async delete(companyIdentityId: number, instrumentId: string, instrumentAccountingValueStateId: string, id: string): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues/{instrumentAccountingValueStateId}/documents/{id}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "instrumentAccountingValueStateId": instrumentAccountingValueStateId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues/{instrumentAccountingValueStateId}/documents/{id}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (instrumentAccountingValueStateId === undefined || instrumentAccountingValueStateId === null)
            throw new globalThis.Error("The parameter 'instrumentAccountingValueStateId' must be defined.");
        url_ = url_.replace("{instrumentAccountingValueStateId}", encodeURIComponent("" + instrumentAccountingValueStateId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class InstrumentAccountingValuesClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("InstrumentAccountingValuesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async get(companyIdentityId: number, instrumentId: string): Promise<InstrumentAccountingValueStateViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<InstrumentAccountingValueStateViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentAccountingValueStateViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentAccountingValueStateViewModel[]>(null as any);
    }

    async post(companyIdentityId: number, instrumentId: string): Promise<string> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    async patch(companyIdentityId: number, instrumentId: string, model: UpdateInstrumentAccountingValue): Promise<void> {
        const span = this.tracer.startSpan("PATCH /companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatch(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatch(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async delete(companyIdentityId: number, instrumentId: string, id: string | undefined): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async sync(companyIdentityId: number, instrumentId: number, model: SyncInstrumentAccountingValue): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues/sync", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/AccountingValues/sync";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processSync(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processSync(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async documentation(companyIdentityId: number, date: string | undefined): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/AccountingValues/Documentation", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "date": date,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/AccountingValues/Documentation?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDocumentation(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDocumentation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

@inject(String, HttpClient)
export class InstrumentCategoriesClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("InstrumentCategoriesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async post(companyIdentityId: number, request: InstrumentViewModel[]): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/InstrumentCategories", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/InstrumentCategories";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class InstrumentPriceDocumentsClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("InstrumentPriceDocumentsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async getAll(companyIdentityId: number, instrumentId: number, instrumentPriceId: number): Promise<InstrumentPriceDocument[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/instruments/{instrumentId}/manualprices/{instrumentPriceId}/documents", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "instrumentPriceId": instrumentPriceId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/manualprices/{instrumentPriceId}/documents";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (instrumentPriceId === undefined || instrumentPriceId === null)
            throw new globalThis.Error("The parameter 'instrumentPriceId' must be defined.");
        url_ = url_.replace("{instrumentPriceId}", encodeURIComponent("" + instrumentPriceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetAll(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetAll(response: Response): Promise<InstrumentPriceDocument[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentPriceDocument.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentPriceDocument[]>(null as any);
    }

    async post(companyIdentityId: number, instrumentId: number, instrumentPriceId: number, files: FileParameter[] | null | undefined): Promise<InstrumentPriceDocument[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/instruments/{instrumentId}/manualprices/{instrumentPriceId}/documents", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "instrumentPriceId": instrumentPriceId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/manualprices/{instrumentPriceId}/documents";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (instrumentPriceId === undefined || instrumentPriceId === null)
            throw new globalThis.Error("The parameter 'instrumentPriceId' must be defined.");
        url_ = url_.replace("{instrumentPriceId}", encodeURIComponent("" + instrumentPriceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<InstrumentPriceDocument[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentPriceDocument.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentPriceDocument[]>(null as any);
    }

    async get(companyIdentityId: number, instrumentId: number, instrumentPriceId: number, id: string): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/instruments/{instrumentId}/manualprices/{instrumentPriceId}/documents/{id}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "instrumentPriceId": instrumentPriceId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/manualprices/{instrumentPriceId}/documents/{id}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (instrumentPriceId === undefined || instrumentPriceId === null)
            throw new globalThis.Error("The parameter 'instrumentPriceId' must be defined.");
        url_ = url_.replace("{instrumentPriceId}", encodeURIComponent("" + instrumentPriceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    async delete(companyIdentityId: number, instrumentId: number, instrumentPriceId: number, id: string): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}/instruments/{instrumentId}/manualprices/{instrumentPriceId}/documents/{id}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "instrumentPriceId": instrumentPriceId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/manualprices/{instrumentPriceId}/documents/{id}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (instrumentPriceId === undefined || instrumentPriceId === null)
            throw new globalThis.Error("The parameter 'instrumentPriceId' must be defined.");
        url_ = url_.replace("{instrumentPriceId}", encodeURIComponent("" + instrumentPriceId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class InstrumentsClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("InstrumentsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async post(companyIdentityId: number, request: Instrument): Promise<Instrument> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Instruments", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Instruments";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<Instrument> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Instrument.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Instrument>(null as any);
    }

    async getPortfolioEntry(companyIdentityId: number, id: string, toDate: string): Promise<InstrumentViewModel> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Instruments/{id}/toDate/{toDate}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Instruments/{id}/toDate/{toDate}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetPortfolioEntry(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetPortfolioEntry(response: Response): Promise<InstrumentViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstrumentViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentViewModel>(null as any);
    }

    async saveCategories(companyIdentityId: number, postedData: InstrumentViewModel): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Instruments/SaveCategories", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Instruments/SaveCategories";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postedData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processSaveCategories(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processSaveCategories(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async search(companyIdentityId: number, request: QueryTransactionInstrumentsRequest): Promise<QueryInstrumentsResponseItem[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Instruments/Search", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Instruments/Search";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processSearch(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processSearch(response: Response): Promise<QueryInstrumentsResponseItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QueryInstrumentsResponseItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryInstrumentsResponseItem[]>(null as any);
    }

    async change(companyIdentityId: number, request: ChangeInstrumentRequest): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Instruments/Change", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Instruments/Change";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processChange(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processChange(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async existingUnnoted(companyIdentityId: number): Promise<Instrument[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Instruments/ExistingUnnoted", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Instruments/ExistingUnnoted";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processExistingUnnoted(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processExistingUnnoted(response: Response): Promise<Instrument[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Instrument.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Instrument[]>(null as any);
    }

    async unconverted(companyIdentityId: number): Promise<UnconvertedInstrumentsViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Instruments/Unconverted", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Instruments/Unconverted";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processUnconverted(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processUnconverted(response: Response): Promise<UnconvertedInstrumentsViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnconvertedInstrumentsViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnconvertedInstrumentsViewModel[]>(null as any);
    }

    async patchComment(companyIdentityId: number, instrumentId: string | undefined, comment: string | undefined): Promise<void> {
        const span = this.tracer.startSpan("PATCH /companies/{companyIdentityId}/Instruments/PatchComment", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "comment": comment,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Instruments/PatchComment?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' cannot be null.");
        else if (instrumentId !== undefined)
            url_ += "instrumentId=" + encodeURIComponent("" + instrumentId) + "&";
        if (comment === null)
            throw new globalThis.Error("The parameter 'comment' cannot be null.");
        else if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatchComment(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatchComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async withTaxValues(companyIdentityId: number, toDate: string | undefined): Promise<InstrumentWithTaxValuesViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Instruments/WithTaxValues", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Instruments/WithTaxValues?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processWithTaxValues(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processWithTaxValues(response: Response): Promise<InstrumentWithTaxValuesViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentWithTaxValuesViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentWithTaxValuesViewModel[]>(null as any);
    }

    /**
     * Force-clears a stuck (non-finalised) batch for an instrument so new batches can be started again.
    Use only for confirmed-stuck batches: if a voucher is still in flight this abandons the saga's tracking.
    Returns the number of rows cleared (0 = nothing was stuck).
     */
    async clearStuckProcessingBatch(companyIdentityId: number, id: string): Promise<number> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Instruments/{id}/ClearStuckProcessingBatch", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Instruments/{id}/ClearStuckProcessingBatch";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processClearStuckProcessingBatch(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processClearStuckProcessingBatch(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

@inject(String, HttpClient)
export class InstrumentTaxValueDocumentsClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("InstrumentTaxValueDocumentsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async getAll(companyIdentityId: number, instrumentId: number, instrumentTaxValueStateId: string): Promise<InstrumentTaxValueStateDocument[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/instruments/{instrumentId}/taxValues/{instrumentTaxValueStateId}/documents", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "instrumentTaxValueStateId": instrumentTaxValueStateId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/taxValues/{instrumentTaxValueStateId}/documents";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (instrumentTaxValueStateId === undefined || instrumentTaxValueStateId === null)
            throw new globalThis.Error("The parameter 'instrumentTaxValueStateId' must be defined.");
        url_ = url_.replace("{instrumentTaxValueStateId}", encodeURIComponent("" + instrumentTaxValueStateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetAll(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetAll(response: Response): Promise<InstrumentTaxValueStateDocument[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentTaxValueStateDocument.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentTaxValueStateDocument[]>(null as any);
    }

    async post(companyIdentityId: number, instrumentId: number, instrumentTaxValueStateId: string, files: FileParameter[] | null | undefined): Promise<InstrumentTaxValueStateDocument[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/instruments/{instrumentId}/taxValues/{instrumentTaxValueStateId}/documents", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "instrumentTaxValueStateId": instrumentTaxValueStateId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/taxValues/{instrumentTaxValueStateId}/documents";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (instrumentTaxValueStateId === undefined || instrumentTaxValueStateId === null)
            throw new globalThis.Error("The parameter 'instrumentTaxValueStateId' must be defined.");
        url_ = url_.replace("{instrumentTaxValueStateId}", encodeURIComponent("" + instrumentTaxValueStateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<InstrumentTaxValueStateDocument[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentTaxValueStateDocument.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentTaxValueStateDocument[]>(null as any);
    }

    async get(companyIdentityId: number, instrumentId: number, instrumentTaxValueStateId: string, id: string): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/instruments/{instrumentId}/taxValues/{instrumentTaxValueStateId}/documents/{id}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "instrumentTaxValueStateId": instrumentTaxValueStateId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/taxValues/{instrumentTaxValueStateId}/documents/{id}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (instrumentTaxValueStateId === undefined || instrumentTaxValueStateId === null)
            throw new globalThis.Error("The parameter 'instrumentTaxValueStateId' must be defined.");
        url_ = url_.replace("{instrumentTaxValueStateId}", encodeURIComponent("" + instrumentTaxValueStateId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    async delete(companyIdentityId: number, instrumentId: number, instrumentTaxValueStateId: string, id: string): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}/instruments/{instrumentId}/taxValues/{instrumentTaxValueStateId}/documents/{id}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "instrumentTaxValueStateId": instrumentTaxValueStateId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/taxValues/{instrumentTaxValueStateId}/documents/{id}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (instrumentTaxValueStateId === undefined || instrumentTaxValueStateId === null)
            throw new globalThis.Error("The parameter 'instrumentTaxValueStateId' must be defined.");
        url_ = url_.replace("{instrumentTaxValueStateId}", encodeURIComponent("" + instrumentTaxValueStateId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class InstrumentTaxValuesClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("InstrumentTaxValuesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async get(companyIdentityId: number, instrumentId: string): Promise<InstrumentTaxValueStateViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/instruments/{instrumentId}/taxValues", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/taxValues";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<InstrumentTaxValueStateViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentTaxValueStateViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentTaxValueStateViewModel[]>(null as any);
    }

    async post(companyIdentityId: number, instrumentId: string, fromDate: string | null | undefined, taxValue: number | null | undefined, comment: string | null | undefined): Promise<string> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/instruments/{instrumentId}/taxValues", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "fromDate": fromDate,
                "taxValue": taxValue,
                "comment": comment,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/taxValues?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (taxValue !== undefined && taxValue !== null)
            url_ += "taxValue=" + encodeURIComponent("" + taxValue) + "&";
        if (comment !== undefined && comment !== null)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    async patch(companyIdentityId: number, instrumentId: string, model: UpdateInstrumentTaxValue): Promise<void> {
        const span = this.tracer.startSpan("PATCH /companies/{companyIdentityId}/instruments/{instrumentId}/taxValues", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/taxValues";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatch(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatch(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async delete(companyIdentityId: number, instrumentId: string, id: string | undefined): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}/instruments/{instrumentId}/taxValues", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/taxValues?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async sync(companyIdentityId: number, instrumentId: string, model: SyncInstrumentTaxValue): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/instruments/{instrumentId}/taxValues/sync", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/taxValues/sync";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processSync(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processSync(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async documentation(companyIdentityId: number, date: string | undefined): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/taxValues/Documentation", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "date": date,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/taxValues/Documentation?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDocumentation(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDocumentation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

@inject(String, HttpClient)
export class InstrumentTypesClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("InstrumentTypesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async get(): Promise<InstrumentType[]> {
        const span = this.tracer.startSpan("GET /InstrumentTypes", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/InstrumentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<InstrumentType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstrumentType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentType[]>(null as any);
    }
}

@inject(String, HttpClient)
export class IsinTaxableConfigurationsClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("IsinTaxableConfigurationsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async get(): Promise<IsinTaxableConfiguration[]> {
        const span = this.tracer.startSpan("GET /IsinTaxableConfigurations", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/IsinTaxableConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<IsinTaxableConfiguration[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IsinTaxableConfiguration.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IsinTaxableConfiguration[]>(null as any);
    }
}

@inject(String, HttpClient)
export class MandatesClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("MandatesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async get(companyIdentityId: number): Promise<Mandate[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Mandates", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Mandates";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<Mandate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Mandate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Mandate[]>(null as any);
    }

    async post(companyIdentityId: number, mandates: Mandate[]): Promise<Mandate[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Mandates", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Mandates";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mandates);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<Mandate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Mandate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Mandate[]>(null as any);
    }
}

@inject(String, HttpClient)
export class ManualPricesClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("ManualPricesClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async get(companyIdentityId: number, instrumentId: number, agGridPageRequest: AgGridPageRequest): Promise<AgGridResponseOfPriceViewModel> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/instruments/{instrumentId}/ManualPrices/Get", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/ManualPrices/Get";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agGridPageRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<AgGridResponseOfPriceViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgGridResponseOfPriceViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgGridResponseOfPriceViewModel>(null as any);
    }

    async getMinMaxDatesFromDate(companyIdentityId: number, instrumentId: number, postedData: ManualValueMinMaxDateViewModel): Promise<ManualValueMinMaxDateViewModel> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/instruments/{instrumentId}/ManualPrices/GetMinMaxDatesFromDate", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/ManualPrices/GetMinMaxDatesFromDate";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postedData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetMinMaxDatesFromDate(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetMinMaxDatesFromDate(response: Response): Promise<ManualValueMinMaxDateViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManualValueMinMaxDateViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ManualValueMinMaxDateViewModel>(null as any);
    }

    async addUnder(companyIdentityId: number, instrumentId: number, postedData: PriceViewModel): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/instruments/{instrumentId}/ManualPrices/AddUnder", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/ManualPrices/AddUnder";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postedData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processAddUnder(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processAddUnder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async addOver(companyIdentityId: number, instrumentId: number, postedData: PriceViewModel): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/instruments/{instrumentId}/ManualPrices/AddOver", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/ManualPrices/AddOver";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postedData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processAddOver(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processAddOver(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async patch(companyIdentityId: number, instrumentId: number, postedData: PriceViewModel): Promise<void> {
        const span = this.tracer.startSpan("PATCH /companies/{companyIdentityId}/instruments/{instrumentId}/ManualPrices", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/ManualPrices";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postedData);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPatch(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPatch(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async delete(companyIdentityId: number, instrumentId: number, id: number): Promise<void> {
        const span = this.tracer.startSpan("DELETE /companies/{companyIdentityId}/instruments/{instrumentId}/ManualPrices/{id}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/ManualPrices/{id}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDelete(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async bulk(companyIdentityId: number, postedData: PriceViewModel[]): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/ManualPrices/Bulk", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ManualPrices/Bulk";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postedData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processBulk(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processBulk(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async documentation(companyIdentityId: number, date: string | undefined): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/ManualPrices/Documentation", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "date": date,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ManualPrices/Documentation?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDocumentation(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDocumentation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

@inject(String, HttpClient)
export class OverviewClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("OverviewClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async instruments(companyIdentityId: number, requestFromAgGrid: OverViewRequestViewModel): Promise<InstrumentsViewModelOfInstrumentViewModel> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Overview/Instruments", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Overview/Instruments";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestFromAgGrid);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processInstruments(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processInstruments(response: Response): Promise<InstrumentsViewModelOfInstrumentViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InstrumentsViewModelOfInstrumentViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentsViewModelOfInstrumentViewModel>(null as any);
    }

    /**
     * Returns the latest instrument accounts for a given company identity ID and date.
     * @param companyIdentityId Company identifier
     * @param toDate (optional) To date
     */
    async latestInstrumentAccounts(companyIdentityId: number, toDate: string | undefined): Promise<LatestInstrumentAccountResponseLine[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Overview/LatestInstrumentAccounts", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Overview/LatestInstrumentAccounts?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processLatestInstrumentAccounts(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processLatestInstrumentAccounts(response: Response): Promise<LatestInstrumentAccountResponseLine[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LatestInstrumentAccountResponseLine.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LatestInstrumentAccountResponseLine[]>(null as any);
    }
}

@inject(String, HttpClient)
export class ReconcileClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("ReconcileClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    /**
     * Returns the state of the missing GL transactions generation job for a given company
     * @param companyIdentityId Company identifier
     * @return Job state information
     */
    async missingGlTransactionsJobState(companyIdentityId: number): Promise<JobStateResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Reconcile/MissingGlTransactionsJobState", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Reconcile/MissingGlTransactionsJobState";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processMissingGlTransactionsJobState(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processMissingGlTransactionsJobState(response: Response): Promise<JobStateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobStateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobStateResponse>(null as any);
    }

    /**
     * Starts a job to generate missing GL transactions for a given company
     * @param companyIdentityId Company identifier
     * @return The job identifier
     */
    async generateMissingGlTransactions(companyIdentityId: number): Promise<string> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Reconcile/GenerateMissingGlTransactions", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Reconcile/GenerateMissingGlTransactions";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGenerateMissingGlTransactions(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGenerateMissingGlTransactions(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Cancels the job to generate missing GL transactions for a given company
     * @param companyIdentityId Company identifier
     */
    async cancelGeneratingMissingGlTransactions(companyIdentityId: number): Promise<string> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Reconcile/CancelGeneratingMissingGlTransactions", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Reconcile/CancelGeneratingMissingGlTransactions";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCancelGeneratingMissingGlTransactions(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCancelGeneratingMissingGlTransactions(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Aggregates Insight transactions for the given company and returns account balances for toDate.
     * @param companyIdentityId Company identifier
     * @param fromDate (optional) The date to calculate incoming balances for
     * @param toDate (optional) The date to calculate end balances for
     * @return Insight accounts summary
     */
    async summary(companyIdentityId: number, fromDate: string | undefined, toDate: string | undefined): Promise<InsightReconcileSummaryResponse[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Reconcile/Summary", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "fromDate": fromDate,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Reconcile/Summary?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processSummary(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processSummary(response: Response): Promise<InsightReconcileSummaryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InsightReconcileSummaryResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsightReconcileSummaryResponse[]>(null as any);
    }
}

@inject(String, HttpClient)
export class TaxValuesImportsClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("TaxValuesImportsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    /**
     * Get list of tax value files
     */
    async get(): Promise<TaxValuesImport[]> {
        const span = this.tracer.startSpan("GET /TaxValuesImports", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/TaxValuesImports";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<TaxValuesImport[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxValuesImport.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxValuesImport[]>(null as any);
    }

    /**
     * Upload New Tax Values File
     * @param date (optional) 
     * @param file (optional) 
     */
    async post(date: string | undefined, file: FileParameter | null | undefined): Promise<void> {
        const span = this.tracer.startSpan("POST /TaxValuesImports", {
            attributes: {
                "date": date,
            }
        }, context.active());

        let url_ = this.baseUrl + "/TaxValuesImports?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async customerPost(companyIdentityId: number, date: string | undefined, file: FileParameter | null | undefined): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/TaxValuesImports", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "date": date,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/TaxValuesImports?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCustomerPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCustomerPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

@inject(String, HttpClient)
export class ToolsClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("ToolsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async resyncVoucher(companyIdentityId: number, voucherId: string): Promise<FileResponse> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Tools/resync/{voucherId}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "voucherId": voucherId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Tools/resync/{voucherId}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (voucherId === undefined || voucherId === null)
            throw new globalThis.Error("The parameter 'voucherId' must be defined.");
        url_ = url_.replace("{voucherId}", encodeURIComponent("" + voucherId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processResyncVoucher(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processResyncVoucher(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Replay an instrument merge to the Reporting Service.
    Syncs the target instrument (AvailableInstrument + Instrument) via request-response first,
    then publishes the merge event.
     * @param sourceInstrumentUuid (optional) 
     * @param targetInstrumentUuid (optional) 
     */
    async replayMerge(companyIdentityId: number, sourceInstrumentUuid: string | undefined, targetInstrumentUuid: string | undefined): Promise<FileResponse> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Tools/replay-merge", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "sourceInstrumentUuid": sourceInstrumentUuid,
                "targetInstrumentUuid": targetInstrumentUuid,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Tools/replay-merge?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (sourceInstrumentUuid === null)
            throw new globalThis.Error("The parameter 'sourceInstrumentUuid' cannot be null.");
        else if (sourceInstrumentUuid !== undefined)
            url_ += "sourceInstrumentUuid=" + encodeURIComponent("" + sourceInstrumentUuid) + "&";
        if (targetInstrumentUuid === null)
            throw new globalThis.Error("The parameter 'targetInstrumentUuid' cannot be null.");
        else if (targetInstrumentUuid !== undefined)
            url_ += "targetInstrumentUuid=" + encodeURIComponent("" + targetInstrumentUuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processReplayMerge(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processReplayMerge(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

@inject(String, HttpClient)
export class TransactionsClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("TransactionsClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async grouped(companyIdentityId: number, instrumentId: number | null | undefined, showRetracted: boolean | undefined, documentId: string | null | undefined, voucherId: string | null | undefined, fromDate: string | null | undefined, toDate: string | null | undefined, portfolio: string | null | undefined): Promise<GroupedTransactionsViewModel[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Transactions/Grouped", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "documentId": documentId,
                "voucherId": voucherId,
                "fromDate": fromDate,
                "toDate": toDate,
                "portfolio": portfolio,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Transactions/Grouped?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId !== undefined && instrumentId !== null)
            url_ += "instrumentId=" + encodeURIComponent("" + instrumentId) + "&";
        if (showRetracted === null)
            throw new globalThis.Error("The parameter 'showRetracted' cannot be null.");
        else if (showRetracted !== undefined)
            url_ += "showRetracted=" + encodeURIComponent("" + showRetracted) + "&";
        if (documentId !== undefined && documentId !== null)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (voucherId !== undefined && voucherId !== null)
            url_ += "voucherId=" + encodeURIComponent("" + voucherId) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (portfolio !== undefined && portfolio !== null)
            url_ += "portfolio=" + encodeURIComponent("" + portfolio) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGrouped(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGrouped(response: Response): Promise<GroupedTransactionsViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupedTransactionsViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupedTransactionsViewModel[]>(null as any);
    }

    async detailed(companyIdentityId: number, instrumentId: number | null | undefined, showRetracted: boolean | undefined, portfolio: string | null | undefined): Promise<TransactionViewmodel[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Transactions/Detailed", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "portfolio": portfolio,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Transactions/Detailed?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId !== undefined && instrumentId !== null)
            url_ += "instrumentId=" + encodeURIComponent("" + instrumentId) + "&";
        if (showRetracted === null)
            throw new globalThis.Error("The parameter 'showRetracted' cannot be null.");
        else if (showRetracted !== undefined)
            url_ += "showRetracted=" + encodeURIComponent("" + showRetracted) + "&";
        if (portfolio !== undefined && portfolio !== null)
            url_ += "portfolio=" + encodeURIComponent("" + portfolio) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDetailed(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDetailed(response: Response): Promise<TransactionViewmodel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionViewmodel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionViewmodel[]>(null as any);
    }

    async byVoucher(companyIdentityId: number, voucherId: string | undefined, showRetracted: boolean | undefined): Promise<TransactionViewmodel[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Transactions/ByVoucher", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "voucherId": voucherId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Transactions/ByVoucher?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (voucherId === null)
            throw new globalThis.Error("The parameter 'voucherId' cannot be null.");
        else if (voucherId !== undefined)
            url_ += "voucherId=" + encodeURIComponent("" + voucherId) + "&";
        if (showRetracted === null)
            throw new globalThis.Error("The parameter 'showRetracted' cannot be null.");
        else if (showRetracted !== undefined)
            url_ += "showRetracted=" + encodeURIComponent("" + showRetracted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processByVoucher(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processByVoucher(response: Response): Promise<TransactionViewmodel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionViewmodel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionViewmodel[]>(null as any);
    }

    async getCurrentHoldings(companyIdentityId: number, instrumentId: string, toDate: string, portfolioId: number | null | undefined): Promise<number> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/instruments/{instrumentId}/CurrentHoldings/{toDate}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "toDate": toDate,
                "portfolioId": portfolioId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/CurrentHoldings/{toDate}?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        if (portfolioId !== undefined && portfolioId !== null)
            url_ += "portfolioId=" + encodeURIComponent("" + portfolioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetCurrentHoldings(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetCurrentHoldings(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    async getCurrentCostprice(companyIdentityId: number, instrumentId: string, toDate: string): Promise<number> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/instruments/{instrumentId}/CurrentCostprice/{toDate}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "toDate": toDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/instruments/{instrumentId}/CurrentCostprice/{toDate}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent("" + toDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetCurrentCostprice(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetCurrentCostprice(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * This only exists to export the return type to swagger.
     * @return ActionType
     */
    async actionTypeExporter(companyIdentityId: string): Promise<ActionType> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/ActionTypeExporter", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/ActionTypeExporter";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processActionTypeExporter(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processActionTypeExporter(response: Response): Promise<ActionType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActionType>(null as any);
    }

    async assignUnattributedToDefaultPortfolio(companyIdentityId: number): Promise<number> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/AssignUnattributedToDefaultPortfolio", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/AssignUnattributedToDefaultPortfolio";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processAssignUnattributedToDefaultPortfolio(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processAssignUnattributedToDefaultPortfolio(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    async canSwitchOffPortfolio(companyIdentityId: number): Promise<boolean> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/CanSwitchOffPortfolio", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CanSwitchOffPortfolio";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCanSwitchOffPortfolio(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCanSwitchOffPortfolio(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    async canChangeUseAverageCostPrice(companyIdentityId: number): Promise<boolean> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/CanChangeUseAverageCostPrice", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/CanChangeUseAverageCostPrice";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCanChangeUseAverageCostPrice(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCanChangeUseAverageCostPrice(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    async isNewInstrumentTypeValid(companyIdentityId: number, instrumentId: string | undefined, instrumentTypeId: number | undefined): Promise<boolean> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/IsNewInstrumentTypeValid", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "instrumentTypeId": instrumentTypeId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/IsNewInstrumentTypeValid?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' cannot be null.");
        else if (instrumentId !== undefined)
            url_ += "instrumentId=" + encodeURIComponent("" + instrumentId) + "&";
        if (instrumentTypeId === null)
            throw new globalThis.Error("The parameter 'instrumentTypeId' cannot be null.");
        else if (instrumentTypeId !== undefined)
            url_ += "instrumentTypeId=" + encodeURIComponent("" + instrumentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processIsNewInstrumentTypeValid(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processIsNewInstrumentTypeValid(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    async getVoucherGlAccountDefaults(companyIdentityId: number, instrumentTypeId: InstrumentTypeEnum | null | undefined, instrumentId: number | null | undefined, longTerm: boolean | undefined, lowerOfCostOrMarket: boolean | undefined, taxable: boolean | undefined, portfolioId: number | null | undefined): Promise<CustomerGlAccountViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/GetVoucherGlAccountDefaults", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "instrumentId": instrumentId,
                "portfolioId": portfolioId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/GetVoucherGlAccountDefaults?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (instrumentTypeId !== undefined && instrumentTypeId !== null)
            url_ += "instrumentTypeId=" + encodeURIComponent("" + instrumentTypeId) + "&";
        if (instrumentId !== undefined && instrumentId !== null)
            url_ += "instrumentId=" + encodeURIComponent("" + instrumentId) + "&";
        if (longTerm === null)
            throw new globalThis.Error("The parameter 'longTerm' cannot be null.");
        else if (longTerm !== undefined)
            url_ += "longTerm=" + encodeURIComponent("" + longTerm) + "&";
        if (lowerOfCostOrMarket === null)
            throw new globalThis.Error("The parameter 'lowerOfCostOrMarket' cannot be null.");
        else if (lowerOfCostOrMarket !== undefined)
            url_ += "lowerOfCostOrMarket=" + encodeURIComponent("" + lowerOfCostOrMarket) + "&";
        if (taxable === null)
            throw new globalThis.Error("The parameter 'taxable' cannot be null.");
        else if (taxable !== undefined)
            url_ += "taxable=" + encodeURIComponent("" + taxable) + "&";
        if (portfolioId !== undefined && portfolioId !== null)
            url_ += "portfolioId=" + encodeURIComponent("" + portfolioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetVoucherGlAccountDefaults(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetVoucherGlAccountDefaults(response: Response): Promise<CustomerGlAccountViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerGlAccountViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerGlAccountViewModel[]>(null as any);
    }

    async transactionCount(startDate: string | undefined, endDate: string | undefined): Promise<TransactionCountViewModel[]> {
        const span = this.tracer.startSpan("GET /Transactions/TransactionCount", {
            attributes: {
                "startDate": startDate,
                "endDate": endDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/Transactions/TransactionCount?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processTransactionCount(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processTransactionCount(response: Response): Promise<TransactionCountViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionCountViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionCountViewModel[]>(null as any);
    }

    async transactionCountPerInstrument(companyIdentityId: number): Promise<TransactionCountViewModel[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Transactions/TransactionCountPerInstrument", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Transactions/TransactionCountPerInstrument";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processTransactionCountPerInstrument(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processTransactionCountPerInstrument(response: Response): Promise<TransactionCountViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionCountViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionCountViewModel[]>(null as any);
    }

    async allTransactionCount(): Promise<TransactionCountViewModel> {
        const span = this.tracer.startSpan("GET /Transactions/AllTransactionCount", {
            attributes: {
            }
        }, context.active());

        let url_ = this.baseUrl + "/Transactions/AllTransactionCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processAllTransactionCount(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processAllTransactionCount(response: Response): Promise<TransactionCountViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionCountViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionCountViewModel>(null as any);
    }

    /**
     * Returns if there are missing GL transactions for a given company
     * @param companyIdentityId Company identifier
     * @return True if there are missing GL transaction
     */
    async missingGlTransactions(companyIdentityId: number): Promise<boolean> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Transactions/MissingGlTransactions", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Transactions/MissingGlTransactions";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processMissingGlTransactions(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processMissingGlTransactions(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    async doesCurrencyMatchCustomerGlAccounts(companyIdentityId: number, request: DoesCurrencyMatchCustomerGlAccountsRequest): Promise<boolean> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Transactions/DoesCurrencyMatchCustomerGlAccounts", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Transactions/DoesCurrencyMatchCustomerGlAccounts";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDoesCurrencyMatchCustomerGlAccounts(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDoesCurrencyMatchCustomerGlAccounts(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

@inject(String, HttpClient)
export class VouchersClient extends TransactionClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;
    private tracer = trace.getTracer("VouchersClient");

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("http://localhost:5110", baseUrl);
    }

    async getUnprocessedVoucherListByDocumentId(companyIdentityId: number, request: GetVouchersAgGridPageRequest): Promise<UpvAgGridResponse> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/GetUnprocessedVoucherListByDocumentId", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/GetUnprocessedVoucherListByDocumentId";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetUnprocessedVoucherListByDocumentId(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetUnprocessedVoucherListByDocumentId(response: Response): Promise<UpvAgGridResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpvAgGridResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpvAgGridResponse>(null as any);
    }

    async getVoucherByDocumentId(companyIdentityId: number, documentId: string): Promise<GetVoucherInputResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Vouchers/GetVoucherByDocumentId/{documentId}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "documentId": documentId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/GetVoucherByDocumentId/{documentId}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGetVoucherByDocumentId(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGetVoucherByDocumentId(response: Response): Promise<GetVoucherInputResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVoucherInputResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetVoucherInputResponse>(null as any);
    }

    async get(companyIdentityId: number, voucherId: string): Promise<GetVoucherInputResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Vouchers/{voucherId}", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "voucherId": voucherId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/{voucherId}";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (voucherId === undefined || voucherId === null)
            throw new globalThis.Error("The parameter 'voucherId' must be defined.");
        url_ = url_.replace("{voucherId}", encodeURIComponent("" + voucherId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGet(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGet(response: Response): Promise<GetVoucherInputResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVoucherInputResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetVoucherInputResponse>(null as any);
    }

    async grouped(companyIdentityId: number, documentIds: string[] | undefined): Promise<VoucherGroup[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/Grouped", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/Grouped";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processGrouped(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processGrouped(response: Response): Promise<VoucherGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VoucherGroup.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoucherGroup[]>(null as any);
    }

    async retract(companyIdentityId: number, id: string, retractPostingOverrideDate: string | null | undefined): Promise<BatchProcessingCompleteEvent> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/{id}/Retract", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
                "retractPostingOverrideDate": retractPostingOverrideDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/{id}/Retract?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (retractPostingOverrideDate !== undefined && retractPostingOverrideDate !== null)
            url_ += "retractPostingOverrideDate=" + encodeURIComponent("" + retractPostingOverrideDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processRetract(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processRetract(response: Response): Promise<BatchProcessingCompleteEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchProcessingCompleteEvent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BatchProcessingCompleteEvent>(null as any);
    }

    async postSimilar(companyIdentityId: number, request: PostSimilarRequest): Promise<number> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/PostSimilar", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/PostSimilar";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPostSimilar(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPostSimilar(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    async postMultiple(companyIdentityId: number, request: VoucherContractBase[]): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/PostMultiple", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/PostMultiple";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPostMultiple(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPostMultiple(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async post(companyIdentityId: number, request: VoucherContractBase): Promise<VoucherState> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processPost(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processPost(response: Response): Promise<VoucherState> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherState.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoucherState>(null as any);
    }

    async process(companyIdentityId: number, id: string, postGl: boolean | undefined): Promise<VoucherState> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/{id}/Process", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/{id}/Process?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (postGl === null)
            throw new globalThis.Error("The parameter 'postGl' cannot be null.");
        else if (postGl !== undefined)
            url_ += "postGl=" + encodeURIComponent("" + postGl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processProcess(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processProcess(response: Response): Promise<VoucherState> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherState.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoucherState>(null as any);
    }

    async batchProcess(companyIdentityId: number, voucherIds: string[]): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/BatchProcess", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/BatchProcess";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(voucherIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processBatchProcess(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processBatchProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async batchProcessAll(companyIdentityId: number): Promise<string[]> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/BatchProcessAll", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/BatchProcessAll";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processBatchProcessAll(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processBatchProcessAll(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    async batchRetract(companyIdentityId: number, retractPostingOverrideDate: string | null | undefined, voucherIds: string[]): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/BatchRetract", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "retractPostingOverrideDate": retractPostingOverrideDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/BatchRetract?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (retractPostingOverrideDate !== undefined && retractPostingOverrideDate !== null)
            url_ += "retractPostingOverrideDate=" + encodeURIComponent("" + retractPostingOverrideDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(voucherIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processBatchRetract(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processBatchRetract(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async batchProcessSimilar(companyIdentityId: number, request: PostSimilarRequest): Promise<number> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/BatchProcessSimilar", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/BatchProcessSimilar";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processBatchProcessSimilar(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processBatchProcessSimilar(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    async createGl(companyIdentityId: number, id: string, sendToGl: boolean | undefined): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/{id}/CreateGl", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/{id}/CreateGl?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (sendToGl === null)
            throw new globalThis.Error("The parameter 'sendToGl' cannot be null.");
        else if (sendToGl !== undefined)
            url_ += "sendToGl=" + encodeURIComponent("" + sendToGl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processCreateGl(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processCreateGl(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async sendGl(companyIdentityId: number, id: string, retractPostingOverrideDate: string | null | undefined): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/{id}/SendGl", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
                "retractPostingOverrideDate": retractPostingOverrideDate,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/{id}/SendGl?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (retractPostingOverrideDate !== undefined && retractPostingOverrideDate !== null)
            url_ += "retractPostingOverrideDate=" + encodeURIComponent("" + retractPostingOverrideDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processSendGl(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processSendGl(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Runs the GL posting confirmation job now for the given vouchers instead of waiting for its next scheduled run.
    Returns the job id.
     */
    async confirmGlPosting(companyIdentityId: number, voucherIds: string[]): Promise<string> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/ConfirmGlPosting", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/ConfirmGlPosting";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(voucherIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processConfirmGlPosting(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processConfirmGlPosting(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    async sendGlBatch(companyIdentityId: number, request: SendGlBatchRequest): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/SendGlBatch", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/SendGlBatch";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processSendGlBatch(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processSendGlBatch(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async lastNonRepaymentOrCapitalIncreaseQuantity(companyIdentityId: number, id: string): Promise<number | null> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Vouchers/{id}/LastNonRepaymentOrCapitalIncreaseQuantity", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/{id}/LastNonRepaymentOrCapitalIncreaseQuantity";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processLastNonRepaymentOrCapitalIncreaseQuantity(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processLastNonRepaymentOrCapitalIncreaseQuantity(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    async document(companyIdentityId: number, id: string): Promise<FileResponse> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Vouchers/{id}/Document", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/{id}/Document";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processDocument(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processDocument(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Returns the history of a voucher and retraced vouchers preceeding it
     * @param companyIdentityId Company identifier
     * @param id Voucher ID
     */
    async history(companyIdentityId: number, id: string): Promise<VoucherStateHistory[]> {
        const span = this.tracer.startSpan("GET /companies/{companyIdentityId}/Vouchers/{id}/History", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/{id}/History";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processHistory(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processHistory(response: Response): Promise<VoucherStateHistory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VoucherStateHistory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoucherStateHistory[]>(null as any);
    }

    async changeBankAccount(companyIdentityId: number, id: string, bankAccountId: number | null | undefined): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/{id}/ChangeBankAccount", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
                "bankAccountId": bankAccountId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/{id}/ChangeBankAccount?";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (bankAccountId !== undefined && bankAccountId !== null)
            url_ += "bankAccountId=" + encodeURIComponent("" + bankAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processChangeBankAccount(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processChangeBankAccount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async archive(companyIdentityId: number, id: string): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/{id}/Archive", {
            attributes: {
                "companyIdentityId": companyIdentityId,
                "id": id,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/{id}/Archive";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processArchive(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processArchive(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    async retryUploadingDocuments(companyIdentityId: number): Promise<void> {
        const span = this.tracer.startSpan("POST /companies/{companyIdentityId}/Vouchers/RetryUploadingDocuments", {
            attributes: {
                "companyIdentityId": companyIdentityId,
            }
        }, context.active());

        let url_ = this.baseUrl + "/companies/{companyIdentityId}/Vouchers/RetryUploadingDocuments";
        if (companyIdentityId === undefined || companyIdentityId === null)
            throw new globalThis.Error("The parameter 'companyIdentityId' must be defined.");
        url_ = url_.replace("{companyIdentityId}", encodeURIComponent("" + companyIdentityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "traceparent": getTraceParent(span)
            }
        };

        try {
          const response = await this.http.fetch(url_, options_);
          const result = await this.transformResult(url_, response, (_response: Response) => this.processRetryUploadingDocuments(_response));
          return result;
        } finally {
            span.end();
        }
    }

    protected processRetryUploadingDocuments(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CategoryViewModel implements ICategoryViewModel {
    externalId?: string | undefined;
    vismaExternalId?: string | undefined;
    id?: number | undefined;
    name?: string | undefined;
    customer?: CustomerViewModel | undefined;
    securitiesCategoryType?: CategoryTypeViewModel | undefined;
    isEditable?: boolean;
    isLocked?: boolean;
    tooltip?: string | undefined;

    constructor(data?: ICategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["ExternalId"];
            this.vismaExternalId = _data["VismaExternalId"];
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.customer = _data["Customer"] ? CustomerViewModel.fromJS(_data["Customer"]) : undefined as any;
            this.securitiesCategoryType = _data["SecuritiesCategoryType"] ? CategoryTypeViewModel.fromJS(_data["SecuritiesCategoryType"]) : undefined as any;
            this.isEditable = _data["IsEditable"];
            this.isLocked = _data["IsLocked"];
            this.tooltip = _data["Tooltip"];
        }
    }

    static fromJS(data: any): CategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExternalId"] = this.externalId;
        data["VismaExternalId"] = this.vismaExternalId;
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["SecuritiesCategoryType"] = this.securitiesCategoryType ? this.securitiesCategoryType.toJSON() : undefined as any;
        data["IsEditable"] = this.isEditable;
        data["IsLocked"] = this.isLocked;
        data["Tooltip"] = this.tooltip;
        return data;
    }
}

export interface ICategoryViewModel {
    externalId?: string | undefined;
    vismaExternalId?: string | undefined;
    id?: number | undefined;
    name?: string | undefined;
    customer?: CustomerViewModel | undefined;
    securitiesCategoryType?: CategoryTypeViewModel | undefined;
    isEditable?: boolean;
    isLocked?: boolean;
    tooltip?: string | undefined;
}

export class CustomerViewModel implements ICustomerViewModel {
    uuid?: string;
    companyId?: number;
    externalGlSystem?: string | undefined;
    sortBy?: string | undefined;
    parentId?: number | undefined;
    numberOfStocks?: number | undefined;
    numberOfStocksChangeReason?: string | undefined;
    parentCompany?: ParentCompanyViewModel | undefined;
    name?: string | undefined;
    externalId?: string | undefined;
    clientKey?: string | undefined;
    startupDate?: string | undefined;
    closePeriodDate?: string | undefined;
    changed?: string | undefined;
    changedBy?: string | undefined;
    inactive?: boolean | undefined;
    voucherReceivingEmail?: string | undefined;
    vatNumber?: string | undefined;
    customerSettings?: CustomerSettingsViewModel | undefined;
    nrofActiveCategories?: number;
    identityId?: number | undefined;
    defaultChartTheme?: string | undefined;
    defaultPhoneDashboard?: string | undefined;
    defaultTabletDashboard?: string | undefined;
    defaultDesktopDashboard?: string | undefined;
    useAverageCostPrice?: boolean | undefined;
    usePortfolio?: boolean;
    defaultPortfolioCategoryId?: number | undefined;
    legacyGlAccountsCutoffDate?: string;

    constructor(data?: ICustomerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uuid = _data["Uuid"];
            this.companyId = _data["CompanyId"];
            this.externalGlSystem = _data["ExternalGlSystem"];
            this.sortBy = _data["SortBy"];
            this.parentId = _data["ParentId"];
            this.numberOfStocks = _data["NumberOfStocks"];
            this.numberOfStocksChangeReason = _data["NumberOfStocksChangeReason"];
            this.parentCompany = _data["ParentCompany"] ? ParentCompanyViewModel.fromJS(_data["ParentCompany"]) : undefined as any;
            this.name = _data["Name"];
            this.externalId = _data["ExternalId"];
            this.clientKey = _data["ClientKey"];
            this.startupDate = _data["StartupDate"];
            this.closePeriodDate = _data["ClosePeriodDate"];
            this.changed = _data["Changed"];
            this.changedBy = _data["ChangedBy"];
            this.inactive = _data["Inactive"];
            this.voucherReceivingEmail = _data["VoucherReceivingEmail"];
            this.vatNumber = _data["VatNumber"];
            this.customerSettings = _data["CustomerSettings"] ? CustomerSettingsViewModel.fromJS(_data["CustomerSettings"]) : undefined as any;
            this.nrofActiveCategories = _data["NrofActiveCategories"];
            this.identityId = _data["IdentityId"];
            this.defaultChartTheme = _data["DefaultChartTheme"];
            this.defaultPhoneDashboard = _data["DefaultPhoneDashboard"];
            this.defaultTabletDashboard = _data["DefaultTabletDashboard"];
            this.defaultDesktopDashboard = _data["DefaultDesktopDashboard"];
            this.useAverageCostPrice = _data["UseAverageCostPrice"];
            this.usePortfolio = _data["UsePortfolio"];
            this.defaultPortfolioCategoryId = _data["DefaultPortfolioCategoryId"];
            this.legacyGlAccountsCutoffDate = _data["LegacyGlAccountsCutoffDate"];
        }
    }

    static fromJS(data: any): CustomerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Uuid"] = this.uuid;
        data["CompanyId"] = this.companyId;
        data["ExternalGlSystem"] = this.externalGlSystem;
        data["SortBy"] = this.sortBy;
        data["ParentId"] = this.parentId;
        data["NumberOfStocks"] = this.numberOfStocks;
        data["NumberOfStocksChangeReason"] = this.numberOfStocksChangeReason;
        data["ParentCompany"] = this.parentCompany ? this.parentCompany.toJSON() : undefined as any;
        data["Name"] = this.name;
        data["ExternalId"] = this.externalId;
        data["ClientKey"] = this.clientKey;
        data["StartupDate"] = this.startupDate;
        data["ClosePeriodDate"] = this.closePeriodDate;
        data["Changed"] = this.changed;
        data["ChangedBy"] = this.changedBy;
        data["Inactive"] = this.inactive;
        data["VoucherReceivingEmail"] = this.voucherReceivingEmail;
        data["VatNumber"] = this.vatNumber;
        data["CustomerSettings"] = this.customerSettings ? this.customerSettings.toJSON() : undefined as any;
        data["NrofActiveCategories"] = this.nrofActiveCategories;
        data["IdentityId"] = this.identityId;
        data["DefaultChartTheme"] = this.defaultChartTheme;
        data["DefaultPhoneDashboard"] = this.defaultPhoneDashboard;
        data["DefaultTabletDashboard"] = this.defaultTabletDashboard;
        data["DefaultDesktopDashboard"] = this.defaultDesktopDashboard;
        data["UseAverageCostPrice"] = this.useAverageCostPrice;
        data["UsePortfolio"] = this.usePortfolio;
        data["DefaultPortfolioCategoryId"] = this.defaultPortfolioCategoryId;
        data["LegacyGlAccountsCutoffDate"] = this.legacyGlAccountsCutoffDate;
        return data;
    }
}

export interface ICustomerViewModel {
    uuid?: string;
    companyId?: number;
    externalGlSystem?: string | undefined;
    sortBy?: string | undefined;
    parentId?: number | undefined;
    numberOfStocks?: number | undefined;
    numberOfStocksChangeReason?: string | undefined;
    parentCompany?: ParentCompanyViewModel | undefined;
    name?: string | undefined;
    externalId?: string | undefined;
    clientKey?: string | undefined;
    startupDate?: string | undefined;
    closePeriodDate?: string | undefined;
    changed?: string | undefined;
    changedBy?: string | undefined;
    inactive?: boolean | undefined;
    voucherReceivingEmail?: string | undefined;
    vatNumber?: string | undefined;
    customerSettings?: CustomerSettingsViewModel | undefined;
    nrofActiveCategories?: number;
    identityId?: number | undefined;
    defaultChartTheme?: string | undefined;
    defaultPhoneDashboard?: string | undefined;
    defaultTabletDashboard?: string | undefined;
    defaultDesktopDashboard?: string | undefined;
    useAverageCostPrice?: boolean | undefined;
    usePortfolio?: boolean;
    defaultPortfolioCategoryId?: number | undefined;
    legacyGlAccountsCutoffDate?: string;
}

export class ParentCompanyViewModel implements IParentCompanyViewModel {
    id?: number | undefined;
    name?: string | undefined;

    constructor(data?: IParentCompanyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): ParentCompanyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParentCompanyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }
}

export interface IParentCompanyViewModel {
    id?: number | undefined;
    name?: string | undefined;
}

export class CustomerSettingsViewModel implements ICustomerSettingsViewModel {
    instrumentCategories?: CategoriesSettingsViewModel[];
    transactionCategories?: CategoriesSettingsViewModel[];

    constructor(data?: ICustomerSettingsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["InstrumentCategories"])) {
                this.instrumentCategories = [] as any;
                for (let item of _data["InstrumentCategories"])
                    this.instrumentCategories!.push(CategoriesSettingsViewModel.fromJS(item));
            }
            if (Array.isArray(_data["TransactionCategories"])) {
                this.transactionCategories = [] as any;
                for (let item of _data["TransactionCategories"])
                    this.transactionCategories!.push(CategoriesSettingsViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerSettingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSettingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.instrumentCategories)) {
            data["InstrumentCategories"] = [];
            for (let item of this.instrumentCategories)
                data["InstrumentCategories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.transactionCategories)) {
            data["TransactionCategories"] = [];
            for (let item of this.transactionCategories)
                data["TransactionCategories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomerSettingsViewModel {
    instrumentCategories?: CategoriesSettingsViewModel[];
    transactionCategories?: CategoriesSettingsViewModel[];
}

export class CategoriesSettingsViewModel implements ICategoriesSettingsViewModel {
    catTypeId?: number;
    originalName?: string;
    catTypeName?: string;
    vismaCatTypeName?: string;
    enabled?: boolean;
    isSystem?: boolean;
    isUsed?: boolean;

    constructor(data?: ICategoriesSettingsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catTypeId = _data["CatTypeId"];
            this.originalName = _data["OriginalName"];
            this.catTypeName = _data["CatTypeName"];
            this.vismaCatTypeName = _data["VismaCatTypeName"];
            this.enabled = _data["Enabled"];
            this.isSystem = _data["IsSystem"];
            this.isUsed = _data["IsUsed"];
        }
    }

    static fromJS(data: any): CategoriesSettingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoriesSettingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CatTypeId"] = this.catTypeId;
        data["OriginalName"] = this.originalName;
        data["CatTypeName"] = this.catTypeName;
        data["VismaCatTypeName"] = this.vismaCatTypeName;
        data["Enabled"] = this.enabled;
        data["IsSystem"] = this.isSystem;
        data["IsUsed"] = this.isUsed;
        return data;
    }
}

export interface ICategoriesSettingsViewModel {
    catTypeId?: number;
    originalName?: string;
    catTypeName?: string;
    vismaCatTypeName?: string;
    enabled?: boolean;
    isSystem?: boolean;
    isUsed?: boolean;
}

export class CategoryTypeViewModel implements ICategoryTypeViewModel {
    id?: number | undefined;
    name?: string | undefined;
    isSystem?: boolean;
    isLocked?: boolean;

    constructor(data?: ICategoryTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.isSystem = _data["IsSystem"];
            this.isLocked = _data["IsLocked"];
        }
    }

    static fromJS(data: any): CategoryTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["IsSystem"] = this.isSystem;
        data["IsLocked"] = this.isLocked;
        return data;
    }
}

export interface ICategoryTypeViewModel {
    id?: number | undefined;
    name?: string | undefined;
    isSystem?: boolean;
    isLocked?: boolean;
}

export class Category implements ICategory {
    id?: number;
    name?: string | undefined;
    created?: string;
    changed?: string;
    changedById?: number | undefined;
    companyId?: number | undefined;
    createdById?: number | undefined;
    externalId?: string | undefined;
    vismaExternalId?: string | undefined;
    disabled?: boolean;
    changedBy?: User | undefined;
    customer?: Customer | undefined;
    createdBy?: User | undefined;
    categoryTypeId?: number | undefined;
    categoryType?: CategoryType | undefined;
    categorySecuritiesTransactions?: InstrumentTransactionsCategories[] | undefined;
    instrumentCategories?: InstrumentsCategories[] | undefined;
    instrumentDefaultCategories?: InstrumentsCategories[] | undefined;
    availableInstrumentCategories?: AvailableInstrumentCategory[] | undefined;

    constructor(data?: ICategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.created = _data["Created"];
            this.changed = _data["Changed"];
            this.changedById = _data["ChangedById"];
            this.companyId = _data["CompanyId"];
            this.createdById = _data["CreatedById"];
            this.externalId = _data["ExternalId"];
            this.vismaExternalId = _data["VismaExternalId"];
            this.disabled = _data["Disabled"];
            this.changedBy = _data["ChangedBy"] ? User.fromJS(_data["ChangedBy"]) : undefined as any;
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            this.createdBy = _data["CreatedBy"] ? User.fromJS(_data["CreatedBy"]) : undefined as any;
            this.categoryTypeId = _data["CategoryTypeId"];
            this.categoryType = _data["CategoryType"] ? CategoryType.fromJS(_data["CategoryType"]) : undefined as any;
            if (Array.isArray(_data["CategorySecuritiesTransactions"])) {
                this.categorySecuritiesTransactions = [] as any;
                for (let item of _data["CategorySecuritiesTransactions"])
                    this.categorySecuritiesTransactions!.push(InstrumentTransactionsCategories.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentCategories"])) {
                this.instrumentCategories = [] as any;
                for (let item of _data["InstrumentCategories"])
                    this.instrumentCategories!.push(InstrumentsCategories.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentDefaultCategories"])) {
                this.instrumentDefaultCategories = [] as any;
                for (let item of _data["InstrumentDefaultCategories"])
                    this.instrumentDefaultCategories!.push(InstrumentsCategories.fromJS(item));
            }
            if (Array.isArray(_data["AvailableInstrumentCategories"])) {
                this.availableInstrumentCategories = [] as any;
                for (let item of _data["AvailableInstrumentCategories"])
                    this.availableInstrumentCategories!.push(AvailableInstrumentCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Created"] = this.created;
        data["Changed"] = this.changed;
        data["ChangedById"] = this.changedById;
        data["CompanyId"] = this.companyId;
        data["CreatedById"] = this.createdById;
        data["ExternalId"] = this.externalId;
        data["VismaExternalId"] = this.vismaExternalId;
        data["Disabled"] = this.disabled;
        data["ChangedBy"] = this.changedBy ? this.changedBy.toJSON() : undefined as any;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["CreatedBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["CategoryTypeId"] = this.categoryTypeId;
        data["CategoryType"] = this.categoryType ? this.categoryType.toJSON() : undefined as any;
        if (Array.isArray(this.categorySecuritiesTransactions)) {
            data["CategorySecuritiesTransactions"] = [];
            for (let item of this.categorySecuritiesTransactions)
                data["CategorySecuritiesTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentCategories)) {
            data["InstrumentCategories"] = [];
            for (let item of this.instrumentCategories)
                data["InstrumentCategories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentDefaultCategories)) {
            data["InstrumentDefaultCategories"] = [];
            for (let item of this.instrumentDefaultCategories)
                data["InstrumentDefaultCategories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.availableInstrumentCategories)) {
            data["AvailableInstrumentCategories"] = [];
            for (let item of this.availableInstrumentCategories)
                data["AvailableInstrumentCategories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICategory {
    id?: number;
    name?: string | undefined;
    created?: string;
    changed?: string;
    changedById?: number | undefined;
    companyId?: number | undefined;
    createdById?: number | undefined;
    externalId?: string | undefined;
    vismaExternalId?: string | undefined;
    disabled?: boolean;
    changedBy?: User | undefined;
    customer?: Customer | undefined;
    createdBy?: User | undefined;
    categoryTypeId?: number | undefined;
    categoryType?: CategoryType | undefined;
    categorySecuritiesTransactions?: InstrumentTransactionsCategories[] | undefined;
    instrumentCategories?: InstrumentsCategories[] | undefined;
    instrumentDefaultCategories?: InstrumentsCategories[] | undefined;
    availableInstrumentCategories?: AvailableInstrumentCategory[] | undefined;
}

export class User implements IUser {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    policyId?: number | undefined;
    created?: string;
    acceptedGdprmessage?: string | undefined;
    languageId?: number | undefined;
    categoriesChangedBy?: Category[] | undefined;
    categoriesCreatedBy?: Category[] | undefined;
    companiesPortfolioInitializedBy?: Customer[] | undefined;
    pogotransactions?: LegacyGlTransaction[] | undefined;
    securitiesPrices?: InstrumentPrice[] | undefined;
    securitiesTransactionsChangedBy?: InstrumentTransaction[] | undefined;
    securitiesTransactionsCreatedBy?: InstrumentTransaction[] | undefined;
    userSettings?: UserSetting[] | undefined;
    glTransactionInsightCreatedBy?: GlTransactionInsight[] | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.email = _data["Email"];
            this.policyId = _data["PolicyId"];
            this.created = _data["Created"];
            this.acceptedGdprmessage = _data["AcceptedGdprmessage"];
            this.languageId = _data["LanguageId"];
            if (Array.isArray(_data["CategoriesChangedBy"])) {
                this.categoriesChangedBy = [] as any;
                for (let item of _data["CategoriesChangedBy"])
                    this.categoriesChangedBy!.push(Category.fromJS(item));
            }
            if (Array.isArray(_data["CategoriesCreatedBy"])) {
                this.categoriesCreatedBy = [] as any;
                for (let item of _data["CategoriesCreatedBy"])
                    this.categoriesCreatedBy!.push(Category.fromJS(item));
            }
            if (Array.isArray(_data["CompaniesPortfolioInitializedBy"])) {
                this.companiesPortfolioInitializedBy = [] as any;
                for (let item of _data["CompaniesPortfolioInitializedBy"])
                    this.companiesPortfolioInitializedBy!.push(Customer.fromJS(item));
            }
            if (Array.isArray(_data["Pogotransactions"])) {
                this.pogotransactions = [] as any;
                for (let item of _data["Pogotransactions"])
                    this.pogotransactions!.push(LegacyGlTransaction.fromJS(item));
            }
            if (Array.isArray(_data["SecuritiesPrices"])) {
                this.securitiesPrices = [] as any;
                for (let item of _data["SecuritiesPrices"])
                    this.securitiesPrices!.push(InstrumentPrice.fromJS(item));
            }
            if (Array.isArray(_data["SecuritiesTransactionsChangedBy"])) {
                this.securitiesTransactionsChangedBy = [] as any;
                for (let item of _data["SecuritiesTransactionsChangedBy"])
                    this.securitiesTransactionsChangedBy!.push(InstrumentTransaction.fromJS(item));
            }
            if (Array.isArray(_data["SecuritiesTransactionsCreatedBy"])) {
                this.securitiesTransactionsCreatedBy = [] as any;
                for (let item of _data["SecuritiesTransactionsCreatedBy"])
                    this.securitiesTransactionsCreatedBy!.push(InstrumentTransaction.fromJS(item));
            }
            if (Array.isArray(_data["UserSettings"])) {
                this.userSettings = [] as any;
                for (let item of _data["UserSettings"])
                    this.userSettings!.push(UserSetting.fromJS(item));
            }
            if (Array.isArray(_data["GlTransactionInsightCreatedBy"])) {
                this.glTransactionInsightCreatedBy = [] as any;
                for (let item of _data["GlTransactionInsightCreatedBy"])
                    this.glTransactionInsightCreatedBy!.push(GlTransactionInsight.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Email"] = this.email;
        data["PolicyId"] = this.policyId;
        data["Created"] = this.created;
        data["AcceptedGdprmessage"] = this.acceptedGdprmessage;
        data["LanguageId"] = this.languageId;
        if (Array.isArray(this.categoriesChangedBy)) {
            data["CategoriesChangedBy"] = [];
            for (let item of this.categoriesChangedBy)
                data["CategoriesChangedBy"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.categoriesCreatedBy)) {
            data["CategoriesCreatedBy"] = [];
            for (let item of this.categoriesCreatedBy)
                data["CategoriesCreatedBy"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.companiesPortfolioInitializedBy)) {
            data["CompaniesPortfolioInitializedBy"] = [];
            for (let item of this.companiesPortfolioInitializedBy)
                data["CompaniesPortfolioInitializedBy"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.pogotransactions)) {
            data["Pogotransactions"] = [];
            for (let item of this.pogotransactions)
                data["Pogotransactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securitiesPrices)) {
            data["SecuritiesPrices"] = [];
            for (let item of this.securitiesPrices)
                data["SecuritiesPrices"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securitiesTransactionsChangedBy)) {
            data["SecuritiesTransactionsChangedBy"] = [];
            for (let item of this.securitiesTransactionsChangedBy)
                data["SecuritiesTransactionsChangedBy"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securitiesTransactionsCreatedBy)) {
            data["SecuritiesTransactionsCreatedBy"] = [];
            for (let item of this.securitiesTransactionsCreatedBy)
                data["SecuritiesTransactionsCreatedBy"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userSettings)) {
            data["UserSettings"] = [];
            for (let item of this.userSettings)
                data["UserSettings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.glTransactionInsightCreatedBy)) {
            data["GlTransactionInsightCreatedBy"] = [];
            for (let item of this.glTransactionInsightCreatedBy)
                data["GlTransactionInsightCreatedBy"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUser {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    policyId?: number | undefined;
    created?: string;
    acceptedGdprmessage?: string | undefined;
    languageId?: number | undefined;
    categoriesChangedBy?: Category[] | undefined;
    categoriesCreatedBy?: Category[] | undefined;
    companiesPortfolioInitializedBy?: Customer[] | undefined;
    pogotransactions?: LegacyGlTransaction[] | undefined;
    securitiesPrices?: InstrumentPrice[] | undefined;
    securitiesTransactionsChangedBy?: InstrumentTransaction[] | undefined;
    securitiesTransactionsCreatedBy?: InstrumentTransaction[] | undefined;
    userSettings?: UserSetting[] | undefined;
    glTransactionInsightCreatedBy?: GlTransactionInsight[] | undefined;
}

export class Customer implements ICustomer {
    id?: number;
    uuid?: string;
    identityId?: number;
    name?: string | undefined;
    parentCompanyId?: number | undefined;
    parentCustomer?: Customer | undefined;
    availableInstruments?: AvailableInstrument[] | undefined;
    categories?: Category[] | undefined;
    categorySettings?: CategorySetting[] | undefined;
    companySettings?: CustomerSetting[] | undefined;
    instruments?: Instrument[] | undefined;
    childCompanies?: Customer[] | undefined;
    companyStocks?: CustomerStockNumber[] | undefined;
    customerGlAccountDefaults?: CustomerGlAccountDefault[] | undefined;
    customerGlAccounts?: CustomerGlAccount[] | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.uuid = _data["Uuid"];
            this.identityId = _data["IdentityId"];
            this.name = _data["Name"];
            this.parentCompanyId = _data["ParentCompanyId"];
            this.parentCustomer = _data["ParentCustomer"] ? Customer.fromJS(_data["ParentCustomer"]) : undefined as any;
            if (Array.isArray(_data["AvailableInstruments"])) {
                this.availableInstruments = [] as any;
                for (let item of _data["AvailableInstruments"])
                    this.availableInstruments!.push(AvailableInstrument.fromJS(item));
            }
            if (Array.isArray(_data["Categories"])) {
                this.categories = [] as any;
                for (let item of _data["Categories"])
                    this.categories!.push(Category.fromJS(item));
            }
            if (Array.isArray(_data["CategorySettings"])) {
                this.categorySettings = [] as any;
                for (let item of _data["CategorySettings"])
                    this.categorySettings!.push(CategorySetting.fromJS(item));
            }
            if (Array.isArray(_data["CompanySettings"])) {
                this.companySettings = [] as any;
                for (let item of _data["CompanySettings"])
                    this.companySettings!.push(CustomerSetting.fromJS(item));
            }
            if (Array.isArray(_data["Instruments"])) {
                this.instruments = [] as any;
                for (let item of _data["Instruments"])
                    this.instruments!.push(Instrument.fromJS(item));
            }
            if (Array.isArray(_data["ChildCompanies"])) {
                this.childCompanies = [] as any;
                for (let item of _data["ChildCompanies"])
                    this.childCompanies!.push(Customer.fromJS(item));
            }
            if (Array.isArray(_data["CompanyStocks"])) {
                this.companyStocks = [] as any;
                for (let item of _data["CompanyStocks"])
                    this.companyStocks!.push(CustomerStockNumber.fromJS(item));
            }
            if (Array.isArray(_data["CustomerGlAccountDefaults"])) {
                this.customerGlAccountDefaults = [] as any;
                for (let item of _data["CustomerGlAccountDefaults"])
                    this.customerGlAccountDefaults!.push(CustomerGlAccountDefault.fromJS(item));
            }
            if (Array.isArray(_data["CustomerGlAccounts"])) {
                this.customerGlAccounts = [] as any;
                for (let item of _data["CustomerGlAccounts"])
                    this.customerGlAccounts!.push(CustomerGlAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Uuid"] = this.uuid;
        data["IdentityId"] = this.identityId;
        data["Name"] = this.name;
        data["ParentCompanyId"] = this.parentCompanyId;
        data["ParentCustomer"] = this.parentCustomer ? this.parentCustomer.toJSON() : undefined as any;
        if (Array.isArray(this.availableInstruments)) {
            data["AvailableInstruments"] = [];
            for (let item of this.availableInstruments)
                data["AvailableInstruments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.categories)) {
            data["Categories"] = [];
            for (let item of this.categories)
                data["Categories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.categorySettings)) {
            data["CategorySettings"] = [];
            for (let item of this.categorySettings)
                data["CategorySettings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.companySettings)) {
            data["CompanySettings"] = [];
            for (let item of this.companySettings)
                data["CompanySettings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instruments)) {
            data["Instruments"] = [];
            for (let item of this.instruments)
                data["Instruments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.childCompanies)) {
            data["ChildCompanies"] = [];
            for (let item of this.childCompanies)
                data["ChildCompanies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.companyStocks)) {
            data["CompanyStocks"] = [];
            for (let item of this.companyStocks)
                data["CompanyStocks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.customerGlAccountDefaults)) {
            data["CustomerGlAccountDefaults"] = [];
            for (let item of this.customerGlAccountDefaults)
                data["CustomerGlAccountDefaults"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.customerGlAccounts)) {
            data["CustomerGlAccounts"] = [];
            for (let item of this.customerGlAccounts)
                data["CustomerGlAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomer {
    id?: number;
    uuid?: string;
    identityId?: number;
    name?: string | undefined;
    parentCompanyId?: number | undefined;
    parentCustomer?: Customer | undefined;
    availableInstruments?: AvailableInstrument[] | undefined;
    categories?: Category[] | undefined;
    categorySettings?: CategorySetting[] | undefined;
    companySettings?: CustomerSetting[] | undefined;
    instruments?: Instrument[] | undefined;
    childCompanies?: Customer[] | undefined;
    companyStocks?: CustomerStockNumber[] | undefined;
    customerGlAccountDefaults?: CustomerGlAccountDefault[] | undefined;
    customerGlAccounts?: CustomerGlAccount[] | undefined;
}

export class AvailableInstrument implements IAvailableInstrument {
    ticker?: string | undefined;
    lastUpdated?: string | undefined;
    name?: string | undefined;
    isin?: string | undefined;
    id?: number;
    uuid?: string;
    instrumentTypeId?: number | undefined;
    instrumentCurrency?: InstrumentCurrency | undefined;
    instrumentCurrencyId?: number | undefined;
    orgNr?: string | undefined;
    feedDescription?: string | undefined;
    figiCode?: string | undefined;
    customerId?: number | undefined;
    searchVector?: Lexeme[] | undefined;
    customer?: Customer | undefined;
    countryCode?: string | undefined;
    importedPrices?: ImportedPrice[] | undefined;
    instruments?: Instrument[] | undefined;
    marketIndexes?: MarketIndex[] | undefined;
    availableInstrumentLookupId?: number | undefined;
    lookupAvailableInstrumentId?: string | undefined;
    availableInstrumentInboxId?: number | undefined;
    availableInstrumentCategories?: AvailableInstrumentCategory[] | undefined;

    constructor(data?: IAvailableInstrument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticker = _data["Ticker"];
            this.lastUpdated = _data["LastUpdated"];
            this.name = _data["Name"];
            this.isin = _data["Isin"];
            this.id = _data["Id"];
            this.uuid = _data["Uuid"];
            this.instrumentTypeId = _data["InstrumentTypeId"];
            this.instrumentCurrency = _data["InstrumentCurrency"] ? InstrumentCurrency.fromJS(_data["InstrumentCurrency"]) : undefined as any;
            this.instrumentCurrencyId = _data["InstrumentCurrencyId"];
            this.orgNr = _data["OrgNr"];
            this.feedDescription = _data["FeedDescription"];
            this.figiCode = _data["FigiCode"];
            this.customerId = _data["CustomerId"];
            if (Array.isArray(_data["SearchVector"])) {
                this.searchVector = [] as any;
                for (let item of _data["SearchVector"])
                    this.searchVector!.push(Lexeme.fromJS(item));
            }
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            this.countryCode = _data["CountryCode"];
            if (Array.isArray(_data["ImportedPrices"])) {
                this.importedPrices = [] as any;
                for (let item of _data["ImportedPrices"])
                    this.importedPrices!.push(ImportedPrice.fromJS(item));
            }
            if (Array.isArray(_data["Instruments"])) {
                this.instruments = [] as any;
                for (let item of _data["Instruments"])
                    this.instruments!.push(Instrument.fromJS(item));
            }
            if (Array.isArray(_data["MarketIndexes"])) {
                this.marketIndexes = [] as any;
                for (let item of _data["MarketIndexes"])
                    this.marketIndexes!.push(MarketIndex.fromJS(item));
            }
            this.availableInstrumentLookupId = _data["AvailableInstrumentLookupId"];
            this.lookupAvailableInstrumentId = _data["LookupAvailableInstrumentId"];
            this.availableInstrumentInboxId = _data["AvailableInstrumentInboxId"];
            if (Array.isArray(_data["AvailableInstrumentCategories"])) {
                this.availableInstrumentCategories = [] as any;
                for (let item of _data["AvailableInstrumentCategories"])
                    this.availableInstrumentCategories!.push(AvailableInstrumentCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvailableInstrument {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableInstrument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Ticker"] = this.ticker;
        data["LastUpdated"] = this.lastUpdated;
        data["Name"] = this.name;
        data["Isin"] = this.isin;
        data["Id"] = this.id;
        data["Uuid"] = this.uuid;
        data["InstrumentTypeId"] = this.instrumentTypeId;
        data["InstrumentCurrency"] = this.instrumentCurrency ? this.instrumentCurrency.toJSON() : undefined as any;
        data["InstrumentCurrencyId"] = this.instrumentCurrencyId;
        data["OrgNr"] = this.orgNr;
        data["FeedDescription"] = this.feedDescription;
        data["FigiCode"] = this.figiCode;
        data["CustomerId"] = this.customerId;
        if (Array.isArray(this.searchVector)) {
            data["SearchVector"] = [];
            for (let item of this.searchVector)
                data["SearchVector"].push(item ? item.toJSON() : undefined as any);
        }
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["CountryCode"] = this.countryCode;
        if (Array.isArray(this.importedPrices)) {
            data["ImportedPrices"] = [];
            for (let item of this.importedPrices)
                data["ImportedPrices"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instruments)) {
            data["Instruments"] = [];
            for (let item of this.instruments)
                data["Instruments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.marketIndexes)) {
            data["MarketIndexes"] = [];
            for (let item of this.marketIndexes)
                data["MarketIndexes"].push(item ? item.toJSON() : undefined as any);
        }
        data["AvailableInstrumentLookupId"] = this.availableInstrumentLookupId;
        data["LookupAvailableInstrumentId"] = this.lookupAvailableInstrumentId;
        data["AvailableInstrumentInboxId"] = this.availableInstrumentInboxId;
        if (Array.isArray(this.availableInstrumentCategories)) {
            data["AvailableInstrumentCategories"] = [];
            for (let item of this.availableInstrumentCategories)
                data["AvailableInstrumentCategories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAvailableInstrument {
    ticker?: string | undefined;
    lastUpdated?: string | undefined;
    name?: string | undefined;
    isin?: string | undefined;
    id?: number;
    uuid?: string;
    instrumentTypeId?: number | undefined;
    instrumentCurrency?: InstrumentCurrency | undefined;
    instrumentCurrencyId?: number | undefined;
    orgNr?: string | undefined;
    feedDescription?: string | undefined;
    figiCode?: string | undefined;
    customerId?: number | undefined;
    searchVector?: Lexeme[] | undefined;
    customer?: Customer | undefined;
    countryCode?: string | undefined;
    importedPrices?: ImportedPrice[] | undefined;
    instruments?: Instrument[] | undefined;
    marketIndexes?: MarketIndex[] | undefined;
    availableInstrumentLookupId?: number | undefined;
    lookupAvailableInstrumentId?: string | undefined;
    availableInstrumentInboxId?: number | undefined;
    availableInstrumentCategories?: AvailableInstrumentCategory[] | undefined;
}

export class InstrumentCurrency implements IInstrumentCurrency {
    id?: number;
    name?: string | undefined;
    currencyFactor?: number;
    mainCurrencyCodeId?: number | undefined;
    mainInstrumentCurrencyCode?: InstrumentCurrency | undefined;
    availableInstruments?: AvailableInstrument[] | undefined;
    currencyMappings?: CurrencyMapping[] | undefined;
    instruments?: Instrument[] | undefined;
    inverseMainCurrencyCode?: InstrumentCurrency[] | undefined;
    securitiesTransactions?: InstrumentTransaction[] | undefined;

    constructor(data?: IInstrumentCurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.currencyFactor = _data["CurrencyFactor"];
            this.mainCurrencyCodeId = _data["MainCurrencyCodeId"];
            this.mainInstrumentCurrencyCode = _data["MainInstrumentCurrencyCode"] ? InstrumentCurrency.fromJS(_data["MainInstrumentCurrencyCode"]) : undefined as any;
            if (Array.isArray(_data["AvailableInstruments"])) {
                this.availableInstruments = [] as any;
                for (let item of _data["AvailableInstruments"])
                    this.availableInstruments!.push(AvailableInstrument.fromJS(item));
            }
            if (Array.isArray(_data["CurrencyMappings"])) {
                this.currencyMappings = [] as any;
                for (let item of _data["CurrencyMappings"])
                    this.currencyMappings!.push(CurrencyMapping.fromJS(item));
            }
            if (Array.isArray(_data["Instruments"])) {
                this.instruments = [] as any;
                for (let item of _data["Instruments"])
                    this.instruments!.push(Instrument.fromJS(item));
            }
            if (Array.isArray(_data["InverseMainCurrencyCode"])) {
                this.inverseMainCurrencyCode = [] as any;
                for (let item of _data["InverseMainCurrencyCode"])
                    this.inverseMainCurrencyCode!.push(InstrumentCurrency.fromJS(item));
            }
            if (Array.isArray(_data["SecuritiesTransactions"])) {
                this.securitiesTransactions = [] as any;
                for (let item of _data["SecuritiesTransactions"])
                    this.securitiesTransactions!.push(InstrumentTransaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstrumentCurrency {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentCurrency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["CurrencyFactor"] = this.currencyFactor;
        data["MainCurrencyCodeId"] = this.mainCurrencyCodeId;
        data["MainInstrumentCurrencyCode"] = this.mainInstrumentCurrencyCode ? this.mainInstrumentCurrencyCode.toJSON() : undefined as any;
        if (Array.isArray(this.availableInstruments)) {
            data["AvailableInstruments"] = [];
            for (let item of this.availableInstruments)
                data["AvailableInstruments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.currencyMappings)) {
            data["CurrencyMappings"] = [];
            for (let item of this.currencyMappings)
                data["CurrencyMappings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instruments)) {
            data["Instruments"] = [];
            for (let item of this.instruments)
                data["Instruments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inverseMainCurrencyCode)) {
            data["InverseMainCurrencyCode"] = [];
            for (let item of this.inverseMainCurrencyCode)
                data["InverseMainCurrencyCode"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securitiesTransactions)) {
            data["SecuritiesTransactions"] = [];
            for (let item of this.securitiesTransactions)
                data["SecuritiesTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInstrumentCurrency {
    id?: number;
    name?: string | undefined;
    currencyFactor?: number;
    mainCurrencyCodeId?: number | undefined;
    mainInstrumentCurrencyCode?: InstrumentCurrency | undefined;
    availableInstruments?: AvailableInstrument[] | undefined;
    currencyMappings?: CurrencyMapping[] | undefined;
    instruments?: Instrument[] | undefined;
    inverseMainCurrencyCode?: InstrumentCurrency[] | undefined;
    securitiesTransactions?: InstrumentTransaction[] | undefined;
}

export class CurrencyMapping implements ICurrencyMapping {
    id?: number;
    description?: string | undefined;
    instrumentCurrencyId?: number | undefined;
    instrumentCurrency?: InstrumentCurrency | undefined;
    reportingCurrencyId?: number | undefined;
    reportingCurrency?: ReportingCurrency | undefined;
    availableInstrumentFxPair?: AvailableInstrument | undefined;
    availableInstrumentFxPairId?: number | undefined;
    availableInstrumentFxPairUuid?: string | undefined;

    constructor(data?: ICurrencyMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.description = _data["Description"];
            this.instrumentCurrencyId = _data["InstrumentCurrencyId"];
            this.instrumentCurrency = _data["InstrumentCurrency"] ? InstrumentCurrency.fromJS(_data["InstrumentCurrency"]) : undefined as any;
            this.reportingCurrencyId = _data["ReportingCurrencyId"];
            this.reportingCurrency = _data["ReportingCurrency"] ? ReportingCurrency.fromJS(_data["ReportingCurrency"]) : undefined as any;
            this.availableInstrumentFxPair = _data["AvailableInstrumentFxPair"] ? AvailableInstrument.fromJS(_data["AvailableInstrumentFxPair"]) : undefined as any;
            this.availableInstrumentFxPairId = _data["AvailableInstrumentFxPairId"];
            this.availableInstrumentFxPairUuid = _data["AvailableInstrumentFxPairUuid"];
        }
    }

    static fromJS(data: any): CurrencyMapping {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Description"] = this.description;
        data["InstrumentCurrencyId"] = this.instrumentCurrencyId;
        data["InstrumentCurrency"] = this.instrumentCurrency ? this.instrumentCurrency.toJSON() : undefined as any;
        data["ReportingCurrencyId"] = this.reportingCurrencyId;
        data["ReportingCurrency"] = this.reportingCurrency ? this.reportingCurrency.toJSON() : undefined as any;
        data["AvailableInstrumentFxPair"] = this.availableInstrumentFxPair ? this.availableInstrumentFxPair.toJSON() : undefined as any;
        data["AvailableInstrumentFxPairId"] = this.availableInstrumentFxPairId;
        data["AvailableInstrumentFxPairUuid"] = this.availableInstrumentFxPairUuid;
        return data;
    }
}

export interface ICurrencyMapping {
    id?: number;
    description?: string | undefined;
    instrumentCurrencyId?: number | undefined;
    instrumentCurrency?: InstrumentCurrency | undefined;
    reportingCurrencyId?: number | undefined;
    reportingCurrency?: ReportingCurrency | undefined;
    availableInstrumentFxPair?: AvailableInstrument | undefined;
    availableInstrumentFxPairId?: number | undefined;
    availableInstrumentFxPairUuid?: string | undefined;
}

export class ReportingCurrency implements IReportingCurrency {
    id?: number;
    currencyCode?: string | undefined;
    currencyMappings?: CurrencyMapping[] | undefined;

    constructor(data?: IReportingCurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.currencyCode = _data["CurrencyCode"];
            if (Array.isArray(_data["CurrencyMappings"])) {
                this.currencyMappings = [] as any;
                for (let item of _data["CurrencyMappings"])
                    this.currencyMappings!.push(CurrencyMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportingCurrency {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingCurrency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CurrencyCode"] = this.currencyCode;
        if (Array.isArray(this.currencyMappings)) {
            data["CurrencyMappings"] = [];
            for (let item of this.currencyMappings)
                data["CurrencyMappings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReportingCurrency {
    id?: number;
    currencyCode?: string | undefined;
    currencyMappings?: CurrencyMapping[] | undefined;
}

export class Instrument implements IInstrument {
    id?: number;
    uuid?: string;
    isin?: string | undefined;
    ticker?: string | undefined;
    name?: string | undefined;
    noted?: boolean;
    taxable?: boolean;
    longTerm?: boolean;
    lowerOfCostOrMarket?: boolean;
    terminated?: boolean;
    instrumentState?: InstrumentState;
    companyId?: number | undefined;
    createdAt?: string;
    availableInstrumentId?: number | undefined;
    availableInstrumentUuid?: string;
    comment?: string | undefined;
    countryCode?: string | undefined;
    accountingValue?: number | undefined;
    availableInstrument?: AvailableInstrument | undefined;
    customer?: Customer | undefined;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    instrumentType?: InstrumentType | undefined;
    instrumentCategories?: InstrumentsCategories[] | undefined;
    instrumentTaxValueStates?: InstrumentTaxValueState[] | undefined;
    instrumentAccountingValueStates?: InstrumentAccountingValueState[] | undefined;
    instrumentPrices?: InstrumentPrice[] | undefined;
    instrumentTransactions?: InstrumentTransaction[] | undefined;
    instrumentGlAccountOverrides?: InstrumentGlAccountOverride[] | undefined;

    constructor(data?: IInstrument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.uuid = _data["Uuid"];
            this.isin = _data["Isin"];
            this.ticker = _data["Ticker"];
            this.name = _data["Name"];
            this.noted = _data["Noted"];
            this.taxable = _data["Taxable"];
            this.longTerm = _data["LongTerm"];
            this.lowerOfCostOrMarket = _data["LowerOfCostOrMarket"];
            this.terminated = _data["Terminated"];
            this.instrumentState = _data["InstrumentState"];
            this.companyId = _data["CompanyId"];
            this.createdAt = _data["CreatedAt"];
            this.availableInstrumentId = _data["AvailableInstrumentId"];
            this.availableInstrumentUuid = _data["AvailableInstrumentUuid"];
            this.comment = _data["Comment"];
            this.countryCode = _data["CountryCode"];
            this.accountingValue = _data["AccountingValue"];
            this.availableInstrument = _data["AvailableInstrument"] ? AvailableInstrument.fromJS(_data["AvailableInstrument"]) : undefined as any;
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            this.instrumentTypeId = _data["InstrumentTypeId"];
            this.instrumentType = _data["InstrumentType"] ? InstrumentType.fromJS(_data["InstrumentType"]) : undefined as any;
            if (Array.isArray(_data["InstrumentCategories"])) {
                this.instrumentCategories = [] as any;
                for (let item of _data["InstrumentCategories"])
                    this.instrumentCategories!.push(InstrumentsCategories.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentTaxValueStates"])) {
                this.instrumentTaxValueStates = [] as any;
                for (let item of _data["InstrumentTaxValueStates"])
                    this.instrumentTaxValueStates!.push(InstrumentTaxValueState.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentAccountingValueStates"])) {
                this.instrumentAccountingValueStates = [] as any;
                for (let item of _data["InstrumentAccountingValueStates"])
                    this.instrumentAccountingValueStates!.push(InstrumentAccountingValueState.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentPrices"])) {
                this.instrumentPrices = [] as any;
                for (let item of _data["InstrumentPrices"])
                    this.instrumentPrices!.push(InstrumentPrice.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentTransactions"])) {
                this.instrumentTransactions = [] as any;
                for (let item of _data["InstrumentTransactions"])
                    this.instrumentTransactions!.push(InstrumentTransaction.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentGlAccountOverrides"])) {
                this.instrumentGlAccountOverrides = [] as any;
                for (let item of _data["InstrumentGlAccountOverrides"])
                    this.instrumentGlAccountOverrides!.push(InstrumentGlAccountOverride.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Instrument {
        data = typeof data === 'object' ? data : {};
        let result = new Instrument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Uuid"] = this.uuid;
        data["Isin"] = this.isin;
        data["Ticker"] = this.ticker;
        data["Name"] = this.name;
        data["Noted"] = this.noted;
        data["Taxable"] = this.taxable;
        data["LongTerm"] = this.longTerm;
        data["LowerOfCostOrMarket"] = this.lowerOfCostOrMarket;
        data["Terminated"] = this.terminated;
        data["InstrumentState"] = this.instrumentState;
        data["CompanyId"] = this.companyId;
        data["CreatedAt"] = this.createdAt;
        data["AvailableInstrumentId"] = this.availableInstrumentId;
        data["AvailableInstrumentUuid"] = this.availableInstrumentUuid;
        data["Comment"] = this.comment;
        data["CountryCode"] = this.countryCode;
        data["AccountingValue"] = this.accountingValue;
        data["AvailableInstrument"] = this.availableInstrument ? this.availableInstrument.toJSON() : undefined as any;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["InstrumentTypeId"] = this.instrumentTypeId;
        data["InstrumentType"] = this.instrumentType ? this.instrumentType.toJSON() : undefined as any;
        if (Array.isArray(this.instrumentCategories)) {
            data["InstrumentCategories"] = [];
            for (let item of this.instrumentCategories)
                data["InstrumentCategories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentTaxValueStates)) {
            data["InstrumentTaxValueStates"] = [];
            for (let item of this.instrumentTaxValueStates)
                data["InstrumentTaxValueStates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentAccountingValueStates)) {
            data["InstrumentAccountingValueStates"] = [];
            for (let item of this.instrumentAccountingValueStates)
                data["InstrumentAccountingValueStates"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentPrices)) {
            data["InstrumentPrices"] = [];
            for (let item of this.instrumentPrices)
                data["InstrumentPrices"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentTransactions)) {
            data["InstrumentTransactions"] = [];
            for (let item of this.instrumentTransactions)
                data["InstrumentTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentGlAccountOverrides)) {
            data["InstrumentGlAccountOverrides"] = [];
            for (let item of this.instrumentGlAccountOverrides)
                data["InstrumentGlAccountOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInstrument {
    id?: number;
    uuid?: string;
    isin?: string | undefined;
    ticker?: string | undefined;
    name?: string | undefined;
    noted?: boolean;
    taxable?: boolean;
    longTerm?: boolean;
    lowerOfCostOrMarket?: boolean;
    terminated?: boolean;
    instrumentState?: InstrumentState;
    companyId?: number | undefined;
    createdAt?: string;
    availableInstrumentId?: number | undefined;
    availableInstrumentUuid?: string;
    comment?: string | undefined;
    countryCode?: string | undefined;
    accountingValue?: number | undefined;
    availableInstrument?: AvailableInstrument | undefined;
    customer?: Customer | undefined;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    instrumentType?: InstrumentType | undefined;
    instrumentCategories?: InstrumentsCategories[] | undefined;
    instrumentTaxValueStates?: InstrumentTaxValueState[] | undefined;
    instrumentAccountingValueStates?: InstrumentAccountingValueState[] | undefined;
    instrumentPrices?: InstrumentPrice[] | undefined;
    instrumentTransactions?: InstrumentTransaction[] | undefined;
    instrumentGlAccountOverrides?: InstrumentGlAccountOverride[] | undefined;
}

export enum InstrumentState {
    Draft = 0,
    Active = 1,
    Deactivated = 2,
}

export enum InstrumentTypeEnum {
    StocksNoted = 1,
    EquityCertificate = 2,
    Bonds = 3,
    FixedIncomeFunds = 4,
    Derivatives = 5,
    Stocks = 7,
    Dividend = 8,
    Repayment = 9,
    EquityFunds = 10,
    Currency = 13,
    Bank = 14,
    ETF = 15,
    ETN = 16,
    StocksSubsidiaries = 50,
    StocksAssociatedCompanies = 51,
    Loans = 52,
    LoansSubsidiaries = 53,
    LoansAssociatedCompanies = 54,
    Property = 55,
    OtherAssets = 56,
    Partnership = 57,
    Cfd = 58,
    Etc = 59,
    ShortPosition = 60,
}

export class InstrumentType implements IInstrumentType {
    id?: InstrumentTypeEnum;
    name?: string | undefined;
    purchasedInterests?: boolean | undefined;
    instruments?: Instrument[] | undefined;
    instrumentGlAccountOverrides?: InstrumentGlAccountOverride[] | undefined;
    customerGlAccountDefaults?: CustomerGlAccountDefault[] | undefined;
    instrumentTransactionGlAccountOverrides?: InstrumentTransactionGlAccountOverride[] | undefined;
    systemDefaultGlAccounts?: SystemDefaultGlAccount[] | undefined;

    constructor(data?: IInstrumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.purchasedInterests = _data["PurchasedInterests"];
            if (Array.isArray(_data["Instruments"])) {
                this.instruments = [] as any;
                for (let item of _data["Instruments"])
                    this.instruments!.push(Instrument.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentGlAccountOverrides"])) {
                this.instrumentGlAccountOverrides = [] as any;
                for (let item of _data["InstrumentGlAccountOverrides"])
                    this.instrumentGlAccountOverrides!.push(InstrumentGlAccountOverride.fromJS(item));
            }
            if (Array.isArray(_data["CustomerGlAccountDefaults"])) {
                this.customerGlAccountDefaults = [] as any;
                for (let item of _data["CustomerGlAccountDefaults"])
                    this.customerGlAccountDefaults!.push(CustomerGlAccountDefault.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentTransactionGlAccountOverrides"])) {
                this.instrumentTransactionGlAccountOverrides = [] as any;
                for (let item of _data["InstrumentTransactionGlAccountOverrides"])
                    this.instrumentTransactionGlAccountOverrides!.push(InstrumentTransactionGlAccountOverride.fromJS(item));
            }
            if (Array.isArray(_data["SystemDefaultGlAccounts"])) {
                this.systemDefaultGlAccounts = [] as any;
                for (let item of _data["SystemDefaultGlAccounts"])
                    this.systemDefaultGlAccounts!.push(SystemDefaultGlAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstrumentType {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["PurchasedInterests"] = this.purchasedInterests;
        if (Array.isArray(this.instruments)) {
            data["Instruments"] = [];
            for (let item of this.instruments)
                data["Instruments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentGlAccountOverrides)) {
            data["InstrumentGlAccountOverrides"] = [];
            for (let item of this.instrumentGlAccountOverrides)
                data["InstrumentGlAccountOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.customerGlAccountDefaults)) {
            data["CustomerGlAccountDefaults"] = [];
            for (let item of this.customerGlAccountDefaults)
                data["CustomerGlAccountDefaults"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentTransactionGlAccountOverrides)) {
            data["InstrumentTransactionGlAccountOverrides"] = [];
            for (let item of this.instrumentTransactionGlAccountOverrides)
                data["InstrumentTransactionGlAccountOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.systemDefaultGlAccounts)) {
            data["SystemDefaultGlAccounts"] = [];
            for (let item of this.systemDefaultGlAccounts)
                data["SystemDefaultGlAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInstrumentType {
    id?: InstrumentTypeEnum;
    name?: string | undefined;
    purchasedInterests?: boolean | undefined;
    instruments?: Instrument[] | undefined;
    instrumentGlAccountOverrides?: InstrumentGlAccountOverride[] | undefined;
    customerGlAccountDefaults?: CustomerGlAccountDefault[] | undefined;
    instrumentTransactionGlAccountOverrides?: InstrumentTransactionGlAccountOverride[] | undefined;
    systemDefaultGlAccounts?: SystemDefaultGlAccount[] | undefined;
}

export class InstrumentGlAccountOverride implements IInstrumentGlAccountOverride {
    id?: number;
    instrumentId?: number;
    glAccountTypeId?: number;
    customerGlAccountId?: number;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    taxable?: boolean | undefined;
    longTerm?: boolean | undefined;
    glAccountType?: GlAccountType | undefined;
    instrument?: Instrument | undefined;
    customerGlAccount?: CustomerGlAccount | undefined;
    instrumentType?: InstrumentType | undefined;

    constructor(data?: IInstrumentGlAccountOverride) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.instrumentId = _data["InstrumentId"];
            this.glAccountTypeId = _data["GlAccountTypeId"];
            this.customerGlAccountId = _data["CustomerGlAccountId"];
            this.instrumentTypeId = _data["InstrumentTypeId"];
            this.taxable = _data["Taxable"];
            this.longTerm = _data["LongTerm"];
            this.glAccountType = _data["GlAccountType"] ? GlAccountType.fromJS(_data["GlAccountType"]) : undefined as any;
            this.instrument = _data["Instrument"] ? Instrument.fromJS(_data["Instrument"]) : undefined as any;
            this.customerGlAccount = _data["CustomerGlAccount"] ? CustomerGlAccount.fromJS(_data["CustomerGlAccount"]) : undefined as any;
            this.instrumentType = _data["InstrumentType"] ? InstrumentType.fromJS(_data["InstrumentType"]) : undefined as any;
        }
    }

    static fromJS(data: any): InstrumentGlAccountOverride {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentGlAccountOverride();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["InstrumentId"] = this.instrumentId;
        data["GlAccountTypeId"] = this.glAccountTypeId;
        data["CustomerGlAccountId"] = this.customerGlAccountId;
        data["InstrumentTypeId"] = this.instrumentTypeId;
        data["Taxable"] = this.taxable;
        data["LongTerm"] = this.longTerm;
        data["GlAccountType"] = this.glAccountType ? this.glAccountType.toJSON() : undefined as any;
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["CustomerGlAccount"] = this.customerGlAccount ? this.customerGlAccount.toJSON() : undefined as any;
        data["InstrumentType"] = this.instrumentType ? this.instrumentType.toJSON() : undefined as any;
        return data;
    }
}

export interface IInstrumentGlAccountOverride {
    id?: number;
    instrumentId?: number;
    glAccountTypeId?: number;
    customerGlAccountId?: number;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    taxable?: boolean | undefined;
    longTerm?: boolean | undefined;
    glAccountType?: GlAccountType | undefined;
    instrument?: Instrument | undefined;
    customerGlAccount?: CustomerGlAccount | undefined;
    instrumentType?: InstrumentType | undefined;
}

export class GlAccountType implements IGlAccountType {
    id?: number;
    name?: string | undefined;
    customerGlAccountDefaults?: CustomerGlAccountDefault[] | undefined;
    glActionTypeGlAccountTypes?: GlActionTypeGlAccountType[] | undefined;
    instrumentGlAccountOverrides?: InstrumentGlAccountOverride[] | undefined;
    instrumentTransactionGlAccountOverrides?: InstrumentTransactionGlAccountOverride[] | undefined;
    systemDefaultGlAccounts?: SystemDefaultGlAccount[] | undefined;

    constructor(data?: IGlAccountType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            if (Array.isArray(_data["CustomerGlAccountDefaults"])) {
                this.customerGlAccountDefaults = [] as any;
                for (let item of _data["CustomerGlAccountDefaults"])
                    this.customerGlAccountDefaults!.push(CustomerGlAccountDefault.fromJS(item));
            }
            if (Array.isArray(_data["GlActionTypeGlAccountTypes"])) {
                this.glActionTypeGlAccountTypes = [] as any;
                for (let item of _data["GlActionTypeGlAccountTypes"])
                    this.glActionTypeGlAccountTypes!.push(GlActionTypeGlAccountType.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentGlAccountOverrides"])) {
                this.instrumentGlAccountOverrides = [] as any;
                for (let item of _data["InstrumentGlAccountOverrides"])
                    this.instrumentGlAccountOverrides!.push(InstrumentGlAccountOverride.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentTransactionGlAccountOverrides"])) {
                this.instrumentTransactionGlAccountOverrides = [] as any;
                for (let item of _data["InstrumentTransactionGlAccountOverrides"])
                    this.instrumentTransactionGlAccountOverrides!.push(InstrumentTransactionGlAccountOverride.fromJS(item));
            }
            if (Array.isArray(_data["SystemDefaultGlAccounts"])) {
                this.systemDefaultGlAccounts = [] as any;
                for (let item of _data["SystemDefaultGlAccounts"])
                    this.systemDefaultGlAccounts!.push(SystemDefaultGlAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlAccountType {
        data = typeof data === 'object' ? data : {};
        let result = new GlAccountType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        if (Array.isArray(this.customerGlAccountDefaults)) {
            data["CustomerGlAccountDefaults"] = [];
            for (let item of this.customerGlAccountDefaults)
                data["CustomerGlAccountDefaults"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.glActionTypeGlAccountTypes)) {
            data["GlActionTypeGlAccountTypes"] = [];
            for (let item of this.glActionTypeGlAccountTypes)
                data["GlActionTypeGlAccountTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentGlAccountOverrides)) {
            data["InstrumentGlAccountOverrides"] = [];
            for (let item of this.instrumentGlAccountOverrides)
                data["InstrumentGlAccountOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentTransactionGlAccountOverrides)) {
            data["InstrumentTransactionGlAccountOverrides"] = [];
            for (let item of this.instrumentTransactionGlAccountOverrides)
                data["InstrumentTransactionGlAccountOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.systemDefaultGlAccounts)) {
            data["SystemDefaultGlAccounts"] = [];
            for (let item of this.systemDefaultGlAccounts)
                data["SystemDefaultGlAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGlAccountType {
    id?: number;
    name?: string | undefined;
    customerGlAccountDefaults?: CustomerGlAccountDefault[] | undefined;
    glActionTypeGlAccountTypes?: GlActionTypeGlAccountType[] | undefined;
    instrumentGlAccountOverrides?: InstrumentGlAccountOverride[] | undefined;
    instrumentTransactionGlAccountOverrides?: InstrumentTransactionGlAccountOverride[] | undefined;
    systemDefaultGlAccounts?: SystemDefaultGlAccount[] | undefined;
}

export class CustomerGlAccountDefault implements ICustomerGlAccountDefault {
    id?: number;
    customerId?: number;
    glAccountTypeId?: number;
    customerGlAccountId?: number;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    systemDefaultGlAccountId?: number | undefined;
    portfolioId?: number | undefined;
    taxable?: boolean | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    disabled?: boolean | undefined;
    default?: boolean | undefined;
    ruleName?: string | undefined;
    broker?: string | undefined;
    currencyCode?: string | undefined;
    brokerBankAccountId?: string | undefined;
    brokerVpsAccountId?: string | undefined;
    brokerCustomerId?: string | undefined;
    brokerPortfolioId?: string | undefined;
    ruleOrder?: number | undefined;
    customer?: Customer | undefined;
    glAccountType?: GlAccountType | undefined;
    customerGlAccount?: CustomerGlAccount | undefined;
    instrumentType?: InstrumentType | undefined;
    systemDefaultGlAccount?: SystemDefaultGlAccount | undefined;
    portfolio?: Category | undefined;

    constructor(data?: ICustomerGlAccountDefault) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.customerId = _data["CustomerId"];
            this.glAccountTypeId = _data["GlAccountTypeId"];
            this.customerGlAccountId = _data["CustomerGlAccountId"];
            this.instrumentTypeId = _data["InstrumentTypeId"];
            this.systemDefaultGlAccountId = _data["SystemDefaultGlAccountId"];
            this.portfolioId = _data["PortfolioId"];
            this.taxable = _data["Taxable"];
            this.longTerm = _data["LongTerm"];
            this.lowerOfCostOrMarket = _data["LowerOfCostOrMarket"];
            this.disabled = _data["Disabled"];
            this.default = _data["Default"];
            this.ruleName = _data["RuleName"];
            this.broker = _data["Broker"];
            this.currencyCode = _data["CurrencyCode"];
            this.brokerBankAccountId = _data["BrokerBankAccountId"];
            this.brokerVpsAccountId = _data["BrokerVpsAccountId"];
            this.brokerCustomerId = _data["BrokerCustomerId"];
            this.brokerPortfolioId = _data["BrokerPortfolioId"];
            this.ruleOrder = _data["RuleOrder"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            this.glAccountType = _data["GlAccountType"] ? GlAccountType.fromJS(_data["GlAccountType"]) : undefined as any;
            this.customerGlAccount = _data["CustomerGlAccount"] ? CustomerGlAccount.fromJS(_data["CustomerGlAccount"]) : undefined as any;
            this.instrumentType = _data["InstrumentType"] ? InstrumentType.fromJS(_data["InstrumentType"]) : undefined as any;
            this.systemDefaultGlAccount = _data["SystemDefaultGlAccount"] ? SystemDefaultGlAccount.fromJS(_data["SystemDefaultGlAccount"]) : undefined as any;
            this.portfolio = _data["Portfolio"] ? Category.fromJS(_data["Portfolio"]) : undefined as any;
        }
    }

    static fromJS(data: any): CustomerGlAccountDefault {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerGlAccountDefault();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CustomerId"] = this.customerId;
        data["GlAccountTypeId"] = this.glAccountTypeId;
        data["CustomerGlAccountId"] = this.customerGlAccountId;
        data["InstrumentTypeId"] = this.instrumentTypeId;
        data["SystemDefaultGlAccountId"] = this.systemDefaultGlAccountId;
        data["PortfolioId"] = this.portfolioId;
        data["Taxable"] = this.taxable;
        data["LongTerm"] = this.longTerm;
        data["LowerOfCostOrMarket"] = this.lowerOfCostOrMarket;
        data["Disabled"] = this.disabled;
        data["Default"] = this.default;
        data["RuleName"] = this.ruleName;
        data["Broker"] = this.broker;
        data["CurrencyCode"] = this.currencyCode;
        data["BrokerBankAccountId"] = this.brokerBankAccountId;
        data["BrokerVpsAccountId"] = this.brokerVpsAccountId;
        data["BrokerCustomerId"] = this.brokerCustomerId;
        data["BrokerPortfolioId"] = this.brokerPortfolioId;
        data["RuleOrder"] = this.ruleOrder;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["GlAccountType"] = this.glAccountType ? this.glAccountType.toJSON() : undefined as any;
        data["CustomerGlAccount"] = this.customerGlAccount ? this.customerGlAccount.toJSON() : undefined as any;
        data["InstrumentType"] = this.instrumentType ? this.instrumentType.toJSON() : undefined as any;
        data["SystemDefaultGlAccount"] = this.systemDefaultGlAccount ? this.systemDefaultGlAccount.toJSON() : undefined as any;
        data["Portfolio"] = this.portfolio ? this.portfolio.toJSON() : undefined as any;
        return data;
    }
}

export interface ICustomerGlAccountDefault {
    id?: number;
    customerId?: number;
    glAccountTypeId?: number;
    customerGlAccountId?: number;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    systemDefaultGlAccountId?: number | undefined;
    portfolioId?: number | undefined;
    taxable?: boolean | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    disabled?: boolean | undefined;
    default?: boolean | undefined;
    ruleName?: string | undefined;
    broker?: string | undefined;
    currencyCode?: string | undefined;
    brokerBankAccountId?: string | undefined;
    brokerVpsAccountId?: string | undefined;
    brokerCustomerId?: string | undefined;
    brokerPortfolioId?: string | undefined;
    ruleOrder?: number | undefined;
    customer?: Customer | undefined;
    glAccountType?: GlAccountType | undefined;
    customerGlAccount?: CustomerGlAccount | undefined;
    instrumentType?: InstrumentType | undefined;
    systemDefaultGlAccount?: SystemDefaultGlAccount | undefined;
    portfolio?: Category | undefined;
}

export class CustomerGlAccount implements ICustomerGlAccount {
    id?: number;
    customerId?: number;
    glAccountTypeId?: number;
    glAccountType?: GlAccountType | undefined;
    code?: number;
    name?: string | undefined;
    externalGlSystemId?: string | undefined;
    externalId?: string | undefined;
    externalGlSystemError?: string | undefined;
    incomingBalance?: number;
    currencyCode?: string | undefined;
    customer?: Customer | undefined;
    customerGlAccountDefaults?: CustomerGlAccountDefault[] | undefined;
    instrumentGlAccountOverrides?: InstrumentGlAccountOverride[] | undefined;
    instrumentTransactionGlAccountOverrides?: InstrumentTransactionGlAccountOverride[] | undefined;

    constructor(data?: ICustomerGlAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.customerId = _data["CustomerId"];
            this.glAccountTypeId = _data["GlAccountTypeId"];
            this.glAccountType = _data["GlAccountType"] ? GlAccountType.fromJS(_data["GlAccountType"]) : undefined as any;
            this.code = _data["Code"];
            this.name = _data["Name"];
            this.externalGlSystemId = _data["ExternalGlSystemId"];
            this.externalId = _data["ExternalId"];
            this.externalGlSystemError = _data["ExternalGlSystemError"];
            this.incomingBalance = _data["IncomingBalance"];
            this.currencyCode = _data["CurrencyCode"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            if (Array.isArray(_data["CustomerGlAccountDefaults"])) {
                this.customerGlAccountDefaults = [] as any;
                for (let item of _data["CustomerGlAccountDefaults"])
                    this.customerGlAccountDefaults!.push(CustomerGlAccountDefault.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentGlAccountOverrides"])) {
                this.instrumentGlAccountOverrides = [] as any;
                for (let item of _data["InstrumentGlAccountOverrides"])
                    this.instrumentGlAccountOverrides!.push(InstrumentGlAccountOverride.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentTransactionGlAccountOverrides"])) {
                this.instrumentTransactionGlAccountOverrides = [] as any;
                for (let item of _data["InstrumentTransactionGlAccountOverrides"])
                    this.instrumentTransactionGlAccountOverrides!.push(InstrumentTransactionGlAccountOverride.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerGlAccount {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerGlAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CustomerId"] = this.customerId;
        data["GlAccountTypeId"] = this.glAccountTypeId;
        data["GlAccountType"] = this.glAccountType ? this.glAccountType.toJSON() : undefined as any;
        data["Code"] = this.code;
        data["Name"] = this.name;
        data["ExternalGlSystemId"] = this.externalGlSystemId;
        data["ExternalId"] = this.externalId;
        data["ExternalGlSystemError"] = this.externalGlSystemError;
        data["IncomingBalance"] = this.incomingBalance;
        data["CurrencyCode"] = this.currencyCode;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        if (Array.isArray(this.customerGlAccountDefaults)) {
            data["CustomerGlAccountDefaults"] = [];
            for (let item of this.customerGlAccountDefaults)
                data["CustomerGlAccountDefaults"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentGlAccountOverrides)) {
            data["InstrumentGlAccountOverrides"] = [];
            for (let item of this.instrumentGlAccountOverrides)
                data["InstrumentGlAccountOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentTransactionGlAccountOverrides)) {
            data["InstrumentTransactionGlAccountOverrides"] = [];
            for (let item of this.instrumentTransactionGlAccountOverrides)
                data["InstrumentTransactionGlAccountOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomerGlAccount {
    id?: number;
    customerId?: number;
    glAccountTypeId?: number;
    glAccountType?: GlAccountType | undefined;
    code?: number;
    name?: string | undefined;
    externalGlSystemId?: string | undefined;
    externalId?: string | undefined;
    externalGlSystemError?: string | undefined;
    incomingBalance?: number;
    currencyCode?: string | undefined;
    customer?: Customer | undefined;
    customerGlAccountDefaults?: CustomerGlAccountDefault[] | undefined;
    instrumentGlAccountOverrides?: InstrumentGlAccountOverride[] | undefined;
    instrumentTransactionGlAccountOverrides?: InstrumentTransactionGlAccountOverride[] | undefined;
}

export class InstrumentTransactionGlAccountOverride implements IInstrumentTransactionGlAccountOverride {
    id?: number;
    externalDocumentId?: number;
    externalRowId?: number | undefined;
    voucherId?: string | undefined;
    glAccountTypeId?: number;
    customerGlAccountId?: number;
    taxable?: boolean | undefined;
    longTerm?: boolean | undefined;
    glAccountType?: GlAccountType | undefined;
    customerGlAccount?: CustomerGlAccount | undefined;

    constructor(data?: IInstrumentTransactionGlAccountOverride) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.externalDocumentId = _data["ExternalDocumentId"];
            this.externalRowId = _data["ExternalRowId"];
            this.voucherId = _data["VoucherId"];
            this.glAccountTypeId = _data["GlAccountTypeId"];
            this.customerGlAccountId = _data["CustomerGlAccountId"];
            this.taxable = _data["Taxable"];
            this.longTerm = _data["LongTerm"];
            this.glAccountType = _data["GlAccountType"] ? GlAccountType.fromJS(_data["GlAccountType"]) : undefined as any;
            this.customerGlAccount = _data["CustomerGlAccount"] ? CustomerGlAccount.fromJS(_data["CustomerGlAccount"]) : undefined as any;
        }
    }

    static fromJS(data: any): InstrumentTransactionGlAccountOverride {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentTransactionGlAccountOverride();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ExternalDocumentId"] = this.externalDocumentId;
        data["ExternalRowId"] = this.externalRowId;
        data["VoucherId"] = this.voucherId;
        data["GlAccountTypeId"] = this.glAccountTypeId;
        data["CustomerGlAccountId"] = this.customerGlAccountId;
        data["Taxable"] = this.taxable;
        data["LongTerm"] = this.longTerm;
        data["GlAccountType"] = this.glAccountType ? this.glAccountType.toJSON() : undefined as any;
        data["CustomerGlAccount"] = this.customerGlAccount ? this.customerGlAccount.toJSON() : undefined as any;
        return data;
    }
}

export interface IInstrumentTransactionGlAccountOverride {
    id?: number;
    externalDocumentId?: number;
    externalRowId?: number | undefined;
    voucherId?: string | undefined;
    glAccountTypeId?: number;
    customerGlAccountId?: number;
    taxable?: boolean | undefined;
    longTerm?: boolean | undefined;
    glAccountType?: GlAccountType | undefined;
    customerGlAccount?: CustomerGlAccount | undefined;
}

export class SystemDefaultGlAccount implements ISystemDefaultGlAccount {
    id?: number;
    glAccountTypeId?: number;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    code?: number;
    name?: string | undefined;
    taxable?: boolean | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    migrateExistingCustomers?: boolean;
    disabled?: boolean;
    template?: GlAccountsTemplate;
    glAccountType?: GlAccountType | undefined;
    instrumentType?: InstrumentType | undefined;
    customerGlAccountDefaults?: CustomerGlAccountDefault[] | undefined;

    constructor(data?: ISystemDefaultGlAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.glAccountTypeId = _data["GlAccountTypeId"];
            this.instrumentTypeId = _data["InstrumentTypeId"];
            this.code = _data["Code"];
            this.name = _data["Name"];
            this.taxable = _data["Taxable"];
            this.longTerm = _data["LongTerm"];
            this.lowerOfCostOrMarket = _data["LowerOfCostOrMarket"];
            this.migrateExistingCustomers = _data["MigrateExistingCustomers"];
            this.disabled = _data["Disabled"];
            this.template = _data["Template"];
            this.glAccountType = _data["GlAccountType"] ? GlAccountType.fromJS(_data["GlAccountType"]) : undefined as any;
            this.instrumentType = _data["InstrumentType"] ? InstrumentType.fromJS(_data["InstrumentType"]) : undefined as any;
            if (Array.isArray(_data["CustomerGlAccountDefaults"])) {
                this.customerGlAccountDefaults = [] as any;
                for (let item of _data["CustomerGlAccountDefaults"])
                    this.customerGlAccountDefaults!.push(CustomerGlAccountDefault.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemDefaultGlAccount {
        data = typeof data === 'object' ? data : {};
        let result = new SystemDefaultGlAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["GlAccountTypeId"] = this.glAccountTypeId;
        data["InstrumentTypeId"] = this.instrumentTypeId;
        data["Code"] = this.code;
        data["Name"] = this.name;
        data["Taxable"] = this.taxable;
        data["LongTerm"] = this.longTerm;
        data["LowerOfCostOrMarket"] = this.lowerOfCostOrMarket;
        data["MigrateExistingCustomers"] = this.migrateExistingCustomers;
        data["Disabled"] = this.disabled;
        data["Template"] = this.template;
        data["GlAccountType"] = this.glAccountType ? this.glAccountType.toJSON() : undefined as any;
        data["InstrumentType"] = this.instrumentType ? this.instrumentType.toJSON() : undefined as any;
        if (Array.isArray(this.customerGlAccountDefaults)) {
            data["CustomerGlAccountDefaults"] = [];
            for (let item of this.customerGlAccountDefaults)
                data["CustomerGlAccountDefaults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISystemDefaultGlAccount {
    id?: number;
    glAccountTypeId?: number;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    code?: number;
    name?: string | undefined;
    taxable?: boolean | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    migrateExistingCustomers?: boolean;
    disabled?: boolean;
    template?: GlAccountsTemplate;
    glAccountType?: GlAccountType | undefined;
    instrumentType?: InstrumentType | undefined;
    customerGlAccountDefaults?: CustomerGlAccountDefault[] | undefined;
}

export enum GlAccountsTemplate {
    FourDigits = 4,
    SixDigits = 6,
}

export class GlActionTypeGlAccountType implements IGlActionTypeGlAccountType {
    id?: number;
    glActionTypeId?: number;
    glAccountTypeId?: number;
    factor?: number | undefined;
    glAccountType?: GlAccountType | undefined;
    glActionType?: GlActionType | undefined;

    constructor(data?: IGlActionTypeGlAccountType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.glActionTypeId = _data["GlActionTypeId"];
            this.glAccountTypeId = _data["GlAccountTypeId"];
            this.factor = _data["Factor"];
            this.glAccountType = _data["GlAccountType"] ? GlAccountType.fromJS(_data["GlAccountType"]) : undefined as any;
            this.glActionType = _data["GlActionType"] ? GlActionType.fromJS(_data["GlActionType"]) : undefined as any;
        }
    }

    static fromJS(data: any): GlActionTypeGlAccountType {
        data = typeof data === 'object' ? data : {};
        let result = new GlActionTypeGlAccountType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["GlActionTypeId"] = this.glActionTypeId;
        data["GlAccountTypeId"] = this.glAccountTypeId;
        data["Factor"] = this.factor;
        data["GlAccountType"] = this.glAccountType ? this.glAccountType.toJSON() : undefined as any;
        data["GlActionType"] = this.glActionType ? this.glActionType.toJSON() : undefined as any;
        return data;
    }
}

export interface IGlActionTypeGlAccountType {
    id?: number;
    glActionTypeId?: number;
    glAccountTypeId?: number;
    factor?: number | undefined;
    glAccountType?: GlAccountType | undefined;
    glActionType?: GlActionType | undefined;
}

export class GlActionType implements IGlActionType {
    id?: number;
    name?: string | undefined;
    glActionTypeGlAccountTypes?: GlActionTypeGlAccountType[] | undefined;

    constructor(data?: IGlActionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            if (Array.isArray(_data["GlActionTypeGlAccountTypes"])) {
                this.glActionTypeGlAccountTypes = [] as any;
                for (let item of _data["GlActionTypeGlAccountTypes"])
                    this.glActionTypeGlAccountTypes!.push(GlActionTypeGlAccountType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlActionType {
        data = typeof data === 'object' ? data : {};
        let result = new GlActionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        if (Array.isArray(this.glActionTypeGlAccountTypes)) {
            data["GlActionTypeGlAccountTypes"] = [];
            for (let item of this.glActionTypeGlAccountTypes)
                data["GlActionTypeGlAccountTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGlActionType {
    id?: number;
    name?: string | undefined;
    glActionTypeGlAccountTypes?: GlActionTypeGlAccountType[] | undefined;
}

export class InstrumentsCategories implements IInstrumentsCategories {
    categoryId?: number;
    defaultCategoryId?: number | undefined;
    instrumentId?: number;
    category?: Category | undefined;
    defaultCategory?: Category | undefined;
    instrument?: Instrument | undefined;
    portion?: number;
    date?: string;

    constructor(data?: IInstrumentsCategories) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["CategoryId"];
            this.defaultCategoryId = _data["DefaultCategoryId"];
            this.instrumentId = _data["InstrumentId"];
            this.category = _data["Category"] ? Category.fromJS(_data["Category"]) : undefined as any;
            this.defaultCategory = _data["DefaultCategory"] ? Category.fromJS(_data["DefaultCategory"]) : undefined as any;
            this.instrument = _data["Instrument"] ? Instrument.fromJS(_data["Instrument"]) : undefined as any;
            this.portion = _data["Portion"];
            this.date = _data["Date"];
        }
    }

    static fromJS(data: any): InstrumentsCategories {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentsCategories();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CategoryId"] = this.categoryId;
        data["DefaultCategoryId"] = this.defaultCategoryId;
        data["InstrumentId"] = this.instrumentId;
        data["Category"] = this.category ? this.category.toJSON() : undefined as any;
        data["DefaultCategory"] = this.defaultCategory ? this.defaultCategory.toJSON() : undefined as any;
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["Portion"] = this.portion;
        data["Date"] = this.date;
        return data;
    }
}

export interface IInstrumentsCategories {
    categoryId?: number;
    defaultCategoryId?: number | undefined;
    instrumentId?: number;
    category?: Category | undefined;
    defaultCategory?: Category | undefined;
    instrument?: Instrument | undefined;
    portion?: number;
    date?: string;
}

export abstract class BaseState implements IBaseState {
    correlationId?: string;
    currentState?: string;
    created?: string;
    updated?: string | undefined;
    createdByEmail?: string;
    updatedByEmail?: string | undefined;

    constructor(data?: IBaseState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correlationId = _data["CorrelationId"];
            this.currentState = _data["CurrentState"];
            this.created = _data["Created"];
            this.updated = _data["Updated"];
            this.createdByEmail = _data["CreatedByEmail"];
            this.updatedByEmail = _data["UpdatedByEmail"];
        }
    }

    static fromJS(data: any): BaseState {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseState' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CorrelationId"] = this.correlationId;
        data["CurrentState"] = this.currentState;
        data["Created"] = this.created;
        data["Updated"] = this.updated;
        data["CreatedByEmail"] = this.createdByEmail;
        data["UpdatedByEmail"] = this.updatedByEmail;
        return data;
    }
}

export interface IBaseState {
    correlationId?: string;
    currentState?: string;
    created?: string;
    updated?: string | undefined;
    createdByEmail?: string;
    updatedByEmail?: string | undefined;
}

export abstract class CustomerBaseState extends BaseState implements ICustomerBaseState {
    companyIdentityId?: number;
    ignoreNotifyState?: boolean;

    constructor(data?: ICustomerBaseState) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.companyIdentityId = _data["CompanyIdentityId"];
            this.ignoreNotifyState = _data["IgnoreNotifyState"];
        }
    }

    static override fromJS(data: any): CustomerBaseState {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CustomerBaseState' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyIdentityId"] = this.companyIdentityId;
        data["IgnoreNotifyState"] = this.ignoreNotifyState;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomerBaseState extends IBaseState {
    companyIdentityId?: number;
    ignoreNotifyState?: boolean;
}

export class InstrumentTaxValueState extends CustomerBaseState implements IInstrumentTaxValueState {
    taxValue?: number;
    fromDate?: string;
    instrumentUuId?: string;
    instrumentId?: number | undefined;
    instrument?: Instrument | undefined;
    comment?: string | undefined;
    timestamp?: string;
    documents?: InstrumentTaxValueStateDocument[] | undefined;
    version?: number;

    constructor(data?: IInstrumentTaxValueState) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taxValue = _data["TaxValue"];
            this.fromDate = _data["FromDate"];
            this.instrumentUuId = _data["InstrumentUuId"];
            this.instrumentId = _data["InstrumentId"];
            this.instrument = _data["Instrument"] ? Instrument.fromJS(_data["Instrument"]) : undefined as any;
            this.comment = _data["Comment"];
            this.timestamp = _data["Timestamp"];
            if (Array.isArray(_data["Documents"])) {
                this.documents = [] as any;
                for (let item of _data["Documents"])
                    this.documents!.push(InstrumentTaxValueStateDocument.fromJS(item));
            }
            this.version = _data["Version"];
        }
    }

    static override fromJS(data: any): InstrumentTaxValueState {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentTaxValueState();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TaxValue"] = this.taxValue;
        data["FromDate"] = this.fromDate;
        data["InstrumentUuId"] = this.instrumentUuId;
        data["InstrumentId"] = this.instrumentId;
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["Comment"] = this.comment;
        data["Timestamp"] = this.timestamp;
        if (Array.isArray(this.documents)) {
            data["Documents"] = [];
            for (let item of this.documents)
                data["Documents"].push(item ? item.toJSON() : undefined as any);
        }
        data["Version"] = this.version;
        super.toJSON(data);
        return data;
    }
}

export interface IInstrumentTaxValueState extends ICustomerBaseState {
    taxValue?: number;
    fromDate?: string;
    instrumentUuId?: string;
    instrumentId?: number | undefined;
    instrument?: Instrument | undefined;
    comment?: string | undefined;
    timestamp?: string;
    documents?: InstrumentTaxValueStateDocument[] | undefined;
    version?: number;
}

export class InstrumentTaxValueStateDocument implements IInstrumentTaxValueStateDocument {
    id?: string;
    name?: string | undefined;
    contentType?: string | undefined;
    instrumentTaxValueStateId?: string;
    instrumentTaxValueState?: InstrumentTaxValueState | undefined;
    path?: string | undefined;
    created?: string;
    createdBy?: string | undefined;

    constructor(data?: IInstrumentTaxValueStateDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.contentType = _data["ContentType"];
            this.instrumentTaxValueStateId = _data["InstrumentTaxValueStateId"];
            this.instrumentTaxValueState = _data["InstrumentTaxValueState"] ? InstrumentTaxValueState.fromJS(_data["InstrumentTaxValueState"]) : undefined as any;
            this.path = _data["Path"];
            this.created = _data["Created"];
            this.createdBy = _data["CreatedBy"];
        }
    }

    static fromJS(data: any): InstrumentTaxValueStateDocument {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentTaxValueStateDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["ContentType"] = this.contentType;
        data["InstrumentTaxValueStateId"] = this.instrumentTaxValueStateId;
        data["InstrumentTaxValueState"] = this.instrumentTaxValueState ? this.instrumentTaxValueState.toJSON() : undefined as any;
        data["Path"] = this.path;
        data["Created"] = this.created;
        data["CreatedBy"] = this.createdBy;
        return data;
    }
}

export interface IInstrumentTaxValueStateDocument {
    id?: string;
    name?: string | undefined;
    contentType?: string | undefined;
    instrumentTaxValueStateId?: string;
    instrumentTaxValueState?: InstrumentTaxValueState | undefined;
    path?: string | undefined;
    created?: string;
    createdBy?: string | undefined;
}

export class InstrumentAccountingValueState extends CustomerBaseState implements IInstrumentAccountingValueState {
    accountingValue?: number;
    fromDate?: string;
    instrumentUuid?: string;
    instrument?: Instrument | undefined;
    comment?: string | undefined;
    timestamp?: string;
    documents?: InstrumentAccountingValueStateDocument[] | undefined;
    version?: number;

    constructor(data?: IInstrumentAccountingValueState) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountingValue = _data["AccountingValue"];
            this.fromDate = _data["FromDate"];
            this.instrumentUuid = _data["InstrumentUuid"];
            this.instrument = _data["Instrument"] ? Instrument.fromJS(_data["Instrument"]) : undefined as any;
            this.comment = _data["Comment"];
            this.timestamp = _data["Timestamp"];
            if (Array.isArray(_data["Documents"])) {
                this.documents = [] as any;
                for (let item of _data["Documents"])
                    this.documents!.push(InstrumentAccountingValueStateDocument.fromJS(item));
            }
            this.version = _data["Version"];
        }
    }

    static override fromJS(data: any): InstrumentAccountingValueState {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentAccountingValueState();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountingValue"] = this.accountingValue;
        data["FromDate"] = this.fromDate;
        data["InstrumentUuid"] = this.instrumentUuid;
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["Comment"] = this.comment;
        data["Timestamp"] = this.timestamp;
        if (Array.isArray(this.documents)) {
            data["Documents"] = [];
            for (let item of this.documents)
                data["Documents"].push(item ? item.toJSON() : undefined as any);
        }
        data["Version"] = this.version;
        super.toJSON(data);
        return data;
    }
}

export interface IInstrumentAccountingValueState extends ICustomerBaseState {
    accountingValue?: number;
    fromDate?: string;
    instrumentUuid?: string;
    instrument?: Instrument | undefined;
    comment?: string | undefined;
    timestamp?: string;
    documents?: InstrumentAccountingValueStateDocument[] | undefined;
    version?: number;
}

export class InstrumentAccountingValueStateDocument implements IInstrumentAccountingValueStateDocument {
    id?: string;
    name?: string | undefined;
    contentType?: string | undefined;
    instrumentAccountingValueStateId?: string;
    instrumentAccountingValueState?: InstrumentAccountingValueState | undefined;
    path?: string | undefined;
    created?: string;
    createdBy?: string | undefined;

    constructor(data?: IInstrumentAccountingValueStateDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.contentType = _data["ContentType"];
            this.instrumentAccountingValueStateId = _data["InstrumentAccountingValueStateId"];
            this.instrumentAccountingValueState = _data["InstrumentAccountingValueState"] ? InstrumentAccountingValueState.fromJS(_data["InstrumentAccountingValueState"]) : undefined as any;
            this.path = _data["Path"];
            this.created = _data["Created"];
            this.createdBy = _data["CreatedBy"];
        }
    }

    static fromJS(data: any): InstrumentAccountingValueStateDocument {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentAccountingValueStateDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["ContentType"] = this.contentType;
        data["InstrumentAccountingValueStateId"] = this.instrumentAccountingValueStateId;
        data["InstrumentAccountingValueState"] = this.instrumentAccountingValueState ? this.instrumentAccountingValueState.toJSON() : undefined as any;
        data["Path"] = this.path;
        data["Created"] = this.created;
        data["CreatedBy"] = this.createdBy;
        return data;
    }
}

export interface IInstrumentAccountingValueStateDocument {
    id?: string;
    name?: string | undefined;
    contentType?: string | undefined;
    instrumentAccountingValueStateId?: string;
    instrumentAccountingValueState?: InstrumentAccountingValueState | undefined;
    path?: string | undefined;
    created?: string;
    createdBy?: string | undefined;
}

export class InstrumentPrice implements IInstrumentPrice {
    id?: number;
    sellPrice?: number;
    instrumentCurrencyId?: number | undefined;
    instrumentCurrency?: InstrumentCurrency | undefined;
    sellPriceAdjusted?: number;
    fromDate?: string;
    toDate?: string | undefined;
    created?: string;
    createdById?: number | undefined;
    createdBy?: User | undefined;
    updated?: string | undefined;
    updatedById?: number | undefined;
    updatedBy?: User | undefined;
    comment?: string | undefined;
    instrumentId?: number | undefined;
    instrumentUuid?: string | undefined;
    instrument?: Instrument | undefined;
    manual?: boolean;
    excludeFromSplitMergeAdjustment?: boolean;
    lastAdjustmentDate?: string | undefined;
    documents?: InstrumentPriceDocument[] | undefined;

    constructor(data?: IInstrumentPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.sellPrice = _data["SellPrice"];
            this.instrumentCurrencyId = _data["InstrumentCurrencyId"];
            this.instrumentCurrency = _data["InstrumentCurrency"] ? InstrumentCurrency.fromJS(_data["InstrumentCurrency"]) : undefined as any;
            this.sellPriceAdjusted = _data["SellPriceAdjusted"];
            this.fromDate = _data["FromDate"];
            this.toDate = _data["ToDate"];
            this.created = _data["Created"];
            this.createdById = _data["CreatedById"];
            this.createdBy = _data["CreatedBy"] ? User.fromJS(_data["CreatedBy"]) : undefined as any;
            this.updated = _data["Updated"];
            this.updatedById = _data["UpdatedById"];
            this.updatedBy = _data["UpdatedBy"] ? User.fromJS(_data["UpdatedBy"]) : undefined as any;
            this.comment = _data["Comment"];
            this.instrumentId = _data["InstrumentId"];
            this.instrumentUuid = _data["InstrumentUuid"];
            this.instrument = _data["Instrument"] ? Instrument.fromJS(_data["Instrument"]) : undefined as any;
            this.manual = _data["Manual"];
            this.excludeFromSplitMergeAdjustment = _data["ExcludeFromSplitMergeAdjustment"];
            this.lastAdjustmentDate = _data["LastAdjustmentDate"];
            if (Array.isArray(_data["Documents"])) {
                this.documents = [] as any;
                for (let item of _data["Documents"])
                    this.documents!.push(InstrumentPriceDocument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstrumentPrice {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["SellPrice"] = this.sellPrice;
        data["InstrumentCurrencyId"] = this.instrumentCurrencyId;
        data["InstrumentCurrency"] = this.instrumentCurrency ? this.instrumentCurrency.toJSON() : undefined as any;
        data["SellPriceAdjusted"] = this.sellPriceAdjusted;
        data["FromDate"] = this.fromDate;
        data["ToDate"] = this.toDate;
        data["Created"] = this.created;
        data["CreatedById"] = this.createdById;
        data["CreatedBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["Updated"] = this.updated;
        data["UpdatedById"] = this.updatedById;
        data["UpdatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : undefined as any;
        data["Comment"] = this.comment;
        data["InstrumentId"] = this.instrumentId;
        data["InstrumentUuid"] = this.instrumentUuid;
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["Manual"] = this.manual;
        data["ExcludeFromSplitMergeAdjustment"] = this.excludeFromSplitMergeAdjustment;
        data["LastAdjustmentDate"] = this.lastAdjustmentDate;
        if (Array.isArray(this.documents)) {
            data["Documents"] = [];
            for (let item of this.documents)
                data["Documents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInstrumentPrice {
    id?: number;
    sellPrice?: number;
    instrumentCurrencyId?: number | undefined;
    instrumentCurrency?: InstrumentCurrency | undefined;
    sellPriceAdjusted?: number;
    fromDate?: string;
    toDate?: string | undefined;
    created?: string;
    createdById?: number | undefined;
    createdBy?: User | undefined;
    updated?: string | undefined;
    updatedById?: number | undefined;
    updatedBy?: User | undefined;
    comment?: string | undefined;
    instrumentId?: number | undefined;
    instrumentUuid?: string | undefined;
    instrument?: Instrument | undefined;
    manual?: boolean;
    excludeFromSplitMergeAdjustment?: boolean;
    lastAdjustmentDate?: string | undefined;
    documents?: InstrumentPriceDocument[] | undefined;
}

export class InstrumentPriceDocument implements IInstrumentPriceDocument {
    id?: string;
    name?: string | undefined;
    contentType?: string | undefined;
    instrumentPriceId?: number;
    instrumentPrice?: InstrumentPrice | undefined;
    path?: string | undefined;
    created?: string;
    createdBy?: string | undefined;

    constructor(data?: IInstrumentPriceDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.contentType = _data["ContentType"];
            this.instrumentPriceId = _data["InstrumentPriceId"];
            this.instrumentPrice = _data["InstrumentPrice"] ? InstrumentPrice.fromJS(_data["InstrumentPrice"]) : undefined as any;
            this.path = _data["Path"];
            this.created = _data["Created"];
            this.createdBy = _data["CreatedBy"];
        }
    }

    static fromJS(data: any): InstrumentPriceDocument {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentPriceDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["ContentType"] = this.contentType;
        data["InstrumentPriceId"] = this.instrumentPriceId;
        data["InstrumentPrice"] = this.instrumentPrice ? this.instrumentPrice.toJSON() : undefined as any;
        data["Path"] = this.path;
        data["Created"] = this.created;
        data["CreatedBy"] = this.createdBy;
        return data;
    }
}

export interface IInstrumentPriceDocument {
    id?: string;
    name?: string | undefined;
    contentType?: string | undefined;
    instrumentPriceId?: number;
    instrumentPrice?: InstrumentPrice | undefined;
    path?: string | undefined;
    created?: string;
    createdBy?: string | undefined;
}

export class BaseModel implements IBaseModel {
    id?: number;

    constructor(data?: IBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): BaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        return data;
    }
}

export interface IBaseModel {
    id?: number;
}

export class InstrumentTransaction extends BaseModel implements IInstrumentTransaction {
    transactionDate?: string;
    quantity?: number;
    amount?: number;
    created?: string;
    changed?: string;
    fee?: number;
    changedById?: number | undefined;
    createdById?: number | undefined;
    instrumentId?: number | undefined;
    instrumentUuid?: string | undefined;
    parentTransactionsId?: number | undefined;
    actionType?: ActionType;
    broker?: string | undefined;
    updateGl?: boolean;
    updatedGl?: boolean;
    canBeGlTransaction?: boolean;
    glTransactionStatus?: GlStatus;
    glRetractedStatus?: GlStatus;
    interests?: number;
    glStatusChangeDate?: string;
    counterTransactionId?: number | undefined;
    retracted?: string | undefined;
    updateGlFailedCount?: number;
    externalGeneralLedgerId?: string | undefined;
    voucherNr?: string | undefined;
    description?: string | undefined;
    currencyCode?: string | undefined;
    currencyAmount?: number | undefined;
    currencyId?: number | undefined;
    currencyInterests?: number | undefined;
    changedBy?: User | undefined;
    counterTransaction?: InstrumentTransaction | undefined;
    createdBy?: User | undefined;
    instrumentCurrency?: InstrumentCurrency | undefined;
    instrument?: Instrument | undefined;
    categorySecuritiesTransactions?: InstrumentTransactionsCategories[] | undefined;
    deprInverseCounterTransaction?: InstrumentTransaction[] | undefined;
    childTransactions?: InstrumentTransaction[] | undefined;
    legacyGlTransactions?: LegacyGlTransaction[] | undefined;
    instrumentTransactionGlTransactionLinesInsight?: InstrumentTransactionGlTransactionInsightLine[] | undefined;
    email?: string | undefined;
    externalDocumentId?: number | undefined;
    externalRowId?: number | undefined;
    documentId?: string | undefined;
    voucherId?: string | undefined;
    voucher?: VoucherState | undefined;
    dueDate?: string | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IInstrumentTransaction) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transactionDate = _data["TransactionDate"];
            this.quantity = _data["Quantity"];
            this.amount = _data["Amount"];
            this.created = _data["Created"];
            this.changed = _data["Changed"];
            this.fee = _data["Fee"];
            this.changedById = _data["ChangedById"];
            this.createdById = _data["CreatedById"];
            this.instrumentId = _data["InstrumentId"];
            this.instrumentUuid = _data["InstrumentUuid"];
            this.parentTransactionsId = _data["ParentTransactionsId"];
            this.actionType = _data["ActionType"];
            this.broker = _data["Broker"];
            this.updateGl = _data["UpdateGl"];
            this.updatedGl = _data["UpdatedGl"];
            this.canBeGlTransaction = _data["CanBeGlTransaction"];
            this.glTransactionStatus = _data["GlTransactionStatus"];
            this.glRetractedStatus = _data["GlRetractedStatus"];
            this.interests = _data["Interests"];
            this.glStatusChangeDate = _data["GlStatusChangeDate"];
            this.counterTransactionId = _data["CounterTransactionId"];
            this.retracted = _data["Retracted"];
            this.updateGlFailedCount = _data["UpdateGlFailedCount"];
            this.externalGeneralLedgerId = _data["ExternalGeneralLedgerId"];
            this.voucherNr = _data["VoucherNr"];
            this.description = _data["Description"];
            this.currencyCode = _data["CurrencyCode"];
            this.currencyAmount = _data["CurrencyAmount"];
            this.currencyId = _data["CurrencyId"];
            this.currencyInterests = _data["CurrencyInterests"];
            this.changedBy = _data["ChangedBy"] ? User.fromJS(_data["ChangedBy"]) : undefined as any;
            this.counterTransaction = _data["CounterTransaction"] ? InstrumentTransaction.fromJS(_data["CounterTransaction"]) : undefined as any;
            this.createdBy = _data["CreatedBy"] ? User.fromJS(_data["CreatedBy"]) : undefined as any;
            this.instrumentCurrency = _data["InstrumentCurrency"] ? InstrumentCurrency.fromJS(_data["InstrumentCurrency"]) : undefined as any;
            this.instrument = _data["Instrument"] ? Instrument.fromJS(_data["Instrument"]) : undefined as any;
            if (Array.isArray(_data["CategorySecuritiesTransactions"])) {
                this.categorySecuritiesTransactions = [] as any;
                for (let item of _data["CategorySecuritiesTransactions"])
                    this.categorySecuritiesTransactions!.push(InstrumentTransactionsCategories.fromJS(item));
            }
            if (Array.isArray(_data["DeprInverseCounterTransaction"])) {
                this.deprInverseCounterTransaction = [] as any;
                for (let item of _data["DeprInverseCounterTransaction"])
                    this.deprInverseCounterTransaction!.push(InstrumentTransaction.fromJS(item));
            }
            if (Array.isArray(_data["ChildTransactions"])) {
                this.childTransactions = [] as any;
                for (let item of _data["ChildTransactions"])
                    this.childTransactions!.push(InstrumentTransaction.fromJS(item));
            }
            if (Array.isArray(_data["LegacyGlTransactions"])) {
                this.legacyGlTransactions = [] as any;
                for (let item of _data["LegacyGlTransactions"])
                    this.legacyGlTransactions!.push(LegacyGlTransaction.fromJS(item));
            }
            if (Array.isArray(_data["InstrumentTransactionGlTransactionLinesInsight"])) {
                this.instrumentTransactionGlTransactionLinesInsight = [] as any;
                for (let item of _data["InstrumentTransactionGlTransactionLinesInsight"])
                    this.instrumentTransactionGlTransactionLinesInsight!.push(InstrumentTransactionGlTransactionInsightLine.fromJS(item));
            }
            this.email = _data["Email"];
            this.externalDocumentId = _data["ExternalDocumentId"];
            this.externalRowId = _data["ExternalRowId"];
            this.documentId = _data["DocumentId"];
            this.voucherId = _data["VoucherId"];
            this.voucher = _data["Voucher"] ? VoucherState.fromJS(_data["Voucher"]) : undefined as any;
            this.dueDate = _data["DueDate"];
            this.updatedBy = _data["UpdatedBy"];
        }
    }

    static override fromJS(data: any): InstrumentTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentTransaction();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TransactionDate"] = this.transactionDate;
        data["Quantity"] = this.quantity;
        data["Amount"] = this.amount;
        data["Created"] = this.created;
        data["Changed"] = this.changed;
        data["Fee"] = this.fee;
        data["ChangedById"] = this.changedById;
        data["CreatedById"] = this.createdById;
        data["InstrumentId"] = this.instrumentId;
        data["InstrumentUuid"] = this.instrumentUuid;
        data["ParentTransactionsId"] = this.parentTransactionsId;
        data["ActionType"] = this.actionType;
        data["Broker"] = this.broker;
        data["UpdateGl"] = this.updateGl;
        data["UpdatedGl"] = this.updatedGl;
        data["CanBeGlTransaction"] = this.canBeGlTransaction;
        data["GlTransactionStatus"] = this.glTransactionStatus;
        data["GlRetractedStatus"] = this.glRetractedStatus;
        data["Interests"] = this.interests;
        data["GlStatusChangeDate"] = this.glStatusChangeDate;
        data["CounterTransactionId"] = this.counterTransactionId;
        data["Retracted"] = this.retracted;
        data["UpdateGlFailedCount"] = this.updateGlFailedCount;
        data["ExternalGeneralLedgerId"] = this.externalGeneralLedgerId;
        data["VoucherNr"] = this.voucherNr;
        data["Description"] = this.description;
        data["CurrencyCode"] = this.currencyCode;
        data["CurrencyAmount"] = this.currencyAmount;
        data["CurrencyId"] = this.currencyId;
        data["CurrencyInterests"] = this.currencyInterests;
        data["ChangedBy"] = this.changedBy ? this.changedBy.toJSON() : undefined as any;
        data["CounterTransaction"] = this.counterTransaction ? this.counterTransaction.toJSON() : undefined as any;
        data["CreatedBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["InstrumentCurrency"] = this.instrumentCurrency ? this.instrumentCurrency.toJSON() : undefined as any;
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        if (Array.isArray(this.categorySecuritiesTransactions)) {
            data["CategorySecuritiesTransactions"] = [];
            for (let item of this.categorySecuritiesTransactions)
                data["CategorySecuritiesTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deprInverseCounterTransaction)) {
            data["DeprInverseCounterTransaction"] = [];
            for (let item of this.deprInverseCounterTransaction)
                data["DeprInverseCounterTransaction"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.childTransactions)) {
            data["ChildTransactions"] = [];
            for (let item of this.childTransactions)
                data["ChildTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.legacyGlTransactions)) {
            data["LegacyGlTransactions"] = [];
            for (let item of this.legacyGlTransactions)
                data["LegacyGlTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.instrumentTransactionGlTransactionLinesInsight)) {
            data["InstrumentTransactionGlTransactionLinesInsight"] = [];
            for (let item of this.instrumentTransactionGlTransactionLinesInsight)
                data["InstrumentTransactionGlTransactionLinesInsight"].push(item ? item.toJSON() : undefined as any);
        }
        data["Email"] = this.email;
        data["ExternalDocumentId"] = this.externalDocumentId;
        data["ExternalRowId"] = this.externalRowId;
        data["DocumentId"] = this.documentId;
        data["VoucherId"] = this.voucherId;
        data["Voucher"] = this.voucher ? this.voucher.toJSON() : undefined as any;
        data["DueDate"] = this.dueDate;
        data["UpdatedBy"] = this.updatedBy;
        super.toJSON(data);
        return data;
    }
}

export interface IInstrumentTransaction extends IBaseModel {
    transactionDate?: string;
    quantity?: number;
    amount?: number;
    created?: string;
    changed?: string;
    fee?: number;
    changedById?: number | undefined;
    createdById?: number | undefined;
    instrumentId?: number | undefined;
    instrumentUuid?: string | undefined;
    parentTransactionsId?: number | undefined;
    actionType?: ActionType;
    broker?: string | undefined;
    updateGl?: boolean;
    updatedGl?: boolean;
    canBeGlTransaction?: boolean;
    glTransactionStatus?: GlStatus;
    glRetractedStatus?: GlStatus;
    interests?: number;
    glStatusChangeDate?: string;
    counterTransactionId?: number | undefined;
    retracted?: string | undefined;
    updateGlFailedCount?: number;
    externalGeneralLedgerId?: string | undefined;
    voucherNr?: string | undefined;
    description?: string | undefined;
    currencyCode?: string | undefined;
    currencyAmount?: number | undefined;
    currencyId?: number | undefined;
    currencyInterests?: number | undefined;
    changedBy?: User | undefined;
    counterTransaction?: InstrumentTransaction | undefined;
    createdBy?: User | undefined;
    instrumentCurrency?: InstrumentCurrency | undefined;
    instrument?: Instrument | undefined;
    categorySecuritiesTransactions?: InstrumentTransactionsCategories[] | undefined;
    deprInverseCounterTransaction?: InstrumentTransaction[] | undefined;
    childTransactions?: InstrumentTransaction[] | undefined;
    legacyGlTransactions?: LegacyGlTransaction[] | undefined;
    instrumentTransactionGlTransactionLinesInsight?: InstrumentTransactionGlTransactionInsightLine[] | undefined;
    email?: string | undefined;
    externalDocumentId?: number | undefined;
    externalRowId?: number | undefined;
    documentId?: string | undefined;
    voucherId?: string | undefined;
    voucher?: VoucherState | undefined;
    dueDate?: string | undefined;
    updatedBy?: string | undefined;
}

export enum ActionType {
    Purchased = 0,
    Sold = 1,
    Profit = 2,
    Loss = 3,
    CostReduction = 4,
    Dividend = 5,
    Repayment = 6,
    RepaymentCostReduction = 7,
    RepaymentCostReductionForSale = 8,
    ReceivedInterest = 9,
    PurchaseInterest = 10,
    SoldInterest = 11,
    CapitalIncrease = 16,
    CapitalIncreaseCostReduction = 17,
    CapitalIncreaseCostReductionForSale = 18,
    SplitOrMerge = 25,
    ShortSale = 30,
    ShortPurchased = 31,
    ShortProfit = 32,
    ShortLoss = 33,
    ShortCostReduction = 34,
    InstrumentLoan = 38,
    AverageProfit = 42,
    AverageLoss = 43,
    AverageCostReduction = 44,
    AverageRepaymentCostReductionForSale = 48,
    AverageShortProfit = 52,
    AverageShortLoss = 53,
    AverageShortCostReduction = 54,
    AverageCapitalIncreaseCostReductionForSale = 58,
    FundSwitchPurchase = 60,
    FundSwitchSale = 61,
    FundSwitchPurchaseInterest = 62,
    FundSwitchSaleInterest = 63,
    WithholdingTax = 65,
    FundClassSwitchPurchase = 70,
    FundClassSwitchSale = 71,
}

export enum GlStatus {
    None = 0,
    Created = 1,
    Sent = 2,
    Posted = 3,
    Queued = 4,
}

export class InstrumentTransactionsCategories implements IInstrumentTransactionsCategories {
    categoryId?: number;
    securitiesTransactionId?: number;
    category?: Category | undefined;
    instrumentTransaction?: InstrumentTransaction | undefined;

    constructor(data?: IInstrumentTransactionsCategories) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["CategoryId"];
            this.securitiesTransactionId = _data["SecuritiesTransactionId"];
            this.category = _data["Category"] ? Category.fromJS(_data["Category"]) : undefined as any;
            this.instrumentTransaction = _data["InstrumentTransaction"] ? InstrumentTransaction.fromJS(_data["InstrumentTransaction"]) : undefined as any;
        }
    }

    static fromJS(data: any): InstrumentTransactionsCategories {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentTransactionsCategories();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CategoryId"] = this.categoryId;
        data["SecuritiesTransactionId"] = this.securitiesTransactionId;
        data["Category"] = this.category ? this.category.toJSON() : undefined as any;
        data["InstrumentTransaction"] = this.instrumentTransaction ? this.instrumentTransaction.toJSON() : undefined as any;
        return data;
    }
}

export interface IInstrumentTransactionsCategories {
    categoryId?: number;
    securitiesTransactionId?: number;
    category?: Category | undefined;
    instrumentTransaction?: InstrumentTransaction | undefined;
}

export class LegacyGlTransaction implements ILegacyGlTransaction {
    id?: number;
    description?: string | undefined;
    date?: string;
    externalVoucherNr?: string | undefined;
    externalVoucherId?: string | undefined;
    externalImportId?: string | undefined;
    savedGl?: string | undefined;
    postedGl?: string | undefined;
    created?: string;
    createdById?: number | undefined;
    securitiesTransactionId?: number | undefined;
    createdBy?: User | undefined;
    glTransactionLines?: LegacyGlTransactionLine[] | undefined;
    securitiesTransactions?: InstrumentTransaction[] | undefined;

    constructor(data?: ILegacyGlTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.description = _data["Description"];
            this.date = _data["Date"];
            this.externalVoucherNr = _data["ExternalVoucherNr"];
            this.externalVoucherId = _data["ExternalVoucherId"];
            this.externalImportId = _data["ExternalImportId"];
            this.savedGl = _data["SavedGl"];
            this.postedGl = _data["PostedGl"];
            this.created = _data["Created"];
            this.createdById = _data["CreatedById"];
            this.securitiesTransactionId = _data["SecuritiesTransactionId"];
            this.createdBy = _data["CreatedBy"] ? User.fromJS(_data["CreatedBy"]) : undefined as any;
            if (Array.isArray(_data["GlTransactionLines"])) {
                this.glTransactionLines = [] as any;
                for (let item of _data["GlTransactionLines"])
                    this.glTransactionLines!.push(LegacyGlTransactionLine.fromJS(item));
            }
            if (Array.isArray(_data["SecuritiesTransactions"])) {
                this.securitiesTransactions = [] as any;
                for (let item of _data["SecuritiesTransactions"])
                    this.securitiesTransactions!.push(InstrumentTransaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LegacyGlTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new LegacyGlTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Description"] = this.description;
        data["Date"] = this.date;
        data["ExternalVoucherNr"] = this.externalVoucherNr;
        data["ExternalVoucherId"] = this.externalVoucherId;
        data["ExternalImportId"] = this.externalImportId;
        data["SavedGl"] = this.savedGl;
        data["PostedGl"] = this.postedGl;
        data["Created"] = this.created;
        data["CreatedById"] = this.createdById;
        data["SecuritiesTransactionId"] = this.securitiesTransactionId;
        data["CreatedBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        if (Array.isArray(this.glTransactionLines)) {
            data["GlTransactionLines"] = [];
            for (let item of this.glTransactionLines)
                data["GlTransactionLines"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.securitiesTransactions)) {
            data["SecuritiesTransactions"] = [];
            for (let item of this.securitiesTransactions)
                data["SecuritiesTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILegacyGlTransaction {
    id?: number;
    description?: string | undefined;
    date?: string;
    externalVoucherNr?: string | undefined;
    externalVoucherId?: string | undefined;
    externalImportId?: string | undefined;
    savedGl?: string | undefined;
    postedGl?: string | undefined;
    created?: string;
    createdById?: number | undefined;
    securitiesTransactionId?: number | undefined;
    createdBy?: User | undefined;
    glTransactionLines?: LegacyGlTransactionLine[] | undefined;
    securitiesTransactions?: InstrumentTransaction[] | undefined;
}

export class LegacyGlTransactionLine implements ILegacyGlTransactionLine {
    id?: number;
    accountNumber?: number;
    amount?: number;
    documentDate?: string;
    postingDate?: string;
    vatCode?: string | undefined;
    glTransactionId?: number | undefined;
    legacyGlTransaction?: LegacyGlTransaction | undefined;

    constructor(data?: ILegacyGlTransactionLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.accountNumber = _data["AccountNumber"];
            this.amount = _data["Amount"];
            this.documentDate = _data["DocumentDate"];
            this.postingDate = _data["PostingDate"];
            this.vatCode = _data["VatCode"];
            this.glTransactionId = _data["GlTransactionId"];
            this.legacyGlTransaction = _data["LegacyGlTransaction"] ? LegacyGlTransaction.fromJS(_data["LegacyGlTransaction"]) : undefined as any;
        }
    }

    static fromJS(data: any): LegacyGlTransactionLine {
        data = typeof data === 'object' ? data : {};
        let result = new LegacyGlTransactionLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["AccountNumber"] = this.accountNumber;
        data["Amount"] = this.amount;
        data["DocumentDate"] = this.documentDate;
        data["PostingDate"] = this.postingDate;
        data["VatCode"] = this.vatCode;
        data["GlTransactionId"] = this.glTransactionId;
        data["LegacyGlTransaction"] = this.legacyGlTransaction ? this.legacyGlTransaction.toJSON() : undefined as any;
        return data;
    }
}

export interface ILegacyGlTransactionLine {
    id?: number;
    accountNumber?: number;
    amount?: number;
    documentDate?: string;
    postingDate?: string;
    vatCode?: string | undefined;
    glTransactionId?: number | undefined;
    legacyGlTransaction?: LegacyGlTransaction | undefined;
}

export class InstrumentTransactionGlTransactionInsightLine implements IInstrumentTransactionGlTransactionInsightLine {
    id?: number;
    glTransactionType?: GlTransactionType;
    instrumentTransactionId?: number;
    instrumentTransaction?: InstrumentTransaction | undefined;
    glTransactionInsightLineId?: number;
    glTransactionInsightLine?: GlTransactionInsightLine | undefined;

    constructor(data?: IInstrumentTransactionGlTransactionInsightLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.glTransactionType = _data["GlTransactionType"];
            this.instrumentTransactionId = _data["InstrumentTransactionId"];
            this.instrumentTransaction = _data["InstrumentTransaction"] ? InstrumentTransaction.fromJS(_data["InstrumentTransaction"]) : undefined as any;
            this.glTransactionInsightLineId = _data["GlTransactionInsightLineId"];
            this.glTransactionInsightLine = _data["GlTransactionInsightLine"] ? GlTransactionInsightLine.fromJS(_data["GlTransactionInsightLine"]) : undefined as any;
        }
    }

    static fromJS(data: any): InstrumentTransactionGlTransactionInsightLine {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentTransactionGlTransactionInsightLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["GlTransactionType"] = this.glTransactionType;
        data["InstrumentTransactionId"] = this.instrumentTransactionId;
        data["InstrumentTransaction"] = this.instrumentTransaction ? this.instrumentTransaction.toJSON() : undefined as any;
        data["GlTransactionInsightLineId"] = this.glTransactionInsightLineId;
        data["GlTransactionInsightLine"] = this.glTransactionInsightLine ? this.glTransactionInsightLine.toJSON() : undefined as any;
        return data;
    }
}

export interface IInstrumentTransactionGlTransactionInsightLine {
    id?: number;
    glTransactionType?: GlTransactionType;
    instrumentTransactionId?: number;
    instrumentTransaction?: InstrumentTransaction | undefined;
    glTransactionInsightLineId?: number;
    glTransactionInsightLine?: GlTransactionInsightLine | undefined;
}

export enum GlTransactionType {
    Standard = 1,
    Retract = 2,
}

export class GlTransactionInsightLine extends BaseModel implements IGlTransactionInsightLine {
    accountNumber?: number;
    glAccountType?: AccountType;
    amount?: number;
    currencyAmount?: number;
    currencyCode?: string | undefined;
    documentDate?: string;
    postingDate?: string;
    vatCode?: string | undefined;
    glTransactionInsightId?: number | undefined;
    glTransactionInsight?: GlTransactionInsight | undefined;
    instrumentTransactions?: InstrumentTransactionGlTransactionInsightLine[] | undefined;

    constructor(data?: IGlTransactionInsightLine) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountNumber = _data["AccountNumber"];
            this.glAccountType = _data["GlAccountType"];
            this.amount = _data["Amount"];
            this.currencyAmount = _data["CurrencyAmount"];
            this.currencyCode = _data["CurrencyCode"];
            this.documentDate = _data["DocumentDate"];
            this.postingDate = _data["PostingDate"];
            this.vatCode = _data["VatCode"];
            this.glTransactionInsightId = _data["GlTransactionInsightId"];
            this.glTransactionInsight = _data["GlTransactionInsight"] ? GlTransactionInsight.fromJS(_data["GlTransactionInsight"]) : undefined as any;
            if (Array.isArray(_data["InstrumentTransactions"])) {
                this.instrumentTransactions = [] as any;
                for (let item of _data["InstrumentTransactions"])
                    this.instrumentTransactions!.push(InstrumentTransactionGlTransactionInsightLine.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GlTransactionInsightLine {
        data = typeof data === 'object' ? data : {};
        let result = new GlTransactionInsightLine();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountNumber"] = this.accountNumber;
        data["GlAccountType"] = this.glAccountType;
        data["Amount"] = this.amount;
        data["CurrencyAmount"] = this.currencyAmount;
        data["CurrencyCode"] = this.currencyCode;
        data["DocumentDate"] = this.documentDate;
        data["PostingDate"] = this.postingDate;
        data["VatCode"] = this.vatCode;
        data["GlTransactionInsightId"] = this.glTransactionInsightId;
        data["GlTransactionInsight"] = this.glTransactionInsight ? this.glTransactionInsight.toJSON() : undefined as any;
        if (Array.isArray(this.instrumentTransactions)) {
            data["InstrumentTransactions"] = [];
            for (let item of this.instrumentTransactions)
                data["InstrumentTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGlTransactionInsightLine extends IBaseModel {
    accountNumber?: number;
    glAccountType?: AccountType;
    amount?: number;
    currencyAmount?: number;
    currencyCode?: string | undefined;
    documentDate?: string;
    postingDate?: string;
    vatCode?: string | undefined;
    glTransactionInsightId?: number | undefined;
    glTransactionInsight?: GlTransactionInsight | undefined;
    instrumentTransactions?: InstrumentTransactionGlTransactionInsightLine[] | undefined;
}

export enum AccountType {
    Unknown = 0,
    Bank = 1,
    Securities = 2,
    Profit = 3,
    Loss = 4,
    Dividend = 6,
    Repayment = 7,
    Interest = 8,
    InstrumentLoan = 9,
    WithholdingTax = 10,
    FundSwitch = 11,
}

export class GlTransactionInsight extends BaseModel implements IGlTransactionInsight {
    voucherId?: string | undefined;
    companyIdentityId?: number | undefined;
    retractedTransaction?: GlTransactionInsight | undefined;
    originalTransactionId?: number | undefined;
    originalTransaction?: GlTransactionInsight | undefined;
    description?: string | undefined;
    date?: string;
    externalVoucherNr?: string | undefined;
    externalVoucherId?: string | undefined;
    externalImportId?: string | undefined;
    savedGl?: string | undefined;
    postedGl?: string | undefined;
    created?: string;
    glDocumentStatus?: GlDocumentStatus;
    documentPostedDate?: string;
    documentFailedDate?: string;
    glTransactionStatus?: GlStatus;
    createdById?: number | undefined;
    createdBy?: User | undefined;
    source?: GlTransactionInsightSource;
    glTransactionInsightLines?: GlTransactionInsightLine[] | undefined;

    constructor(data?: IGlTransactionInsight) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voucherId = _data["VoucherId"];
            this.companyIdentityId = _data["CompanyIdentityId"];
            this.retractedTransaction = _data["RetractedTransaction"] ? GlTransactionInsight.fromJS(_data["RetractedTransaction"]) : undefined as any;
            this.originalTransactionId = _data["OriginalTransactionId"];
            this.originalTransaction = _data["OriginalTransaction"] ? GlTransactionInsight.fromJS(_data["OriginalTransaction"]) : undefined as any;
            this.description = _data["Description"];
            this.date = _data["Date"];
            this.externalVoucherNr = _data["ExternalVoucherNr"];
            this.externalVoucherId = _data["ExternalVoucherId"];
            this.externalImportId = _data["ExternalImportId"];
            this.savedGl = _data["SavedGl"];
            this.postedGl = _data["PostedGl"];
            this.created = _data["Created"];
            this.glDocumentStatus = _data["GlDocumentStatus"];
            this.documentPostedDate = _data["DocumentPostedDate"];
            this.documentFailedDate = _data["DocumentFailedDate"];
            this.glTransactionStatus = _data["GlTransactionStatus"];
            this.createdById = _data["CreatedById"];
            this.createdBy = _data["CreatedBy"] ? User.fromJS(_data["CreatedBy"]) : undefined as any;
            this.source = _data["Source"];
            if (Array.isArray(_data["GlTransactionInsightLines"])) {
                this.glTransactionInsightLines = [] as any;
                for (let item of _data["GlTransactionInsightLines"])
                    this.glTransactionInsightLines!.push(GlTransactionInsightLine.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): GlTransactionInsight {
        data = typeof data === 'object' ? data : {};
        let result = new GlTransactionInsight();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VoucherId"] = this.voucherId;
        data["CompanyIdentityId"] = this.companyIdentityId;
        data["RetractedTransaction"] = this.retractedTransaction ? this.retractedTransaction.toJSON() : undefined as any;
        data["OriginalTransactionId"] = this.originalTransactionId;
        data["OriginalTransaction"] = this.originalTransaction ? this.originalTransaction.toJSON() : undefined as any;
        data["Description"] = this.description;
        data["Date"] = this.date;
        data["ExternalVoucherNr"] = this.externalVoucherNr;
        data["ExternalVoucherId"] = this.externalVoucherId;
        data["ExternalImportId"] = this.externalImportId;
        data["SavedGl"] = this.savedGl;
        data["PostedGl"] = this.postedGl;
        data["Created"] = this.created;
        data["GlDocumentStatus"] = this.glDocumentStatus;
        data["DocumentPostedDate"] = this.documentPostedDate;
        data["DocumentFailedDate"] = this.documentFailedDate;
        data["GlTransactionStatus"] = this.glTransactionStatus;
        data["CreatedById"] = this.createdById;
        data["CreatedBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["Source"] = this.source;
        if (Array.isArray(this.glTransactionInsightLines)) {
            data["GlTransactionInsightLines"] = [];
            for (let item of this.glTransactionInsightLines)
                data["GlTransactionInsightLines"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGlTransactionInsight extends IBaseModel {
    voucherId?: string | undefined;
    companyIdentityId?: number | undefined;
    retractedTransaction?: GlTransactionInsight | undefined;
    originalTransactionId?: number | undefined;
    originalTransaction?: GlTransactionInsight | undefined;
    description?: string | undefined;
    date?: string;
    externalVoucherNr?: string | undefined;
    externalVoucherId?: string | undefined;
    externalImportId?: string | undefined;
    savedGl?: string | undefined;
    postedGl?: string | undefined;
    created?: string;
    glDocumentStatus?: GlDocumentStatus;
    documentPostedDate?: string;
    documentFailedDate?: string;
    glTransactionStatus?: GlStatus;
    createdById?: number | undefined;
    createdBy?: User | undefined;
    source?: GlTransactionInsightSource;
    glTransactionInsightLines?: GlTransactionInsightLine[] | undefined;
}

export enum GlDocumentStatus {
    Unknown = 0,
    QueuedForPosting = 1,
    Retrieved = 2,
    Posted = 3,
    Failed = -1,
}

export enum GlTransactionInsightSource {
    System = 0,
    Reconciliation = 1,
}

export class VoucherState implements IVoucherState {
    correlationId?: string;
    companyIdentityId?: number;
    documentId?: string;
    documentPath?: string | undefined;
    currentState?: VoucherStateMachineStatus;
    previousState?: string | undefined;
    documentStorageType?: DocumentStorageType | undefined;
    fileType?: FileTypes;
    duplicateOfVoucherId?: string | undefined;
    createdBy?: string | undefined;
    updatedAt?: string | undefined;
    updatedBy?: string | undefined;
    brokerFee?: number | undefined;
    brokerFeeCurrencyAmount?: number | undefined;
    brokerFeeCurrencyCode?: string | undefined;
    description?: string | undefined;
    exchangeRate?: number | undefined;
    bankAccountId?: number | undefined;
    vpsAccountId?: number | undefined;
    portfolioId?: number | undefined;
    parsedBankAccount?: string | undefined;
    parsedVpsAccount?: string | undefined;
    parsedPortfolioAccount?: string | undefined;
    parsedCustomerId?: string | undefined;
    settlementAmount?: number | undefined;
    settlementAmountCurrency?: number | undefined;
    settlementAmountCurrencyCode?: string | undefined;
    settlementDate?: string | undefined;
    totalAmount?: number | undefined;
    totalAmountCurrency?: number | undefined;
    totalAmountCurrencyCode?: string | undefined;
    totalQuantity?: number | undefined;
    tradeDate?: string | undefined;
    transactionComment?: string | undefined;
    broker?: string | undefined;
    voucherNr?: string | undefined;
    activityType?: string | undefined;
    importedInstrumentCurrencyCode?: string | undefined;
    isin?: string | undefined;
    multipleInstrumentMatches?: boolean;
    orgNr?: string | undefined;
    rowId?: number | undefined;
    sourceActivityType?: string | undefined;
    ticker?: string | undefined;
    instrumentName?: string | undefined;
    importedInstrumentTypeId?: number | undefined;
    unknownActivityType?: boolean;
    instrumentId?: string | undefined;
    instrument?: Instrument | undefined;
    splitMergeFactor?: number | undefined;
    interest?: number | undefined;
    currencyInterests?: number | undefined;
    dueDate?: string | undefined;
    externalVoucherNr?: string | undefined;
    externalVoucherId?: string | undefined;
    externalImportId?: string | undefined;
    externalRectractVoucherNr?: string | undefined;
    externalRectractVoucherId?: string | undefined;
    externalRectractImportId?: string | undefined;
    processingFailedReason?: string | undefined;
    creatingGlFailedReason?: string | undefined;
    sendingGlFailedReason?: string | undefined;
    glDocumentUploadFailedReason?: string | undefined;
    retractingFailedReason?: string | undefined;
    customerGlAccountIds?: string | undefined;
    items?: VoucherItem[] | undefined;
    flaggedFields?: FlaggedField[] | undefined;
    version?: number;
    createVoucherInstrumentRequestId?: string | undefined;
    archiveReason?: ArchiveReason;
    duplicateStatus?: VoucherDuplicateStatus;
    processVoucherRequestId?: string | undefined;
    lookupAvailableInstrumentId?: string | undefined;
    createVoucherResponseEndpoint?: string | undefined;
    createVoucherRequestId?: string | undefined;
    voucherValidationStatus?: VoucherValidationStatus;
    startCreatingVoucherGlTransactionsRequestId?: string | undefined;
    startCreatingVoucherGlTransactionsResponseAddress?: string | undefined;
    batchJobId?: string | undefined;
    retractVoucherAndCreateGlRequestId?: string | undefined;
    retractVoucherAndDeleteGlRequestId?: string | undefined;
    createVoucherGlTransactionsRequestId?: string | undefined;
    sendingVoucherGlTransactionsTimeoutTokenId?: string | undefined;
    ignoreNotifyState?: boolean;
    retractedVoucherId?: string | undefined;
    countOfTransactionsThatCanHaveGlTransactions?: number | undefined;
    sendGlTransactionsJobId?: string | undefined;
    sendGlRetractTransactionsJobId?: string | undefined;
    sendGlTransactionsTraceParent?: string | undefined;
    sendGlRetractTransactionsTraceParent?: string | undefined;
    pastVoucherNr?: string | undefined;
    postingOverrideDate?: string | undefined;
    notificationStep?: NotificationStep | undefined;
    isUpvProcessed?: boolean;

    constructor(data?: IVoucherState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correlationId = _data["CorrelationId"];
            this.companyIdentityId = _data["CompanyIdentityId"];
            this.documentId = _data["DocumentId"];
            this.documentPath = _data["DocumentPath"];
            this.currentState = _data["CurrentState"];
            this.previousState = _data["PreviousState"];
            this.documentStorageType = _data["DocumentStorageType"];
            this.fileType = _data["FileType"];
            this.duplicateOfVoucherId = _data["DuplicateOfVoucherId"];
            this.createdBy = _data["CreatedBy"];
            this.updatedAt = _data["UpdatedAt"];
            this.updatedBy = _data["UpdatedBy"];
            this.brokerFee = _data["BrokerFee"];
            this.brokerFeeCurrencyAmount = _data["BrokerFeeCurrencyAmount"];
            this.brokerFeeCurrencyCode = _data["BrokerFeeCurrencyCode"];
            this.description = _data["Description"];
            this.exchangeRate = _data["ExchangeRate"];
            this.bankAccountId = _data["BankAccountId"];
            this.vpsAccountId = _data["VpsAccountId"];
            this.portfolioId = _data["PortfolioId"];
            this.parsedBankAccount = _data["ParsedBankAccount"];
            this.parsedVpsAccount = _data["ParsedVpsAccount"];
            this.parsedPortfolioAccount = _data["ParsedPortfolioAccount"];
            this.parsedCustomerId = _data["ParsedCustomerId"];
            this.settlementAmount = _data["SettlementAmount"];
            this.settlementAmountCurrency = _data["SettlementAmountCurrency"];
            this.settlementAmountCurrencyCode = _data["SettlementAmountCurrencyCode"];
            this.settlementDate = _data["SettlementDate"];
            this.totalAmount = _data["TotalAmount"];
            this.totalAmountCurrency = _data["TotalAmountCurrency"];
            this.totalAmountCurrencyCode = _data["TotalAmountCurrencyCode"];
            this.totalQuantity = _data["TotalQuantity"];
            this.tradeDate = _data["TradeDate"];
            this.transactionComment = _data["TransactionComment"];
            this.broker = _data["Broker"];
            this.voucherNr = _data["VoucherNr"];
            this.activityType = _data["ActivityType"];
            this.importedInstrumentCurrencyCode = _data["ImportedInstrumentCurrencyCode"];
            this.isin = _data["Isin"];
            this.multipleInstrumentMatches = _data["MultipleInstrumentMatches"];
            this.orgNr = _data["OrgNr"];
            this.rowId = _data["RowId"];
            this.sourceActivityType = _data["SourceActivityType"];
            this.ticker = _data["Ticker"];
            this.instrumentName = _data["InstrumentName"];
            this.importedInstrumentTypeId = _data["ImportedInstrumentTypeId"];
            this.unknownActivityType = _data["UnknownActivityType"];
            this.instrumentId = _data["InstrumentId"];
            this.instrument = _data["Instrument"] ? Instrument.fromJS(_data["Instrument"]) : undefined as any;
            this.splitMergeFactor = _data["SplitMergeFactor"];
            this.interest = _data["Interest"];
            this.currencyInterests = _data["CurrencyInterests"];
            this.dueDate = _data["DueDate"];
            this.externalVoucherNr = _data["ExternalVoucherNr"];
            this.externalVoucherId = _data["ExternalVoucherId"];
            this.externalImportId = _data["ExternalImportId"];
            this.externalRectractVoucherNr = _data["ExternalRectractVoucherNr"];
            this.externalRectractVoucherId = _data["ExternalRectractVoucherId"];
            this.externalRectractImportId = _data["ExternalRectractImportId"];
            this.processingFailedReason = _data["ProcessingFailedReason"];
            this.creatingGlFailedReason = _data["CreatingGlFailedReason"];
            this.sendingGlFailedReason = _data["SendingGlFailedReason"];
            this.glDocumentUploadFailedReason = _data["GlDocumentUploadFailedReason"];
            this.retractingFailedReason = _data["RetractingFailedReason"];
            this.customerGlAccountIds = _data["CustomerGlAccountIds"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(VoucherItem.fromJS(item));
            }
            if (Array.isArray(_data["FlaggedFields"])) {
                this.flaggedFields = [] as any;
                for (let item of _data["FlaggedFields"])
                    this.flaggedFields!.push(FlaggedField.fromJS(item));
            }
            this.version = _data["Version"];
            this.createVoucherInstrumentRequestId = _data["CreateVoucherInstrumentRequestId"];
            this.archiveReason = _data["ArchiveReason"];
            this.duplicateStatus = _data["DuplicateStatus"];
            this.processVoucherRequestId = _data["ProcessVoucherRequestId"];
            this.lookupAvailableInstrumentId = _data["LookupAvailableInstrumentId"];
            this.createVoucherResponseEndpoint = _data["CreateVoucherResponseEndpoint"];
            this.createVoucherRequestId = _data["CreateVoucherRequestId"];
            this.voucherValidationStatus = _data["VoucherValidationStatus"];
            this.startCreatingVoucherGlTransactionsRequestId = _data["StartCreatingVoucherGlTransactionsRequestId"];
            this.startCreatingVoucherGlTransactionsResponseAddress = _data["StartCreatingVoucherGlTransactionsResponseAddress"];
            this.batchJobId = _data["BatchJobId"];
            this.retractVoucherAndCreateGlRequestId = _data["RetractVoucherAndCreateGlRequestId"];
            this.retractVoucherAndDeleteGlRequestId = _data["RetractVoucherAndDeleteGlRequestId"];
            this.createVoucherGlTransactionsRequestId = _data["CreateVoucherGlTransactionsRequestId"];
            this.sendingVoucherGlTransactionsTimeoutTokenId = _data["SendingVoucherGlTransactionsTimeoutTokenId"];
            this.ignoreNotifyState = _data["IgnoreNotifyState"];
            this.retractedVoucherId = _data["RetractedVoucherId"];
            this.countOfTransactionsThatCanHaveGlTransactions = _data["CountOfTransactionsThatCanHaveGlTransactions"];
            this.sendGlTransactionsJobId = _data["SendGlTransactionsJobId"];
            this.sendGlRetractTransactionsJobId = _data["SendGlRetractTransactionsJobId"];
            this.sendGlTransactionsTraceParent = _data["SendGlTransactionsTraceParent"];
            this.sendGlRetractTransactionsTraceParent = _data["SendGlRetractTransactionsTraceParent"];
            this.pastVoucherNr = _data["PastVoucherNr"];
            this.postingOverrideDate = _data["PostingOverrideDate"];
            this.notificationStep = _data["NotificationStep"] ? NotificationStep.fromJS(_data["NotificationStep"]) : undefined as any;
            this.isUpvProcessed = _data["IsUpvProcessed"];
        }
    }

    static fromJS(data: any): VoucherState {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CorrelationId"] = this.correlationId;
        data["CompanyIdentityId"] = this.companyIdentityId;
        data["DocumentId"] = this.documentId;
        data["DocumentPath"] = this.documentPath;
        data["CurrentState"] = this.currentState;
        data["PreviousState"] = this.previousState;
        data["DocumentStorageType"] = this.documentStorageType;
        data["FileType"] = this.fileType;
        data["DuplicateOfVoucherId"] = this.duplicateOfVoucherId;
        data["CreatedBy"] = this.createdBy;
        data["UpdatedAt"] = this.updatedAt;
        data["UpdatedBy"] = this.updatedBy;
        data["BrokerFee"] = this.brokerFee;
        data["BrokerFeeCurrencyAmount"] = this.brokerFeeCurrencyAmount;
        data["BrokerFeeCurrencyCode"] = this.brokerFeeCurrencyCode;
        data["Description"] = this.description;
        data["ExchangeRate"] = this.exchangeRate;
        data["BankAccountId"] = this.bankAccountId;
        data["VpsAccountId"] = this.vpsAccountId;
        data["PortfolioId"] = this.portfolioId;
        data["ParsedBankAccount"] = this.parsedBankAccount;
        data["ParsedVpsAccount"] = this.parsedVpsAccount;
        data["ParsedPortfolioAccount"] = this.parsedPortfolioAccount;
        data["ParsedCustomerId"] = this.parsedCustomerId;
        data["SettlementAmount"] = this.settlementAmount;
        data["SettlementAmountCurrency"] = this.settlementAmountCurrency;
        data["SettlementAmountCurrencyCode"] = this.settlementAmountCurrencyCode;
        data["SettlementDate"] = this.settlementDate;
        data["TotalAmount"] = this.totalAmount;
        data["TotalAmountCurrency"] = this.totalAmountCurrency;
        data["TotalAmountCurrencyCode"] = this.totalAmountCurrencyCode;
        data["TotalQuantity"] = this.totalQuantity;
        data["TradeDate"] = this.tradeDate;
        data["TransactionComment"] = this.transactionComment;
        data["Broker"] = this.broker;
        data["VoucherNr"] = this.voucherNr;
        data["ActivityType"] = this.activityType;
        data["ImportedInstrumentCurrencyCode"] = this.importedInstrumentCurrencyCode;
        data["Isin"] = this.isin;
        data["MultipleInstrumentMatches"] = this.multipleInstrumentMatches;
        data["OrgNr"] = this.orgNr;
        data["RowId"] = this.rowId;
        data["SourceActivityType"] = this.sourceActivityType;
        data["Ticker"] = this.ticker;
        data["InstrumentName"] = this.instrumentName;
        data["ImportedInstrumentTypeId"] = this.importedInstrumentTypeId;
        data["UnknownActivityType"] = this.unknownActivityType;
        data["InstrumentId"] = this.instrumentId;
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["SplitMergeFactor"] = this.splitMergeFactor;
        data["Interest"] = this.interest;
        data["CurrencyInterests"] = this.currencyInterests;
        data["DueDate"] = this.dueDate;
        data["ExternalVoucherNr"] = this.externalVoucherNr;
        data["ExternalVoucherId"] = this.externalVoucherId;
        data["ExternalImportId"] = this.externalImportId;
        data["ExternalRectractVoucherNr"] = this.externalRectractVoucherNr;
        data["ExternalRectractVoucherId"] = this.externalRectractVoucherId;
        data["ExternalRectractImportId"] = this.externalRectractImportId;
        data["ProcessingFailedReason"] = this.processingFailedReason;
        data["CreatingGlFailedReason"] = this.creatingGlFailedReason;
        data["SendingGlFailedReason"] = this.sendingGlFailedReason;
        data["GlDocumentUploadFailedReason"] = this.glDocumentUploadFailedReason;
        data["RetractingFailedReason"] = this.retractingFailedReason;
        data["CustomerGlAccountIds"] = this.customerGlAccountIds;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.flaggedFields)) {
            data["FlaggedFields"] = [];
            for (let item of this.flaggedFields)
                data["FlaggedFields"].push(item ? item.toJSON() : undefined as any);
        }
        data["Version"] = this.version;
        data["CreateVoucherInstrumentRequestId"] = this.createVoucherInstrumentRequestId;
        data["ArchiveReason"] = this.archiveReason;
        data["DuplicateStatus"] = this.duplicateStatus;
        data["ProcessVoucherRequestId"] = this.processVoucherRequestId;
        data["LookupAvailableInstrumentId"] = this.lookupAvailableInstrumentId;
        data["CreateVoucherResponseEndpoint"] = this.createVoucherResponseEndpoint;
        data["CreateVoucherRequestId"] = this.createVoucherRequestId;
        data["VoucherValidationStatus"] = this.voucherValidationStatus;
        data["StartCreatingVoucherGlTransactionsRequestId"] = this.startCreatingVoucherGlTransactionsRequestId;
        data["StartCreatingVoucherGlTransactionsResponseAddress"] = this.startCreatingVoucherGlTransactionsResponseAddress;
        data["BatchJobId"] = this.batchJobId;
        data["RetractVoucherAndCreateGlRequestId"] = this.retractVoucherAndCreateGlRequestId;
        data["RetractVoucherAndDeleteGlRequestId"] = this.retractVoucherAndDeleteGlRequestId;
        data["CreateVoucherGlTransactionsRequestId"] = this.createVoucherGlTransactionsRequestId;
        data["SendingVoucherGlTransactionsTimeoutTokenId"] = this.sendingVoucherGlTransactionsTimeoutTokenId;
        data["IgnoreNotifyState"] = this.ignoreNotifyState;
        data["RetractedVoucherId"] = this.retractedVoucherId;
        data["CountOfTransactionsThatCanHaveGlTransactions"] = this.countOfTransactionsThatCanHaveGlTransactions;
        data["SendGlTransactionsJobId"] = this.sendGlTransactionsJobId;
        data["SendGlRetractTransactionsJobId"] = this.sendGlRetractTransactionsJobId;
        data["SendGlTransactionsTraceParent"] = this.sendGlTransactionsTraceParent;
        data["SendGlRetractTransactionsTraceParent"] = this.sendGlRetractTransactionsTraceParent;
        data["PastVoucherNr"] = this.pastVoucherNr;
        data["PostingOverrideDate"] = this.postingOverrideDate;
        data["NotificationStep"] = this.notificationStep ? this.notificationStep.toJSON() : undefined as any;
        data["IsUpvProcessed"] = this.isUpvProcessed;
        return data;
    }
}

export interface IVoucherState {
    correlationId?: string;
    companyIdentityId?: number;
    documentId?: string;
    documentPath?: string | undefined;
    currentState?: VoucherStateMachineStatus;
    previousState?: string | undefined;
    documentStorageType?: DocumentStorageType | undefined;
    fileType?: FileTypes;
    duplicateOfVoucherId?: string | undefined;
    createdBy?: string | undefined;
    updatedAt?: string | undefined;
    updatedBy?: string | undefined;
    brokerFee?: number | undefined;
    brokerFeeCurrencyAmount?: number | undefined;
    brokerFeeCurrencyCode?: string | undefined;
    description?: string | undefined;
    exchangeRate?: number | undefined;
    bankAccountId?: number | undefined;
    vpsAccountId?: number | undefined;
    portfolioId?: number | undefined;
    parsedBankAccount?: string | undefined;
    parsedVpsAccount?: string | undefined;
    parsedPortfolioAccount?: string | undefined;
    parsedCustomerId?: string | undefined;
    settlementAmount?: number | undefined;
    settlementAmountCurrency?: number | undefined;
    settlementAmountCurrencyCode?: string | undefined;
    settlementDate?: string | undefined;
    totalAmount?: number | undefined;
    totalAmountCurrency?: number | undefined;
    totalAmountCurrencyCode?: string | undefined;
    totalQuantity?: number | undefined;
    tradeDate?: string | undefined;
    transactionComment?: string | undefined;
    broker?: string | undefined;
    voucherNr?: string | undefined;
    activityType?: string | undefined;
    importedInstrumentCurrencyCode?: string | undefined;
    isin?: string | undefined;
    multipleInstrumentMatches?: boolean;
    orgNr?: string | undefined;
    rowId?: number | undefined;
    sourceActivityType?: string | undefined;
    ticker?: string | undefined;
    instrumentName?: string | undefined;
    importedInstrumentTypeId?: number | undefined;
    unknownActivityType?: boolean;
    instrumentId?: string | undefined;
    instrument?: Instrument | undefined;
    splitMergeFactor?: number | undefined;
    interest?: number | undefined;
    currencyInterests?: number | undefined;
    dueDate?: string | undefined;
    externalVoucherNr?: string | undefined;
    externalVoucherId?: string | undefined;
    externalImportId?: string | undefined;
    externalRectractVoucherNr?: string | undefined;
    externalRectractVoucherId?: string | undefined;
    externalRectractImportId?: string | undefined;
    processingFailedReason?: string | undefined;
    creatingGlFailedReason?: string | undefined;
    sendingGlFailedReason?: string | undefined;
    glDocumentUploadFailedReason?: string | undefined;
    retractingFailedReason?: string | undefined;
    customerGlAccountIds?: string | undefined;
    items?: VoucherItem[] | undefined;
    flaggedFields?: FlaggedField[] | undefined;
    version?: number;
    createVoucherInstrumentRequestId?: string | undefined;
    archiveReason?: ArchiveReason;
    duplicateStatus?: VoucherDuplicateStatus;
    processVoucherRequestId?: string | undefined;
    lookupAvailableInstrumentId?: string | undefined;
    createVoucherResponseEndpoint?: string | undefined;
    createVoucherRequestId?: string | undefined;
    voucherValidationStatus?: VoucherValidationStatus;
    startCreatingVoucherGlTransactionsRequestId?: string | undefined;
    startCreatingVoucherGlTransactionsResponseAddress?: string | undefined;
    batchJobId?: string | undefined;
    retractVoucherAndCreateGlRequestId?: string | undefined;
    retractVoucherAndDeleteGlRequestId?: string | undefined;
    createVoucherGlTransactionsRequestId?: string | undefined;
    sendingVoucherGlTransactionsTimeoutTokenId?: string | undefined;
    ignoreNotifyState?: boolean;
    retractedVoucherId?: string | undefined;
    countOfTransactionsThatCanHaveGlTransactions?: number | undefined;
    sendGlTransactionsJobId?: string | undefined;
    sendGlRetractTransactionsJobId?: string | undefined;
    sendGlTransactionsTraceParent?: string | undefined;
    sendGlRetractTransactionsTraceParent?: string | undefined;
    pastVoucherNr?: string | undefined;
    postingOverrideDate?: string | undefined;
    notificationStep?: NotificationStep | undefined;
    isUpvProcessed?: boolean;
}

export enum DocumentStorageType {
    InsightDb = 1,
    AzureBlob = 2,
    ScwBlob = 3,
    NotSet = -1,
}

export enum FileTypes {
    Voucher = 1,
    MultiLineVoucher = 2,
    MultiLineImportFile = 3,
    Report = 4,
}

export class VoucherItem implements IVoucherItem {
    flaggedFields?: FlaggedField[] | undefined;
    ticker?: string | undefined;
    orgNr?: string | undefined;
    isin?: string | undefined;
    instrumentName?: string | undefined;
    voucherNr?: string | undefined;
    price?: number | undefined;
    quantity?: number | undefined;
    exchangeRate?: number | undefined;
    totalAmount?: number | undefined;
    brokerFee?: number | undefined;
    settlementAmount?: number | undefined;
    currencyAmount?: number | undefined;
    currencyCode?: string | undefined;
    bankAccount?: string | undefined;
    vpsAccount?: string | undefined;
    bankAccountId?: number | undefined;
    vpsAccountId?: number | undefined;
    portfolioId?: number | undefined;
    instrument?: InstrumentContract | undefined;
    noted?: boolean;
    multipleInstrumentMatches?: boolean;
    interest?: number | undefined;
    activityType?: string | undefined;
    importedInstrumentCurrencyCode?: string | undefined;
    amountCurrencyCode?: string | undefined;
    sourceActivityType?: string | undefined;
    unknownActivityType?: boolean;

    constructor(data?: IVoucherItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["FlaggedFields"])) {
                this.flaggedFields = [] as any;
                for (let item of _data["FlaggedFields"])
                    this.flaggedFields!.push(FlaggedField.fromJS(item));
            }
            this.ticker = _data["Ticker"];
            this.orgNr = _data["OrgNr"];
            this.isin = _data["Isin"];
            this.instrumentName = _data["InstrumentName"];
            this.voucherNr = _data["VoucherNr"];
            this.price = _data["Price"];
            this.quantity = _data["Quantity"];
            this.exchangeRate = _data["ExchangeRate"];
            this.totalAmount = _data["TotalAmount"];
            this.brokerFee = _data["BrokerFee"];
            this.settlementAmount = _data["SettlementAmount"];
            this.currencyAmount = _data["CurrencyAmount"];
            this.currencyCode = _data["CurrencyCode"];
            this.bankAccount = _data["BankAccount"];
            this.vpsAccount = _data["VpsAccount"];
            this.bankAccountId = _data["BankAccountId"];
            this.vpsAccountId = _data["VpsAccountId"];
            this.portfolioId = _data["PortfolioId"];
            this.instrument = _data["Instrument"] ? InstrumentContract.fromJS(_data["Instrument"]) : undefined as any;
            this.noted = _data["Noted"];
            this.multipleInstrumentMatches = _data["MultipleInstrumentMatches"];
            this.interest = _data["Interest"];
            this.activityType = _data["ActivityType"];
            this.importedInstrumentCurrencyCode = _data["ImportedInstrumentCurrencyCode"];
            this.amountCurrencyCode = _data["AmountCurrencyCode"];
            this.sourceActivityType = _data["SourceActivityType"];
            this.unknownActivityType = _data["UnknownActivityType"];
        }
    }

    static fromJS(data: any): VoucherItem {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flaggedFields)) {
            data["FlaggedFields"] = [];
            for (let item of this.flaggedFields)
                data["FlaggedFields"].push(item ? item.toJSON() : undefined as any);
        }
        data["Ticker"] = this.ticker;
        data["OrgNr"] = this.orgNr;
        data["Isin"] = this.isin;
        data["InstrumentName"] = this.instrumentName;
        data["VoucherNr"] = this.voucherNr;
        data["Price"] = this.price;
        data["Quantity"] = this.quantity;
        data["ExchangeRate"] = this.exchangeRate;
        data["TotalAmount"] = this.totalAmount;
        data["BrokerFee"] = this.brokerFee;
        data["SettlementAmount"] = this.settlementAmount;
        data["CurrencyAmount"] = this.currencyAmount;
        data["CurrencyCode"] = this.currencyCode;
        data["BankAccount"] = this.bankAccount;
        data["VpsAccount"] = this.vpsAccount;
        data["BankAccountId"] = this.bankAccountId;
        data["VpsAccountId"] = this.vpsAccountId;
        data["PortfolioId"] = this.portfolioId;
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["Noted"] = this.noted;
        data["MultipleInstrumentMatches"] = this.multipleInstrumentMatches;
        data["Interest"] = this.interest;
        data["ActivityType"] = this.activityType;
        data["ImportedInstrumentCurrencyCode"] = this.importedInstrumentCurrencyCode;
        data["AmountCurrencyCode"] = this.amountCurrencyCode;
        data["SourceActivityType"] = this.sourceActivityType;
        data["UnknownActivityType"] = this.unknownActivityType;
        return data;
    }
}

export interface IVoucherItem {
    flaggedFields?: FlaggedField[] | undefined;
    ticker?: string | undefined;
    orgNr?: string | undefined;
    isin?: string | undefined;
    instrumentName?: string | undefined;
    voucherNr?: string | undefined;
    price?: number | undefined;
    quantity?: number | undefined;
    exchangeRate?: number | undefined;
    totalAmount?: number | undefined;
    brokerFee?: number | undefined;
    settlementAmount?: number | undefined;
    currencyAmount?: number | undefined;
    currencyCode?: string | undefined;
    bankAccount?: string | undefined;
    vpsAccount?: string | undefined;
    bankAccountId?: number | undefined;
    vpsAccountId?: number | undefined;
    portfolioId?: number | undefined;
    instrument?: InstrumentContract | undefined;
    noted?: boolean;
    multipleInstrumentMatches?: boolean;
    interest?: number | undefined;
    activityType?: string | undefined;
    importedInstrumentCurrencyCode?: string | undefined;
    amountCurrencyCode?: string | undefined;
    sourceActivityType?: string | undefined;
    unknownActivityType?: boolean;
}

export class FlaggedField implements IFlaggedField {
    type?: string;
    value?: string | undefined;
    content?: string;
    confidence?: number;
    description?: string | undefined;

    constructor(data?: IFlaggedField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            this.value = _data["Value"];
            this.content = _data["Content"];
            this.confidence = _data["Confidence"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): FlaggedField {
        data = typeof data === 'object' ? data : {};
        let result = new FlaggedField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["Value"] = this.value;
        data["Content"] = this.content;
        data["Confidence"] = this.confidence;
        data["Description"] = this.description;
        return data;
    }
}

export interface IFlaggedField {
    type?: string;
    value?: string | undefined;
    content?: string;
    confidence?: number;
    description?: string | undefined;
}

export class InstrumentContract implements IInstrumentContract {
    transactionAvailableInstrumentId?: string | undefined;
    transactionLegacyInstrumentId?: number | undefined;
    transactionInstrumentId?: string | undefined;
    lookupAvailableInstrumentId?: string | undefined;
    name?: string | undefined;
    isin?: string | undefined;
    ticker?: string | undefined;
    taxable?: boolean | undefined;
    noted?: boolean | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    currencyCode?: string | undefined;
    countryCode?: string | undefined;
    orgNr?: string | undefined;
    feedDescription?: string | undefined;
    companyIdentityId?: number | undefined;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    fetchSectors?: boolean;
    mic?: string | undefined;

    constructor(data?: IInstrumentContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionAvailableInstrumentId = _data["TransactionAvailableInstrumentId"];
            this.transactionLegacyInstrumentId = _data["TransactionLegacyInstrumentId"];
            this.transactionInstrumentId = _data["TransactionInstrumentId"];
            this.lookupAvailableInstrumentId = _data["LookupAvailableInstrumentId"];
            this.name = _data["Name"];
            this.isin = _data["Isin"];
            this.ticker = _data["Ticker"];
            this.taxable = _data["Taxable"];
            this.noted = _data["Noted"];
            this.longTerm = _data["LongTerm"];
            this.lowerOfCostOrMarket = _data["LowerOfCostOrMarket"];
            this.currencyCode = _data["CurrencyCode"];
            this.countryCode = _data["CountryCode"];
            this.orgNr = _data["OrgNr"];
            this.feedDescription = _data["FeedDescription"];
            this.companyIdentityId = _data["CompanyIdentityId"];
            this.instrumentTypeId = _data["InstrumentTypeId"];
            this.fetchSectors = _data["FetchSectors"];
            this.mic = _data["Mic"];
        }
    }

    static fromJS(data: any): InstrumentContract {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TransactionAvailableInstrumentId"] = this.transactionAvailableInstrumentId;
        data["TransactionLegacyInstrumentId"] = this.transactionLegacyInstrumentId;
        data["TransactionInstrumentId"] = this.transactionInstrumentId;
        data["LookupAvailableInstrumentId"] = this.lookupAvailableInstrumentId;
        data["Name"] = this.name;
        data["Isin"] = this.isin;
        data["Ticker"] = this.ticker;
        data["Taxable"] = this.taxable;
        data["Noted"] = this.noted;
        data["LongTerm"] = this.longTerm;
        data["LowerOfCostOrMarket"] = this.lowerOfCostOrMarket;
        data["CurrencyCode"] = this.currencyCode;
        data["CountryCode"] = this.countryCode;
        data["OrgNr"] = this.orgNr;
        data["FeedDescription"] = this.feedDescription;
        data["CompanyIdentityId"] = this.companyIdentityId;
        data["InstrumentTypeId"] = this.instrumentTypeId;
        data["FetchSectors"] = this.fetchSectors;
        data["Mic"] = this.mic;
        return data;
    }
}

export interface IInstrumentContract {
    transactionAvailableInstrumentId?: string | undefined;
    transactionLegacyInstrumentId?: number | undefined;
    transactionInstrumentId?: string | undefined;
    lookupAvailableInstrumentId?: string | undefined;
    name?: string | undefined;
    isin?: string | undefined;
    ticker?: string | undefined;
    taxable?: boolean | undefined;
    noted?: boolean | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    currencyCode?: string | undefined;
    countryCode?: string | undefined;
    orgNr?: string | undefined;
    feedDescription?: string | undefined;
    companyIdentityId?: number | undefined;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    fetchSectors?: boolean;
    mic?: string | undefined;
}

export enum ArchiveReason {
    NotArchived = 0,
    Deleted = 1,
    DuplicateVoucherNr = 2,
    DuplicateVoucherOnSameSinglePdf = 3,
    DuplicateOfProcessedVoucher = 4,
}

export enum VoucherDuplicateStatus {
    NotTested = 0,
    IsDuplicate = 1,
    HasDuplicate = 2,
    NoDuplicate = 3,
    DuplicatesProcessed = 4,
    Failed = -1,
}

export enum VoucherValidationStatus {
    NotValidated = 0,
    Unvalid = 1,
    Validated = 2,
    Failed = -1,
}

export class NotificationStep implements INotificationStep {
    notificationId?: string;
    step?: number;
    stepName?: string;
    companyIdentityId?: number;
    date?: string;
    status?: NotificationStepStatus;
    text?: string;
    debugMessage?: string | undefined;
    errorType?: NotificationErrorType;
    expectedProgress?: number;
    currentProgress?: number;
    progresses?: NotificationStepProgress[] | undefined;
    activityTraceId?: string | undefined;
    lastAccessed?: string;

    constructor(data?: INotificationStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationId = _data["NotificationId"];
            this.step = _data["Step"];
            this.stepName = _data["StepName"];
            this.companyIdentityId = _data["CompanyIdentityId"];
            this.date = _data["Date"];
            this.status = _data["Status"];
            this.text = _data["Text"];
            this.debugMessage = _data["DebugMessage"];
            this.errorType = _data["ErrorType"];
            this.expectedProgress = _data["ExpectedProgress"];
            this.currentProgress = _data["CurrentProgress"];
            if (Array.isArray(_data["Progresses"])) {
                this.progresses = [] as any;
                for (let item of _data["Progresses"])
                    this.progresses!.push(NotificationStepProgress.fromJS(item));
            }
            this.activityTraceId = _data["ActivityTraceId"];
            this.lastAccessed = _data["LastAccessed"];
        }
    }

    static fromJS(data: any): NotificationStep {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NotificationId"] = this.notificationId;
        data["Step"] = this.step;
        data["StepName"] = this.stepName;
        data["CompanyIdentityId"] = this.companyIdentityId;
        data["Date"] = this.date;
        data["Status"] = this.status;
        data["Text"] = this.text;
        data["DebugMessage"] = this.debugMessage;
        data["ErrorType"] = this.errorType;
        data["ExpectedProgress"] = this.expectedProgress;
        data["CurrentProgress"] = this.currentProgress;
        if (Array.isArray(this.progresses)) {
            data["Progresses"] = [];
            for (let item of this.progresses)
                data["Progresses"].push(item ? item.toJSON() : undefined as any);
        }
        data["ActivityTraceId"] = this.activityTraceId;
        data["LastAccessed"] = this.lastAccessed;
        return data;
    }
}

export interface INotificationStep {
    notificationId?: string;
    step?: number;
    stepName?: string;
    companyIdentityId?: number;
    date?: string;
    status?: NotificationStepStatus;
    text?: string;
    debugMessage?: string | undefined;
    errorType?: NotificationErrorType;
    expectedProgress?: number;
    currentProgress?: number;
    progresses?: NotificationStepProgress[] | undefined;
    activityTraceId?: string | undefined;
    lastAccessed?: string;
}

export enum NotificationStepStatus {
    Pending = 0,
    InProgress = 1,
    Success = 2,
    Error = 3,
    Warning = 4,
}

export enum NotificationErrorType {
    Unknown = 0,
    LockDate = 1,
    Authentication = 2,
    DatabaseError = 3,
}

export class NotificationStepProgress implements INotificationStepProgress {
    notificationId?: string;
    step?: number;
    date?: string;
    companyIdentityId?: number;

    constructor(data?: INotificationStepProgress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationId = _data["NotificationId"];
            this.step = _data["Step"];
            this.date = _data["Date"];
            this.companyIdentityId = _data["CompanyIdentityId"];
        }
    }

    static fromJS(data: any): NotificationStepProgress {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationStepProgress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NotificationId"] = this.notificationId;
        data["Step"] = this.step;
        data["Date"] = this.date;
        data["CompanyIdentityId"] = this.companyIdentityId;
        return data;
    }
}

export interface INotificationStepProgress {
    notificationId?: string;
    step?: number;
    date?: string;
    companyIdentityId?: number;
}

/** Represents a lexeme. A lexeme consists of a text string and optional word entry positions. */
export class Lexeme implements ILexeme {
    /** Gets or sets the text. */
    text?: string;
    /** Gets the number of word entry positions. */
    count?: number;

    constructor(data?: ILexeme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["Text"];
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): Lexeme {
        data = typeof data === 'object' ? data : {};
        let result = new Lexeme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Text"] = this.text;
        data["Count"] = this.count;
        return data;
    }
}

/** Represents a lexeme. A lexeme consists of a text string and optional word entry positions. */
export interface ILexeme {
    /** Gets or sets the text. */
    text?: string;
    /** Gets the number of word entry positions. */
    count?: number;
}

export class ImportedPrice implements IImportedPrice {
    sellPrice?: number;
    sellPriceAdjusted?: number;
    availableInstrumentId?: number | undefined;
    availableInstrumentUuid?: string | undefined;
    id?: number;
    date?: string;
    lastAdjustmentDate?: string | undefined;
    availableInstrument?: AvailableInstrument | undefined;

    constructor(data?: IImportedPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sellPrice = _data["SellPrice"];
            this.sellPriceAdjusted = _data["SellPriceAdjusted"];
            this.availableInstrumentId = _data["AvailableInstrumentId"];
            this.availableInstrumentUuid = _data["AvailableInstrumentUuid"];
            this.id = _data["Id"];
            this.date = _data["Date"];
            this.lastAdjustmentDate = _data["LastAdjustmentDate"];
            this.availableInstrument = _data["AvailableInstrument"] ? AvailableInstrument.fromJS(_data["AvailableInstrument"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImportedPrice {
        data = typeof data === 'object' ? data : {};
        let result = new ImportedPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SellPrice"] = this.sellPrice;
        data["SellPriceAdjusted"] = this.sellPriceAdjusted;
        data["AvailableInstrumentId"] = this.availableInstrumentId;
        data["AvailableInstrumentUuid"] = this.availableInstrumentUuid;
        data["Id"] = this.id;
        data["Date"] = this.date;
        data["LastAdjustmentDate"] = this.lastAdjustmentDate;
        data["AvailableInstrument"] = this.availableInstrument ? this.availableInstrument.toJSON() : undefined as any;
        return data;
    }
}

export interface IImportedPrice {
    sellPrice?: number;
    sellPriceAdjusted?: number;
    availableInstrumentId?: number | undefined;
    availableInstrumentUuid?: string | undefined;
    id?: number;
    date?: string;
    lastAdjustmentDate?: string | undefined;
    availableInstrument?: AvailableInstrument | undefined;
}

export class MarketIndex implements IMarketIndex {
    id?: number;
    name?: string | undefined;
    availableInstrumentId?: number | undefined;
    availableInstrument?: AvailableInstrument | undefined;

    constructor(data?: IMarketIndex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.availableInstrumentId = _data["AvailableInstrumentId"];
            this.availableInstrument = _data["AvailableInstrument"] ? AvailableInstrument.fromJS(_data["AvailableInstrument"]) : undefined as any;
        }
    }

    static fromJS(data: any): MarketIndex {
        data = typeof data === 'object' ? data : {};
        let result = new MarketIndex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["AvailableInstrumentId"] = this.availableInstrumentId;
        data["AvailableInstrument"] = this.availableInstrument ? this.availableInstrument.toJSON() : undefined as any;
        return data;
    }
}

export interface IMarketIndex {
    id?: number;
    name?: string | undefined;
    availableInstrumentId?: number | undefined;
    availableInstrument?: AvailableInstrument | undefined;
}

export class AvailableInstrumentCategory implements IAvailableInstrumentCategory {
    categoryId?: number;
    availableInstrumentId?: number;
    availableInstrumentUiid?: string;
    category?: Category | undefined;
    availableInstrument?: AvailableInstrument | undefined;
    portion?: number;
    date?: string;

    constructor(data?: IAvailableInstrumentCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["CategoryId"];
            this.availableInstrumentId = _data["AvailableInstrumentId"];
            this.availableInstrumentUiid = _data["AvailableInstrumentUiid"];
            this.category = _data["Category"] ? Category.fromJS(_data["Category"]) : undefined as any;
            this.availableInstrument = _data["AvailableInstrument"] ? AvailableInstrument.fromJS(_data["AvailableInstrument"]) : undefined as any;
            this.portion = _data["Portion"];
            this.date = _data["Date"];
        }
    }

    static fromJS(data: any): AvailableInstrumentCategory {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableInstrumentCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CategoryId"] = this.categoryId;
        data["AvailableInstrumentId"] = this.availableInstrumentId;
        data["AvailableInstrumentUiid"] = this.availableInstrumentUiid;
        data["Category"] = this.category ? this.category.toJSON() : undefined as any;
        data["AvailableInstrument"] = this.availableInstrument ? this.availableInstrument.toJSON() : undefined as any;
        data["Portion"] = this.portion;
        data["Date"] = this.date;
        return data;
    }
}

export interface IAvailableInstrumentCategory {
    categoryId?: number;
    availableInstrumentId?: number;
    availableInstrumentUiid?: string;
    category?: Category | undefined;
    availableInstrument?: AvailableInstrument | undefined;
    portion?: number;
    date?: string;
}

export class CategorySetting implements ICategorySetting {
    id?: number;
    customName?: string | undefined;
    vismaName?: string | undefined;
    enabled?: boolean;
    categoryTypeId?: number | undefined;
    companyId?: number | undefined;
    categoryType?: CategoryType | undefined;
    customerId?: number | undefined;
    customer?: Customer | undefined;

    constructor(data?: ICategorySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.customName = _data["CustomName"];
            this.vismaName = _data["VismaName"];
            this.enabled = _data["Enabled"];
            this.categoryTypeId = _data["CategoryTypeId"];
            this.companyId = _data["CompanyId"];
            this.categoryType = _data["CategoryType"] ? CategoryType.fromJS(_data["CategoryType"]) : undefined as any;
            this.customerId = _data["CustomerId"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
        }
    }

    static fromJS(data: any): CategorySetting {
        data = typeof data === 'object' ? data : {};
        let result = new CategorySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CustomName"] = this.customName;
        data["VismaName"] = this.vismaName;
        data["Enabled"] = this.enabled;
        data["CategoryTypeId"] = this.categoryTypeId;
        data["CompanyId"] = this.companyId;
        data["CategoryType"] = this.categoryType ? this.categoryType.toJSON() : undefined as any;
        data["CustomerId"] = this.customerId;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        return data;
    }
}

export interface ICategorySetting {
    id?: number;
    customName?: string | undefined;
    vismaName?: string | undefined;
    enabled?: boolean;
    categoryTypeId?: number | undefined;
    companyId?: number | undefined;
    categoryType?: CategoryType | undefined;
    customerId?: number | undefined;
    customer?: Customer | undefined;
}

export class CategoryType implements ICategoryType {
    id?: number;
    name?: string | undefined;
    isSystemCategory?: boolean;
    isTransactionCategory?: boolean;
    isInstrumentCategory?: boolean;
    isLocked?: boolean;
    disabled?: boolean;
    categories?: Category[] | undefined;
    categorySettings?: CategorySetting[] | undefined;

    constructor(data?: ICategoryType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.isSystemCategory = _data["IsSystemCategory"];
            this.isTransactionCategory = _data["IsTransactionCategory"];
            this.isInstrumentCategory = _data["IsInstrumentCategory"];
            this.isLocked = _data["IsLocked"];
            this.disabled = _data["Disabled"];
            if (Array.isArray(_data["Categories"])) {
                this.categories = [] as any;
                for (let item of _data["Categories"])
                    this.categories!.push(Category.fromJS(item));
            }
            if (Array.isArray(_data["CategorySettings"])) {
                this.categorySettings = [] as any;
                for (let item of _data["CategorySettings"])
                    this.categorySettings!.push(CategorySetting.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryType {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["IsSystemCategory"] = this.isSystemCategory;
        data["IsTransactionCategory"] = this.isTransactionCategory;
        data["IsInstrumentCategory"] = this.isInstrumentCategory;
        data["IsLocked"] = this.isLocked;
        data["Disabled"] = this.disabled;
        if (Array.isArray(this.categories)) {
            data["Categories"] = [];
            for (let item of this.categories)
                data["Categories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.categorySettings)) {
            data["CategorySettings"] = [];
            for (let item of this.categorySettings)
                data["CategorySettings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICategoryType {
    id?: number;
    name?: string | undefined;
    isSystemCategory?: boolean;
    isTransactionCategory?: boolean;
    isInstrumentCategory?: boolean;
    isLocked?: boolean;
    disabled?: boolean;
    categories?: Category[] | undefined;
    categorySettings?: CategorySetting[] | undefined;
}

export class CustomerSetting implements ICustomerSetting {
    id?: number;
    name?: string | undefined;
    value?: string | undefined;
    type?: number;
    companyId?: number | undefined;
    customer?: Customer | undefined;

    constructor(data?: ICustomerSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.value = _data["Value"];
            this.type = _data["Type"];
            this.companyId = _data["CompanyId"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
        }
    }

    static fromJS(data: any): CustomerSetting {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Value"] = this.value;
        data["Type"] = this.type;
        data["CompanyId"] = this.companyId;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        return data;
    }
}

export interface ICustomerSetting {
    id?: number;
    name?: string | undefined;
    value?: string | undefined;
    type?: number;
    companyId?: number | undefined;
    customer?: Customer | undefined;
}

export class CustomerStockNumber implements ICustomerStockNumber {
    id?: number;
    stockValue?: number;
    fromDate?: string;
    companyId?: number | undefined;
    customerId?: number;
    created?: string;
    createdById?: number | undefined;
    comment?: string | undefined;
    createdBy?: User | undefined;
    customer?: Customer | undefined;

    constructor(data?: ICustomerStockNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.stockValue = _data["StockValue"];
            this.fromDate = _data["FromDate"];
            this.companyId = _data["CompanyId"];
            this.customerId = _data["CustomerId"];
            this.created = _data["Created"];
            this.createdById = _data["CreatedById"];
            this.comment = _data["Comment"];
            this.createdBy = _data["CreatedBy"] ? User.fromJS(_data["CreatedBy"]) : undefined as any;
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
        }
    }

    static fromJS(data: any): CustomerStockNumber {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerStockNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StockValue"] = this.stockValue;
        data["FromDate"] = this.fromDate;
        data["CompanyId"] = this.companyId;
        data["CustomerId"] = this.customerId;
        data["Created"] = this.created;
        data["CreatedById"] = this.createdById;
        data["Comment"] = this.comment;
        data["CreatedBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        return data;
    }
}

export interface ICustomerStockNumber {
    id?: number;
    stockValue?: number;
    fromDate?: string;
    companyId?: number | undefined;
    customerId?: number;
    created?: string;
    createdById?: number | undefined;
    comment?: string | undefined;
    createdBy?: User | undefined;
    customer?: Customer | undefined;
}

export class UserSetting implements IUserSetting {
    id?: number;
    showProfitLossTable?: boolean;
    showMarketIndexGraph?: boolean;
    showCategoryPie?: boolean;
    userId?: number | undefined;
    defaultCustomerId?: number | undefined;
    showBalanceSheet?: boolean;
    showOverViewTable?: boolean;
    user?: User | undefined;

    constructor(data?: IUserSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.showProfitLossTable = _data["ShowProfitLossTable"];
            this.showMarketIndexGraph = _data["ShowMarketIndexGraph"];
            this.showCategoryPie = _data["ShowCategoryPie"];
            this.userId = _data["UserId"];
            this.defaultCustomerId = _data["DefaultCustomerId"];
            this.showBalanceSheet = _data["ShowBalanceSheet"];
            this.showOverViewTable = _data["ShowOverViewTable"];
            this.user = _data["User"] ? User.fromJS(_data["User"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ShowProfitLossTable"] = this.showProfitLossTable;
        data["ShowMarketIndexGraph"] = this.showMarketIndexGraph;
        data["ShowCategoryPie"] = this.showCategoryPie;
        data["UserId"] = this.userId;
        data["DefaultCustomerId"] = this.defaultCustomerId;
        data["ShowBalanceSheet"] = this.showBalanceSheet;
        data["ShowOverViewTable"] = this.showOverViewTable;
        data["User"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserSetting {
    id?: number;
    showProfitLossTable?: boolean;
    showMarketIndexGraph?: boolean;
    showCategoryPie?: boolean;
    userId?: number | undefined;
    defaultCustomerId?: number | undefined;
    showBalanceSheet?: boolean;
    showOverViewTable?: boolean;
    user?: User | undefined;
}

export class CommittedCapital implements ICommittedCapital {
    id?: number;
    instrumentId?: number;
    instrument?: Instrument | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    amount?: number;

    constructor(data?: ICommittedCapital) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.instrumentId = _data["InstrumentId"];
            this.instrument = _data["Instrument"] ? Instrument.fromJS(_data["Instrument"]) : undefined as any;
            this.fromDate = _data["FromDate"];
            this.toDate = _data["ToDate"];
            this.amount = _data["Amount"];
        }
    }

    static fromJS(data: any): CommittedCapital {
        data = typeof data === 'object' ? data : {};
        let result = new CommittedCapital();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["InstrumentId"] = this.instrumentId;
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["FromDate"] = this.fromDate;
        data["ToDate"] = this.toDate;
        data["Amount"] = this.amount;
        return data;
    }
}

export interface ICommittedCapital {
    id?: number;
    instrumentId?: number;
    instrument?: Instrument | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    amount?: number;
}

export class AgGridResponseOfCompanyStockValueUpdatedEvent implements IAgGridResponseOfCompanyStockValueUpdatedEvent {
    rowData?: CompanyStockValueUpdatedEvent[];
    rowCount?: number;

    constructor(data?: IAgGridResponseOfCompanyStockValueUpdatedEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["RowData"])) {
                this.rowData = [] as any;
                for (let item of _data["RowData"])
                    this.rowData!.push(CompanyStockValueUpdatedEvent.fromJS(item));
            }
            this.rowCount = _data["RowCount"];
        }
    }

    static fromJS(data: any): AgGridResponseOfCompanyStockValueUpdatedEvent {
        data = typeof data === 'object' ? data : {};
        let result = new AgGridResponseOfCompanyStockValueUpdatedEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rowData)) {
            data["RowData"] = [];
            for (let item of this.rowData)
                data["RowData"].push(item ? item.toJSON() : undefined as any);
        }
        data["RowCount"] = this.rowCount;
        return data;
    }
}

export interface IAgGridResponseOfCompanyStockValueUpdatedEvent {
    rowData?: CompanyStockValueUpdatedEvent[];
    rowCount?: number;
}

export class CompanyStockValueUpdatedEvent implements ICompanyStockValueUpdatedEvent {
    id?: number;
    stockValue?: number;
    fromDate?: string;
    companyId?: number | undefined;
    created?: string;
    createdById?: number | undefined;
    comment?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: ICompanyStockValueUpdatedEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.stockValue = _data["StockValue"];
            this.fromDate = _data["FromDate"];
            this.companyId = _data["CompanyId"];
            this.created = _data["Created"];
            this.createdById = _data["CreatedById"];
            this.comment = _data["Comment"];
            this.isDeleted = _data["IsDeleted"];
        }
    }

    static fromJS(data: any): CompanyStockValueUpdatedEvent {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyStockValueUpdatedEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StockValue"] = this.stockValue;
        data["FromDate"] = this.fromDate;
        data["CompanyId"] = this.companyId;
        data["Created"] = this.created;
        data["CreatedById"] = this.createdById;
        data["Comment"] = this.comment;
        data["IsDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ICompanyStockValueUpdatedEvent {
    id?: number;
    stockValue?: number;
    fromDate?: string;
    companyId?: number | undefined;
    created?: string;
    createdById?: number | undefined;
    comment?: string | undefined;
    isDeleted?: boolean;
}

export class AgGridPageRequest implements IAgGridPageRequest {
    startRow?: number;
    endRow?: number;
    sortModel?: AgGridSortModel[];
    filterModel?: { [key: string]: AgGridFilterModel; };

    constructor(data?: IAgGridPageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startRow = _data["StartRow"];
            this.endRow = _data["EndRow"];
            if (Array.isArray(_data["SortModel"])) {
                this.sortModel = [] as any;
                for (let item of _data["SortModel"])
                    this.sortModel!.push(AgGridSortModel.fromJS(item));
            }
            if (_data["FilterModel"]) {
                this.filterModel = {} as any;
                for (let key in _data["FilterModel"]) {
                    if (_data["FilterModel"].hasOwnProperty(key))
                        (this.filterModel as any)![key] = _data["FilterModel"][key] ? AgGridFilterModel.fromJS(_data["FilterModel"][key]) : new AgGridFilterModel();
                }
            }
        }
    }

    static fromJS(data: any): AgGridPageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgGridPageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartRow"] = this.startRow;
        data["EndRow"] = this.endRow;
        if (Array.isArray(this.sortModel)) {
            data["SortModel"] = [];
            for (let item of this.sortModel)
                data["SortModel"].push(item ? item.toJSON() : undefined as any);
        }
        if (this.filterModel) {
            data["FilterModel"] = {};
            for (let key in this.filterModel) {
                if (this.filterModel.hasOwnProperty(key))
                    (data["FilterModel"] as any)[key] = this.filterModel[key] ? this.filterModel[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IAgGridPageRequest {
    startRow?: number;
    endRow?: number;
    sortModel?: AgGridSortModel[];
    filterModel?: { [key: string]: AgGridFilterModel; };
}

export class AgGridSortModel implements IAgGridSortModel {
    colId?: string;
    sort?: string;

    constructor(data?: IAgGridSortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colId = _data["ColId"];
            this.sort = _data["Sort"];
        }
    }

    static fromJS(data: any): AgGridSortModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgGridSortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ColId"] = this.colId;
        data["Sort"] = this.sort;
        return data;
    }
}

export interface IAgGridSortModel {
    colId?: string;
    sort?: string;
}

export class AgGridFilterModel implements IAgGridFilterModel {
    filterType?: string;
    filter?: string;
    type?: string;
    dateTo?: string;
    dateFrom?: string;
    values?: string[];

    constructor(data?: IAgGridFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterType = _data["FilterType"];
            this.filter = _data["Filter"];
            this.type = _data["Type"];
            this.dateTo = _data["DateTo"];
            this.dateFrom = _data["DateFrom"];
            if (Array.isArray(_data["Values"])) {
                this.values = [] as any;
                for (let item of _data["Values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): AgGridFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgGridFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FilterType"] = this.filterType;
        data["Filter"] = this.filter;
        data["Type"] = this.type;
        data["DateTo"] = this.dateTo;
        data["DateFrom"] = this.dateFrom;
        if (Array.isArray(this.values)) {
            data["Values"] = [];
            for (let item of this.values)
                data["Values"].push(item);
        }
        return data;
    }
}

export interface IAgGridFilterModel {
    filterType?: string;
    filter?: string;
    type?: string;
    dateTo?: string;
    dateFrom?: string;
    values?: string[];
}

export class CurrencyCodeViewModel implements ICurrencyCodeViewModel {
    id?: number | undefined;
    name?: string | undefined;
    operatingMic?: string | undefined;

    constructor(data?: ICurrencyCodeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.operatingMic = _data["OperatingMic"];
        }
    }

    static fromJS(data: any): CurrencyCodeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyCodeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["OperatingMic"] = this.operatingMic;
        return data;
    }
}

export interface ICurrencyCodeViewModel {
    id?: number | undefined;
    name?: string | undefined;
    operatingMic?: string | undefined;
}

export class CustomerGlAccountViewModel implements ICustomerGlAccountViewModel {
    id?: number | undefined;
    customerId?: number;
    code?: number;
    name?: string | undefined;
    externalGlSystemId?: string | undefined;
    externalId?: string | undefined;
    externalGlSystemError?: string | undefined;
    incomingBalance?: number | undefined;
    glAccountTypeId?: number | undefined;
    type?: string | undefined;
    currencyCode?: string | undefined;

    constructor(data?: ICustomerGlAccountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.customerId = _data["CustomerId"];
            this.code = _data["Code"];
            this.name = _data["Name"];
            this.externalGlSystemId = _data["ExternalGlSystemId"];
            this.externalId = _data["ExternalId"];
            this.externalGlSystemError = _data["ExternalGlSystemError"];
            this.incomingBalance = _data["IncomingBalance"];
            this.glAccountTypeId = _data["GlAccountTypeId"];
            this.type = _data["Type"];
            this.currencyCode = _data["CurrencyCode"];
        }
    }

    static fromJS(data: any): CustomerGlAccountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerGlAccountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CustomerId"] = this.customerId;
        data["Code"] = this.code;
        data["Name"] = this.name;
        data["ExternalGlSystemId"] = this.externalGlSystemId;
        data["ExternalId"] = this.externalId;
        data["ExternalGlSystemError"] = this.externalGlSystemError;
        data["IncomingBalance"] = this.incomingBalance;
        data["GlAccountTypeId"] = this.glAccountTypeId;
        data["Type"] = this.type;
        data["CurrencyCode"] = this.currencyCode;
        return data;
    }
}

export interface ICustomerGlAccountViewModel {
    id?: number | undefined;
    customerId?: number;
    code?: number;
    name?: string | undefined;
    externalGlSystemId?: string | undefined;
    externalId?: string | undefined;
    externalGlSystemError?: string | undefined;
    incomingBalance?: number | undefined;
    glAccountTypeId?: number | undefined;
    type?: string | undefined;
    currencyCode?: string | undefined;
}

export class InstrumentTypeViewModel implements IInstrumentTypeViewModel {
    id?: InstrumentTypeEnum;
    name?: string;
    purchasedInterests?: boolean | undefined;

    constructor(data?: IInstrumentTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.purchasedInterests = _data["PurchasedInterests"];
        }
    }

    static fromJS(data: any): InstrumentTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["PurchasedInterests"] = this.purchasedInterests;
        return data;
    }
}

export interface IInstrumentTypeViewModel {
    id?: InstrumentTypeEnum;
    name?: string;
    purchasedInterests?: boolean | undefined;
}

export class AgGridResponseOfGlTransactionInsight implements IAgGridResponseOfGlTransactionInsight {
    rowData?: GlTransactionInsight[];
    rowCount?: number;

    constructor(data?: IAgGridResponseOfGlTransactionInsight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["RowData"])) {
                this.rowData = [] as any;
                for (let item of _data["RowData"])
                    this.rowData!.push(GlTransactionInsight.fromJS(item));
            }
            this.rowCount = _data["RowCount"];
        }
    }

    static fromJS(data: any): AgGridResponseOfGlTransactionInsight {
        data = typeof data === 'object' ? data : {};
        let result = new AgGridResponseOfGlTransactionInsight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rowData)) {
            data["RowData"] = [];
            for (let item of this.rowData)
                data["RowData"].push(item ? item.toJSON() : undefined as any);
        }
        data["RowCount"] = this.rowCount;
        return data;
    }
}

export interface IAgGridResponseOfGlTransactionInsight {
    rowData?: GlTransactionInsight[];
    rowCount?: number;
}

export class InstrumentAccountingValueStateViewModel implements IInstrumentAccountingValueStateViewModel {
    correlationId?: string;
    symbol?: string;
    accountingValue?: number | undefined;
    fromDate?: string | undefined;
    comment?: string | undefined;
    created?: string;
    createdBy?: string;
    updated?: string | undefined;
    updatedBy?: string | undefined;
    hasDocuments?: boolean;
    state?: string;

    constructor(data?: IInstrumentAccountingValueStateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correlationId = _data["CorrelationId"];
            this.symbol = _data["Symbol"];
            this.accountingValue = _data["AccountingValue"];
            this.fromDate = _data["FromDate"];
            this.comment = _data["Comment"];
            this.created = _data["Created"];
            this.createdBy = _data["CreatedBy"];
            this.updated = _data["Updated"];
            this.updatedBy = _data["UpdatedBy"];
            this.hasDocuments = _data["HasDocuments"];
            this.state = _data["State"];
        }
    }

    static fromJS(data: any): InstrumentAccountingValueStateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentAccountingValueStateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CorrelationId"] = this.correlationId;
        data["Symbol"] = this.symbol;
        data["AccountingValue"] = this.accountingValue;
        data["FromDate"] = this.fromDate;
        data["Comment"] = this.comment;
        data["Created"] = this.created;
        data["CreatedBy"] = this.createdBy;
        data["Updated"] = this.updated;
        data["UpdatedBy"] = this.updatedBy;
        data["HasDocuments"] = this.hasDocuments;
        data["State"] = this.state;
        return data;
    }
}

export interface IInstrumentAccountingValueStateViewModel {
    correlationId?: string;
    symbol?: string;
    accountingValue?: number | undefined;
    fromDate?: string | undefined;
    comment?: string | undefined;
    created?: string;
    createdBy?: string;
    updated?: string | undefined;
    updatedBy?: string | undefined;
    hasDocuments?: boolean;
    state?: string;
}

export class SyncInstrumentAccountingValue implements ISyncInstrumentAccountingValue {
    correlationId?: string;
    userEmail?: string;

    constructor(data?: ISyncInstrumentAccountingValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correlationId = _data["CorrelationId"];
            this.userEmail = _data["UserEmail"];
        }
    }

    static fromJS(data: any): SyncInstrumentAccountingValue {
        data = typeof data === 'object' ? data : {};
        let result = new SyncInstrumentAccountingValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CorrelationId"] = this.correlationId;
        data["UserEmail"] = this.userEmail;
        return data;
    }
}

export interface ISyncInstrumentAccountingValue {
    correlationId?: string;
    userEmail?: string;
}

export class UpdateInstrumentAccountingValue implements IUpdateInstrumentAccountingValue {
    correlationId?: string;
    userEmail?: string;
    accountingValue?: number;
    fromDate?: string;
    comment?: string | undefined;
    companyIdentityId?: number;

    constructor(data?: IUpdateInstrumentAccountingValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correlationId = _data["CorrelationId"];
            this.userEmail = _data["UserEmail"];
            this.accountingValue = _data["AccountingValue"];
            this.fromDate = _data["FromDate"];
            this.comment = _data["Comment"];
            this.companyIdentityId = _data["CompanyIdentityId"];
        }
    }

    static fromJS(data: any): UpdateInstrumentAccountingValue {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInstrumentAccountingValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CorrelationId"] = this.correlationId;
        data["UserEmail"] = this.userEmail;
        data["AccountingValue"] = this.accountingValue;
        data["FromDate"] = this.fromDate;
        data["Comment"] = this.comment;
        data["CompanyIdentityId"] = this.companyIdentityId;
        return data;
    }
}

export interface IUpdateInstrumentAccountingValue {
    correlationId?: string;
    userEmail?: string;
    accountingValue?: number;
    fromDate?: string;
    comment?: string | undefined;
    companyIdentityId?: number;
}

export class InstrumentViewModel implements IInstrumentViewModel {
    id?: number | undefined;
    uuid?: string | undefined;
    isin?: string | undefined;
    ticker?: string | undefined;
    name?: string | undefined;
    countryCode?: string | undefined;
    aiCountryCode?: string | undefined;
    iCountryCode?: string | undefined;
    reportName?: string | undefined;
    quantity?: number | undefined;
    noted?: boolean | undefined;
    taxable?: boolean | undefined;
    divideByFactor?: number | undefined;
    sellPrice?: number | undefined;
    purchasedInterest?: boolean | undefined;
    instrumentTypeName?: string | undefined;
    categories?: CategoryViewModel[] | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    companyId?: number | undefined;
    profitLoss?: number | undefined;
    totalCostPrice?: number | undefined;
    dividends?: number | undefined;
    receivedInterest?: number | undefined;
    realizedForPeriod?: number | undefined;
    costOfRealizedForPeriod?: number | undefined;
    showAll?: boolean | undefined;
    currencyCode?: string | undefined;
    tickerPrefix?: string | undefined;
    existingPortfolio?: boolean | undefined;
    currency?: CurrencyCodeViewModel | undefined;
    tickerWithPrefix?: string | undefined;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    autoPriceStatus?: number | undefined;
    estimatedValue?: number | undefined;
    grossMargin?: number | undefined;
    unitCostPrice?: number | undefined;
    unitCostPriceInCurrency?: number | undefined;
    lastImportedPriceDate?: string | undefined;
    lastImportedPrice?: number | undefined;
    manualPrice?: number | undefined;
    lastManualPrice?: number | undefined;
    mergeOrSplitFactor?: number | undefined;
    feedDescription?: string | undefined;
    availableinstrumentId?: number | undefined;
    lookupAvailableinstrumentId?: string | undefined;
    availableInstrument?: AvailableInstrumentsViewModel | undefined;
    sortOrder?: number | undefined;
    orgNr?: string | undefined;
    securitiesPriceType?: SecuritiesPriceTypeViewModel | undefined;
    mathSellPrice?: number | undefined;
    comment?: string | undefined;
    accountingValue?: number | undefined;
    avgAccountingValue?: number | undefined;
    availableInstrumentBelongsToCompany?: boolean | undefined;
    taxValue?: number | undefined;
    instrumentLoanQuantity?: number | undefined;
    lastImportedCurrencyRate?: number | undefined;
    lastImportedCurrencyDate?: string | undefined;
    dimension1?: string | undefined;
    dimension2?: string | undefined;
    dimension3?: string | undefined;
    dimension4?: string | undefined;
    dimension5?: string | undefined;
    sellPriceType?: string | undefined;
    dimension6?: string | undefined;
    dimension7?: string | undefined;
    dimension10?: string | undefined;
    dimension11?: string | undefined;
    dimension12?: string | undefined;
    dimension13?: string | undefined;
    dimension14?: string | undefined;
    dimension20?: string | undefined;
    dimension21?: string | undefined;
    dimension22?: string | undefined;
    dimension23?: string | undefined;
    dimension24?: string | undefined;
    dimension25?: string | undefined;
    dimension26?: string | undefined;
    dimension27?: string | undefined;
    dimension28?: string | undefined;
    msSuperSector?: string | undefined;
    msSector?: string | undefined;
    msIndustryGroup?: string | undefined;
    msIndustry?: string | undefined;
    portfolio?: string | undefined;
    securitiesAccounts?: string | undefined;
    availableinstrumentUuid?: string | undefined;
    avgUnitCostPrice?: number | undefined;
    avgCostPrice?: number | undefined;

    constructor(data?: IInstrumentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.uuid = _data["Uuid"];
            this.isin = _data["Isin"];
            this.ticker = _data["Ticker"];
            this.name = _data["Name"];
            this.countryCode = _data["CountryCode"];
            this.aiCountryCode = _data["AiCountryCode"];
            this.iCountryCode = _data["ICountryCode"];
            this.reportName = _data["ReportName"];
            this.quantity = _data["Quantity"];
            this.noted = _data["Noted"];
            this.taxable = _data["Taxable"];
            this.divideByFactor = _data["DivideByFactor"];
            this.sellPrice = _data["SellPrice"];
            this.purchasedInterest = _data["PurchasedInterest"];
            this.instrumentTypeName = _data["InstrumentTypeName"];
            if (Array.isArray(_data["Categories"])) {
                this.categories = [] as any;
                for (let item of _data["Categories"])
                    this.categories!.push(CategoryViewModel.fromJS(item));
            }
            this.longTerm = _data["LongTerm"];
            this.lowerOfCostOrMarket = _data["LowerOfCostOrMarket"];
            this.companyId = _data["CompanyId"];
            this.profitLoss = _data["ProfitLoss"];
            this.totalCostPrice = _data["TotalCostPrice"];
            this.dividends = _data["Dividends"];
            this.receivedInterest = _data["ReceivedInterest"];
            this.realizedForPeriod = _data["RealizedForPeriod"];
            this.costOfRealizedForPeriod = _data["CostOfRealizedForPeriod"];
            this.showAll = _data["ShowAll"];
            this.currencyCode = _data["CurrencyCode"];
            this.tickerPrefix = _data["TickerPrefix"];
            this.existingPortfolio = _data["ExistingPortfolio"];
            this.currency = _data["Currency"] ? CurrencyCodeViewModel.fromJS(_data["Currency"]) : undefined as any;
            this.tickerWithPrefix = _data["TickerWithPrefix"];
            this.instrumentTypeId = _data["InstrumentTypeId"];
            this.autoPriceStatus = _data["AutoPriceStatus"];
            this.estimatedValue = _data["EstimatedValue"];
            this.grossMargin = _data["GrossMargin"];
            this.unitCostPrice = _data["UnitCostPrice"];
            this.unitCostPriceInCurrency = _data["UnitCostPriceInCurrency"];
            this.lastImportedPriceDate = _data["LastImportedPriceDate"];
            this.lastImportedPrice = _data["LastImportedPrice"];
            this.manualPrice = _data["ManualPrice"];
            this.lastManualPrice = _data["LastManualPrice"];
            this.mergeOrSplitFactor = _data["MergeOrSplitFactor"];
            this.feedDescription = _data["FeedDescription"];
            this.availableinstrumentId = _data["AvailableinstrumentId"];
            this.lookupAvailableinstrumentId = _data["LookupAvailableinstrumentId"];
            this.availableInstrument = _data["AvailableInstrument"] ? AvailableInstrumentsViewModel.fromJS(_data["AvailableInstrument"]) : undefined as any;
            this.sortOrder = _data["SortOrder"];
            this.orgNr = _data["OrgNr"];
            this.securitiesPriceType = _data["SecuritiesPriceType"] ? SecuritiesPriceTypeViewModel.fromJS(_data["SecuritiesPriceType"]) : undefined as any;
            this.mathSellPrice = _data["MathSellPrice"];
            this.comment = _data["Comment"];
            this.accountingValue = _data["AccountingValue"];
            this.avgAccountingValue = _data["AvgAccountingValue"];
            this.availableInstrumentBelongsToCompany = _data["AvailableInstrumentBelongsToCompany"];
            this.taxValue = _data["TaxValue"];
            this.instrumentLoanQuantity = _data["InstrumentLoanQuantity"];
            this.lastImportedCurrencyRate = _data["LastImportedCurrencyRate"];
            this.lastImportedCurrencyDate = _data["LastImportedCurrencyDate"];
            this.dimension1 = _data["Dimension1"];
            this.dimension2 = _data["Dimension2"];
            this.dimension3 = _data["Dimension3"];
            this.dimension4 = _data["Dimension4"];
            this.dimension5 = _data["Dimension5"];
            this.sellPriceType = _data["SellPriceType"];
            this.dimension6 = _data["Dimension6"];
            this.dimension7 = _data["Dimension7"];
            this.dimension10 = _data["Dimension10"];
            this.dimension11 = _data["Dimension11"];
            this.dimension12 = _data["Dimension12"];
            this.dimension13 = _data["Dimension13"];
            this.dimension14 = _data["Dimension14"];
            this.dimension20 = _data["Dimension20"];
            this.dimension21 = _data["Dimension21"];
            this.dimension22 = _data["Dimension22"];
            this.dimension23 = _data["Dimension23"];
            this.dimension24 = _data["Dimension24"];
            this.dimension25 = _data["Dimension25"];
            this.dimension26 = _data["Dimension26"];
            this.dimension27 = _data["Dimension27"];
            this.dimension28 = _data["Dimension28"];
            this.msSuperSector = _data["MsSuperSector"];
            this.msSector = _data["MsSector"];
            this.msIndustryGroup = _data["MsIndustryGroup"];
            this.msIndustry = _data["MsIndustry"];
            this.portfolio = _data["Portfolio"];
            this.securitiesAccounts = _data["SecuritiesAccounts"];
            this.availableinstrumentUuid = _data["AvailableinstrumentUuid"];
            this.avgUnitCostPrice = _data["AvgUnitCostPrice"];
            this.avgCostPrice = _data["AvgCostPrice"];
        }
    }

    static fromJS(data: any): InstrumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Uuid"] = this.uuid;
        data["Isin"] = this.isin;
        data["Ticker"] = this.ticker;
        data["Name"] = this.name;
        data["CountryCode"] = this.countryCode;
        data["AiCountryCode"] = this.aiCountryCode;
        data["ICountryCode"] = this.iCountryCode;
        data["ReportName"] = this.reportName;
        data["Quantity"] = this.quantity;
        data["Noted"] = this.noted;
        data["Taxable"] = this.taxable;
        data["DivideByFactor"] = this.divideByFactor;
        data["SellPrice"] = this.sellPrice;
        data["PurchasedInterest"] = this.purchasedInterest;
        data["InstrumentTypeName"] = this.instrumentTypeName;
        if (Array.isArray(this.categories)) {
            data["Categories"] = [];
            for (let item of this.categories)
                data["Categories"].push(item ? item.toJSON() : undefined as any);
        }
        data["LongTerm"] = this.longTerm;
        data["LowerOfCostOrMarket"] = this.lowerOfCostOrMarket;
        data["CompanyId"] = this.companyId;
        data["ProfitLoss"] = this.profitLoss;
        data["TotalCostPrice"] = this.totalCostPrice;
        data["Dividends"] = this.dividends;
        data["ReceivedInterest"] = this.receivedInterest;
        data["RealizedForPeriod"] = this.realizedForPeriod;
        data["CostOfRealizedForPeriod"] = this.costOfRealizedForPeriod;
        data["ShowAll"] = this.showAll;
        data["CurrencyCode"] = this.currencyCode;
        data["TickerPrefix"] = this.tickerPrefix;
        data["ExistingPortfolio"] = this.existingPortfolio;
        data["Currency"] = this.currency ? this.currency.toJSON() : undefined as any;
        data["TickerWithPrefix"] = this.tickerWithPrefix;
        data["InstrumentTypeId"] = this.instrumentTypeId;
        data["AutoPriceStatus"] = this.autoPriceStatus;
        data["EstimatedValue"] = this.estimatedValue;
        data["GrossMargin"] = this.grossMargin;
        data["UnitCostPrice"] = this.unitCostPrice;
        data["UnitCostPriceInCurrency"] = this.unitCostPriceInCurrency;
        data["LastImportedPriceDate"] = this.lastImportedPriceDate;
        data["LastImportedPrice"] = this.lastImportedPrice;
        data["ManualPrice"] = this.manualPrice;
        data["LastManualPrice"] = this.lastManualPrice;
        data["MergeOrSplitFactor"] = this.mergeOrSplitFactor;
        data["FeedDescription"] = this.feedDescription;
        data["AvailableinstrumentId"] = this.availableinstrumentId;
        data["LookupAvailableinstrumentId"] = this.lookupAvailableinstrumentId;
        data["AvailableInstrument"] = this.availableInstrument ? this.availableInstrument.toJSON() : undefined as any;
        data["SortOrder"] = this.sortOrder;
        data["OrgNr"] = this.orgNr;
        data["SecuritiesPriceType"] = this.securitiesPriceType ? this.securitiesPriceType.toJSON() : undefined as any;
        data["MathSellPrice"] = this.mathSellPrice;
        data["Comment"] = this.comment;
        data["AccountingValue"] = this.accountingValue;
        data["AvgAccountingValue"] = this.avgAccountingValue;
        data["AvailableInstrumentBelongsToCompany"] = this.availableInstrumentBelongsToCompany;
        data["TaxValue"] = this.taxValue;
        data["InstrumentLoanQuantity"] = this.instrumentLoanQuantity;
        data["LastImportedCurrencyRate"] = this.lastImportedCurrencyRate;
        data["LastImportedCurrencyDate"] = this.lastImportedCurrencyDate;
        data["Dimension1"] = this.dimension1;
        data["Dimension2"] = this.dimension2;
        data["Dimension3"] = this.dimension3;
        data["Dimension4"] = this.dimension4;
        data["Dimension5"] = this.dimension5;
        data["SellPriceType"] = this.sellPriceType;
        data["Dimension6"] = this.dimension6;
        data["Dimension7"] = this.dimension7;
        data["Dimension10"] = this.dimension10;
        data["Dimension11"] = this.dimension11;
        data["Dimension12"] = this.dimension12;
        data["Dimension13"] = this.dimension13;
        data["Dimension14"] = this.dimension14;
        data["Dimension20"] = this.dimension20;
        data["Dimension21"] = this.dimension21;
        data["Dimension22"] = this.dimension22;
        data["Dimension23"] = this.dimension23;
        data["Dimension24"] = this.dimension24;
        data["Dimension25"] = this.dimension25;
        data["Dimension26"] = this.dimension26;
        data["Dimension27"] = this.dimension27;
        data["Dimension28"] = this.dimension28;
        data["MsSuperSector"] = this.msSuperSector;
        data["MsSector"] = this.msSector;
        data["MsIndustryGroup"] = this.msIndustryGroup;
        data["MsIndustry"] = this.msIndustry;
        data["Portfolio"] = this.portfolio;
        data["SecuritiesAccounts"] = this.securitiesAccounts;
        data["AvailableinstrumentUuid"] = this.availableinstrumentUuid;
        data["AvgUnitCostPrice"] = this.avgUnitCostPrice;
        data["AvgCostPrice"] = this.avgCostPrice;
        return data;
    }
}

export interface IInstrumentViewModel {
    id?: number | undefined;
    uuid?: string | undefined;
    isin?: string | undefined;
    ticker?: string | undefined;
    name?: string | undefined;
    countryCode?: string | undefined;
    aiCountryCode?: string | undefined;
    iCountryCode?: string | undefined;
    reportName?: string | undefined;
    quantity?: number | undefined;
    noted?: boolean | undefined;
    taxable?: boolean | undefined;
    divideByFactor?: number | undefined;
    sellPrice?: number | undefined;
    purchasedInterest?: boolean | undefined;
    instrumentTypeName?: string | undefined;
    categories?: CategoryViewModel[] | undefined;
    longTerm?: boolean | undefined;
    lowerOfCostOrMarket?: boolean | undefined;
    companyId?: number | undefined;
    profitLoss?: number | undefined;
    totalCostPrice?: number | undefined;
    dividends?: number | undefined;
    receivedInterest?: number | undefined;
    realizedForPeriod?: number | undefined;
    costOfRealizedForPeriod?: number | undefined;
    showAll?: boolean | undefined;
    currencyCode?: string | undefined;
    tickerPrefix?: string | undefined;
    existingPortfolio?: boolean | undefined;
    currency?: CurrencyCodeViewModel | undefined;
    tickerWithPrefix?: string | undefined;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    autoPriceStatus?: number | undefined;
    estimatedValue?: number | undefined;
    grossMargin?: number | undefined;
    unitCostPrice?: number | undefined;
    unitCostPriceInCurrency?: number | undefined;
    lastImportedPriceDate?: string | undefined;
    lastImportedPrice?: number | undefined;
    manualPrice?: number | undefined;
    lastManualPrice?: number | undefined;
    mergeOrSplitFactor?: number | undefined;
    feedDescription?: string | undefined;
    availableinstrumentId?: number | undefined;
    lookupAvailableinstrumentId?: string | undefined;
    availableInstrument?: AvailableInstrumentsViewModel | undefined;
    sortOrder?: number | undefined;
    orgNr?: string | undefined;
    securitiesPriceType?: SecuritiesPriceTypeViewModel | undefined;
    mathSellPrice?: number | undefined;
    comment?: string | undefined;
    accountingValue?: number | undefined;
    avgAccountingValue?: number | undefined;
    availableInstrumentBelongsToCompany?: boolean | undefined;
    taxValue?: number | undefined;
    instrumentLoanQuantity?: number | undefined;
    lastImportedCurrencyRate?: number | undefined;
    lastImportedCurrencyDate?: string | undefined;
    dimension1?: string | undefined;
    dimension2?: string | undefined;
    dimension3?: string | undefined;
    dimension4?: string | undefined;
    dimension5?: string | undefined;
    sellPriceType?: string | undefined;
    dimension6?: string | undefined;
    dimension7?: string | undefined;
    dimension10?: string | undefined;
    dimension11?: string | undefined;
    dimension12?: string | undefined;
    dimension13?: string | undefined;
    dimension14?: string | undefined;
    dimension20?: string | undefined;
    dimension21?: string | undefined;
    dimension22?: string | undefined;
    dimension23?: string | undefined;
    dimension24?: string | undefined;
    dimension25?: string | undefined;
    dimension26?: string | undefined;
    dimension27?: string | undefined;
    dimension28?: string | undefined;
    msSuperSector?: string | undefined;
    msSector?: string | undefined;
    msIndustryGroup?: string | undefined;
    msIndustry?: string | undefined;
    portfolio?: string | undefined;
    securitiesAccounts?: string | undefined;
    availableinstrumentUuid?: string | undefined;
    avgUnitCostPrice?: number | undefined;
    avgCostPrice?: number | undefined;
}

export class AvailableInstrumentsViewModel implements IAvailableInstrumentsViewModel {
    ticker?: string | undefined;
    lastUpdated?: string | undefined;
    name?: string | undefined;
    isin?: string | undefined;
    securitiesPriceTypeId?: number | undefined;
    id?: string;
    currencyId?: number | undefined;
    currencyCode?: string | undefined;
    feedDescription?: string | undefined;
    marketsId?: number | undefined;
    failCount?: number | undefined;
    orgNr?: string | undefined;
    companyIdentityId?: number | undefined;
    availableInstrumentInboxId?: number | undefined;
    availableInstrumentLookupId?: number | undefined;
    categories?: CategoryViewModel[] | undefined;

    constructor(data?: IAvailableInstrumentsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticker = _data["Ticker"];
            this.lastUpdated = _data["LastUpdated"];
            this.name = _data["Name"];
            this.isin = _data["Isin"];
            this.securitiesPriceTypeId = _data["SecuritiesPriceTypeId"];
            this.id = _data["Id"];
            this.currencyId = _data["CurrencyId"];
            this.currencyCode = _data["CurrencyCode"];
            this.feedDescription = _data["FeedDescription"];
            this.marketsId = _data["MarketsId"];
            this.failCount = _data["FailCount"];
            this.orgNr = _data["OrgNr"];
            this.companyIdentityId = _data["CompanyIdentityId"];
            this.availableInstrumentInboxId = _data["AvailableInstrumentInboxId"];
            this.availableInstrumentLookupId = _data["AvailableInstrumentLookupId"];
            if (Array.isArray(_data["Categories"])) {
                this.categories = [] as any;
                for (let item of _data["Categories"])
                    this.categories!.push(CategoryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvailableInstrumentsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableInstrumentsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Ticker"] = this.ticker;
        data["LastUpdated"] = this.lastUpdated;
        data["Name"] = this.name;
        data["Isin"] = this.isin;
        data["SecuritiesPriceTypeId"] = this.securitiesPriceTypeId;
        data["Id"] = this.id;
        data["CurrencyId"] = this.currencyId;
        data["CurrencyCode"] = this.currencyCode;
        data["FeedDescription"] = this.feedDescription;
        data["MarketsId"] = this.marketsId;
        data["FailCount"] = this.failCount;
        data["OrgNr"] = this.orgNr;
        data["CompanyIdentityId"] = this.companyIdentityId;
        data["AvailableInstrumentInboxId"] = this.availableInstrumentInboxId;
        data["AvailableInstrumentLookupId"] = this.availableInstrumentLookupId;
        if (Array.isArray(this.categories)) {
            data["Categories"] = [];
            for (let item of this.categories)
                data["Categories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAvailableInstrumentsViewModel {
    ticker?: string | undefined;
    lastUpdated?: string | undefined;
    name?: string | undefined;
    isin?: string | undefined;
    securitiesPriceTypeId?: number | undefined;
    id?: string;
    currencyId?: number | undefined;
    currencyCode?: string | undefined;
    feedDescription?: string | undefined;
    marketsId?: number | undefined;
    failCount?: number | undefined;
    orgNr?: string | undefined;
    companyIdentityId?: number | undefined;
    availableInstrumentInboxId?: number | undefined;
    availableInstrumentLookupId?: number | undefined;
    categories?: CategoryViewModel[] | undefined;
}

export class SecuritiesPriceTypeViewModel implements ISecuritiesPriceTypeViewModel {
    priceType?: string;
    id?: number;

    constructor(data?: ISecuritiesPriceTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priceType = _data["PriceType"];
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): SecuritiesPriceTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritiesPriceTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PriceType"] = this.priceType;
        data["Id"] = this.id;
        return data;
    }
}

export interface ISecuritiesPriceTypeViewModel {
    priceType?: string;
    id?: number;
}

export class QueryInstrumentsResponseItem implements IQueryInstrumentsResponseItem {
    transactionAvailableInstrumentId?: string | undefined;
    transactionInstrumentId?: string | undefined;
    lookupAvailableInstrumentId?: string | undefined;
    isin?: string | undefined;
    existingInstrument?: boolean | undefined;
    name?: string | undefined;
    reportName?: string | undefined;
    ticker?: string | undefined;
    currencyCode?: string | undefined;
    orgNr?: string | undefined;
    sortOrder?: number | undefined;
    feedDescription?: string | undefined;
    countryCode?: string | undefined;
    infrontPriceType?: string | undefined;
    possibleInstrumentTypesIds?: InstrumentTypeEnum[] | undefined;
    companyIdentityId?: number | undefined;
    instrumentId?: number | undefined;
    typeShortName?: string | undefined;
    exchangeName?: string | undefined;
    mic?: string | undefined;
    categories?: SectorMessageModel[];
    fetchSectors?: boolean;
    lastUpdated?: string | undefined;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    instrumentTaxable?: boolean | undefined;
    instrumentLongTerm?: boolean | undefined;
    instrumentLowerOfCostOrMarket?: boolean | undefined;
    instrumentState?: InstrumentState;

    constructor(data?: IQueryInstrumentsResponseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionAvailableInstrumentId = _data["TransactionAvailableInstrumentId"];
            this.transactionInstrumentId = _data["TransactionInstrumentId"];
            this.lookupAvailableInstrumentId = _data["LookupAvailableInstrumentId"];
            this.isin = _data["Isin"];
            this.existingInstrument = _data["ExistingInstrument"];
            this.name = _data["Name"];
            this.reportName = _data["ReportName"];
            this.ticker = _data["Ticker"];
            this.currencyCode = _data["CurrencyCode"];
            this.orgNr = _data["OrgNr"];
            this.sortOrder = _data["SortOrder"];
            this.feedDescription = _data["FeedDescription"];
            this.countryCode = _data["CountryCode"];
            this.infrontPriceType = _data["InfrontPriceType"];
            if (Array.isArray(_data["PossibleInstrumentTypesIds"])) {
                this.possibleInstrumentTypesIds = [] as any;
                for (let item of _data["PossibleInstrumentTypesIds"])
                    this.possibleInstrumentTypesIds!.push(item);
            }
            this.companyIdentityId = _data["CompanyIdentityId"];
            this.instrumentId = _data["InstrumentId"];
            this.typeShortName = _data["TypeShortName"];
            this.exchangeName = _data["ExchangeName"];
            this.mic = _data["Mic"];
            if (Array.isArray(_data["Categories"])) {
                this.categories = [] as any;
                for (let item of _data["Categories"])
                    this.categories!.push(SectorMessageModel.fromJS(item));
            }
            this.fetchSectors = _data["FetchSectors"];
            this.lastUpdated = _data["LastUpdated"];
            this.instrumentTypeId = _data["InstrumentTypeId"];
            this.instrumentTaxable = _data["InstrumentTaxable"];
            this.instrumentLongTerm = _data["InstrumentLongTerm"];
            this.instrumentLowerOfCostOrMarket = _data["InstrumentLowerOfCostOrMarket"];
            this.instrumentState = _data["InstrumentState"];
        }
    }

    static fromJS(data: any): QueryInstrumentsResponseItem {
        data = typeof data === 'object' ? data : {};
        let result = new QueryInstrumentsResponseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TransactionAvailableInstrumentId"] = this.transactionAvailableInstrumentId;
        data["TransactionInstrumentId"] = this.transactionInstrumentId;
        data["LookupAvailableInstrumentId"] = this.lookupAvailableInstrumentId;
        data["Isin"] = this.isin;
        data["ExistingInstrument"] = this.existingInstrument;
        data["Name"] = this.name;
        data["ReportName"] = this.reportName;
        data["Ticker"] = this.ticker;
        data["CurrencyCode"] = this.currencyCode;
        data["OrgNr"] = this.orgNr;
        data["SortOrder"] = this.sortOrder;
        data["FeedDescription"] = this.feedDescription;
        data["CountryCode"] = this.countryCode;
        data["InfrontPriceType"] = this.infrontPriceType;
        if (Array.isArray(this.possibleInstrumentTypesIds)) {
            data["PossibleInstrumentTypesIds"] = [];
            for (let item of this.possibleInstrumentTypesIds)
                data["PossibleInstrumentTypesIds"].push(item);
        }
        data["CompanyIdentityId"] = this.companyIdentityId;
        data["InstrumentId"] = this.instrumentId;
        data["TypeShortName"] = this.typeShortName;
        data["ExchangeName"] = this.exchangeName;
        data["Mic"] = this.mic;
        if (Array.isArray(this.categories)) {
            data["Categories"] = [];
            for (let item of this.categories)
                data["Categories"].push(item ? item.toJSON() : undefined as any);
        }
        data["FetchSectors"] = this.fetchSectors;
        data["LastUpdated"] = this.lastUpdated;
        data["InstrumentTypeId"] = this.instrumentTypeId;
        data["InstrumentTaxable"] = this.instrumentTaxable;
        data["InstrumentLongTerm"] = this.instrumentLongTerm;
        data["InstrumentLowerOfCostOrMarket"] = this.instrumentLowerOfCostOrMarket;
        data["InstrumentState"] = this.instrumentState;
        return data;
    }
}

export interface IQueryInstrumentsResponseItem {
    transactionAvailableInstrumentId?: string | undefined;
    transactionInstrumentId?: string | undefined;
    lookupAvailableInstrumentId?: string | undefined;
    isin?: string | undefined;
    existingInstrument?: boolean | undefined;
    name?: string | undefined;
    reportName?: string | undefined;
    ticker?: string | undefined;
    currencyCode?: string | undefined;
    orgNr?: string | undefined;
    sortOrder?: number | undefined;
    feedDescription?: string | undefined;
    countryCode?: string | undefined;
    infrontPriceType?: string | undefined;
    possibleInstrumentTypesIds?: InstrumentTypeEnum[] | undefined;
    companyIdentityId?: number | undefined;
    instrumentId?: number | undefined;
    typeShortName?: string | undefined;
    exchangeName?: string | undefined;
    mic?: string | undefined;
    categories?: SectorMessageModel[];
    fetchSectors?: boolean;
    lastUpdated?: string | undefined;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    instrumentTaxable?: boolean | undefined;
    instrumentLongTerm?: boolean | undefined;
    instrumentLowerOfCostOrMarket?: boolean | undefined;
    instrumentState?: InstrumentState;
}

export class SectorMessageModel implements ISectorMessageModel {
    categoryId?: number | undefined;
    externalId?: string | undefined;
    name?: string | undefined;
    portion?: number;
    externalType?: string | undefined;
    categoryType?: number | undefined;

    constructor(data?: ISectorMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["CategoryId"];
            this.externalId = _data["ExternalId"];
            this.name = _data["Name"];
            this.portion = _data["Portion"];
            this.externalType = _data["ExternalType"];
            this.categoryType = _data["CategoryType"];
        }
    }

    static fromJS(data: any): SectorMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new SectorMessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CategoryId"] = this.categoryId;
        data["ExternalId"] = this.externalId;
        data["Name"] = this.name;
        data["Portion"] = this.portion;
        data["ExternalType"] = this.externalType;
        data["CategoryType"] = this.categoryType;
        return data;
    }
}

export interface ISectorMessageModel {
    categoryId?: number | undefined;
    externalId?: string | undefined;
    name?: string | undefined;
    portion?: number;
    externalType?: string | undefined;
    categoryType?: number | undefined;
}

export class InsightBaseContract implements IInsightBaseContract {
    companyIdentityId?: number;

    constructor(data?: IInsightBaseContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyIdentityId = _data["CompanyIdentityId"];
        }
    }

    static fromJS(data: any): InsightBaseContract {
        data = typeof data === 'object' ? data : {};
        let result = new InsightBaseContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyIdentityId"] = this.companyIdentityId;
        return data;
    }
}

export interface IInsightBaseContract {
    companyIdentityId?: number;
}

export class QueryTransactionInstrumentsRequest extends InsightBaseContract implements IQueryTransactionInstrumentsRequest {
    isin?: string | undefined;
    ticker?: string | undefined;
    currencyCode?: string | undefined;
    instrumentCurrencyCode?: string | undefined;
    availableInstrumentId?: string | undefined;
    searchString?: string | undefined;
    mode?: QueryInstrumentsMode;
    filterByInstrumentType?: InstrumentTypeEnum | undefined;
    orgNr?: string | undefined;
    takeLimit?: number | undefined;

    constructor(data?: IQueryTransactionInstrumentsRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isin = _data["Isin"];
            this.ticker = _data["Ticker"];
            this.currencyCode = _data["CurrencyCode"];
            this.instrumentCurrencyCode = _data["InstrumentCurrencyCode"];
            this.availableInstrumentId = _data["AvailableInstrumentId"];
            this.searchString = _data["SearchString"];
            this.mode = _data["Mode"];
            this.filterByInstrumentType = _data["FilterByInstrumentType"];
            this.orgNr = _data["OrgNr"];
            this.takeLimit = _data["TakeLimit"];
        }
    }

    static override fromJS(data: any): QueryTransactionInstrumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QueryTransactionInstrumentsRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Isin"] = this.isin;
        data["Ticker"] = this.ticker;
        data["CurrencyCode"] = this.currencyCode;
        data["InstrumentCurrencyCode"] = this.instrumentCurrencyCode;
        data["AvailableInstrumentId"] = this.availableInstrumentId;
        data["SearchString"] = this.searchString;
        data["Mode"] = this.mode;
        data["FilterByInstrumentType"] = this.filterByInstrumentType;
        data["OrgNr"] = this.orgNr;
        data["TakeLimit"] = this.takeLimit;
        super.toJSON(data);
        return data;
    }
}

export interface IQueryTransactionInstrumentsRequest extends IInsightBaseContract {
    isin?: string | undefined;
    ticker?: string | undefined;
    currencyCode?: string | undefined;
    instrumentCurrencyCode?: string | undefined;
    availableInstrumentId?: string | undefined;
    searchString?: string | undefined;
    mode?: QueryInstrumentsMode;
    filterByInstrumentType?: InstrumentTypeEnum | undefined;
    orgNr?: string | undefined;
    takeLimit?: number | undefined;
}

export enum QueryInstrumentsMode {
    All = 0,
    OnlyExisting = 1,
    OnlyNew = 2,
}

export class ChangeInstrumentRequest implements IChangeInstrumentRequest {
    instrumentId?: string;
    targetAvailableInstrument?: AvailableInstrument;

    constructor(data?: IChangeInstrumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instrumentId = _data["InstrumentId"];
            this.targetAvailableInstrument = _data["TargetAvailableInstrument"] ? AvailableInstrument.fromJS(_data["TargetAvailableInstrument"]) : undefined as any;
        }
    }

    static fromJS(data: any): ChangeInstrumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeInstrumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InstrumentId"] = this.instrumentId;
        data["TargetAvailableInstrument"] = this.targetAvailableInstrument ? this.targetAvailableInstrument.toJSON() : undefined as any;
        return data;
    }
}

export interface IChangeInstrumentRequest {
    instrumentId?: string;
    targetAvailableInstrument?: AvailableInstrument;
}

export class UnconvertedInstrumentsViewModel implements IUnconvertedInstrumentsViewModel {
    instrument?: Instrument;
    availableInstrument?: AvailableInstrument;
    newInstrument?: Instrument;
    newAvailableInstrument?: AvailableInstrument;

    constructor(data?: IUnconvertedInstrumentsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instrument = _data["Instrument"] ? Instrument.fromJS(_data["Instrument"]) : undefined as any;
            this.availableInstrument = _data["AvailableInstrument"] ? AvailableInstrument.fromJS(_data["AvailableInstrument"]) : undefined as any;
            this.newInstrument = _data["NewInstrument"] ? Instrument.fromJS(_data["NewInstrument"]) : undefined as any;
            this.newAvailableInstrument = _data["NewAvailableInstrument"] ? AvailableInstrument.fromJS(_data["NewAvailableInstrument"]) : undefined as any;
        }
    }

    static fromJS(data: any): UnconvertedInstrumentsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UnconvertedInstrumentsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["AvailableInstrument"] = this.availableInstrument ? this.availableInstrument.toJSON() : undefined as any;
        data["NewInstrument"] = this.newInstrument ? this.newInstrument.toJSON() : undefined as any;
        data["NewAvailableInstrument"] = this.newAvailableInstrument ? this.newAvailableInstrument.toJSON() : undefined as any;
        return data;
    }
}

export interface IUnconvertedInstrumentsViewModel {
    instrument?: Instrument;
    availableInstrument?: AvailableInstrument;
    newInstrument?: Instrument;
    newAvailableInstrument?: AvailableInstrument;
}

export class InstrumentWithTaxValuesViewModel implements IInstrumentWithTaxValuesViewModel {
    id?: number;
    uuid?: string;
    name?: string | undefined;
    isin?: string | undefined;
    currency?: string | undefined;
    type?: string | undefined;
    quantity?: number | undefined;
    instrumentTaxValueStateId?: string | undefined;
    fromDate?: string | undefined;
    taxValuePerUnit?: number | undefined;
    taxValue?: number | undefined;
    updated?: string | undefined;
    by?: string | undefined;
    comment?: string | undefined;
    instrumentTaxValueStateDocumentId?: string | undefined;
    taxValues?: InstrumentTaxValueStateViewModel[];

    constructor(data?: IInstrumentWithTaxValuesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.uuid = _data["Uuid"];
            this.name = _data["Name"];
            this.isin = _data["Isin"];
            this.currency = _data["Currency"];
            this.type = _data["Type"];
            this.quantity = _data["Quantity"];
            this.instrumentTaxValueStateId = _data["InstrumentTaxValueStateId"];
            this.fromDate = _data["FromDate"];
            this.taxValuePerUnit = _data["TaxValuePerUnit"];
            this.taxValue = _data["TaxValue"];
            this.updated = _data["Updated"];
            this.by = _data["By"];
            this.comment = _data["Comment"];
            this.instrumentTaxValueStateDocumentId = _data["InstrumentTaxValueStateDocumentId"];
            if (Array.isArray(_data["TaxValues"])) {
                this.taxValues = [] as any;
                for (let item of _data["TaxValues"])
                    this.taxValues!.push(InstrumentTaxValueStateViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstrumentWithTaxValuesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentWithTaxValuesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Uuid"] = this.uuid;
        data["Name"] = this.name;
        data["Isin"] = this.isin;
        data["Currency"] = this.currency;
        data["Type"] = this.type;
        data["Quantity"] = this.quantity;
        data["InstrumentTaxValueStateId"] = this.instrumentTaxValueStateId;
        data["FromDate"] = this.fromDate;
        data["TaxValuePerUnit"] = this.taxValuePerUnit;
        data["TaxValue"] = this.taxValue;
        data["Updated"] = this.updated;
        data["By"] = this.by;
        data["Comment"] = this.comment;
        data["InstrumentTaxValueStateDocumentId"] = this.instrumentTaxValueStateDocumentId;
        if (Array.isArray(this.taxValues)) {
            data["TaxValues"] = [];
            for (let item of this.taxValues)
                data["TaxValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInstrumentWithTaxValuesViewModel {
    id?: number;
    uuid?: string;
    name?: string | undefined;
    isin?: string | undefined;
    currency?: string | undefined;
    type?: string | undefined;
    quantity?: number | undefined;
    instrumentTaxValueStateId?: string | undefined;
    fromDate?: string | undefined;
    taxValuePerUnit?: number | undefined;
    taxValue?: number | undefined;
    updated?: string | undefined;
    by?: string | undefined;
    comment?: string | undefined;
    instrumentTaxValueStateDocumentId?: string | undefined;
    taxValues?: InstrumentTaxValueStateViewModel[];
}

export class InstrumentTaxValueStateViewModel implements IInstrumentTaxValueStateViewModel {
    correlationId?: string;
    symbol?: string;
    taxValue?: number | undefined;
    fromDate?: string | undefined;
    comment?: string | undefined;
    created?: string;
    createdBy?: string;
    updated?: string | undefined;
    updatedBy?: string | undefined;
    hasDocuments?: boolean;
    state?: string;

    constructor(data?: IInstrumentTaxValueStateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correlationId = _data["CorrelationId"];
            this.symbol = _data["Symbol"];
            this.taxValue = _data["TaxValue"];
            this.fromDate = _data["FromDate"];
            this.comment = _data["Comment"];
            this.created = _data["Created"];
            this.createdBy = _data["CreatedBy"];
            this.updated = _data["Updated"];
            this.updatedBy = _data["UpdatedBy"];
            this.hasDocuments = _data["HasDocuments"];
            this.state = _data["State"];
        }
    }

    static fromJS(data: any): InstrumentTaxValueStateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentTaxValueStateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CorrelationId"] = this.correlationId;
        data["Symbol"] = this.symbol;
        data["TaxValue"] = this.taxValue;
        data["FromDate"] = this.fromDate;
        data["Comment"] = this.comment;
        data["Created"] = this.created;
        data["CreatedBy"] = this.createdBy;
        data["Updated"] = this.updated;
        data["UpdatedBy"] = this.updatedBy;
        data["HasDocuments"] = this.hasDocuments;
        data["State"] = this.state;
        return data;
    }
}

export interface IInstrumentTaxValueStateViewModel {
    correlationId?: string;
    symbol?: string;
    taxValue?: number | undefined;
    fromDate?: string | undefined;
    comment?: string | undefined;
    created?: string;
    createdBy?: string;
    updated?: string | undefined;
    updatedBy?: string | undefined;
    hasDocuments?: boolean;
    state?: string;
}

export class SyncInstrumentTaxValue implements ISyncInstrumentTaxValue {
    correlationId?: string;
    userEmail?: string;

    constructor(data?: ISyncInstrumentTaxValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correlationId = _data["CorrelationId"];
            this.userEmail = _data["UserEmail"];
        }
    }

    static fromJS(data: any): SyncInstrumentTaxValue {
        data = typeof data === 'object' ? data : {};
        let result = new SyncInstrumentTaxValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CorrelationId"] = this.correlationId;
        data["UserEmail"] = this.userEmail;
        return data;
    }
}

export interface ISyncInstrumentTaxValue {
    correlationId?: string;
    userEmail?: string;
}

export class UpdateInstrumentTaxValue implements IUpdateInstrumentTaxValue {
    correlationId?: string;
    userEmail?: string;
    taxValue?: number;
    fromDate?: string;
    comment?: string | undefined;
    companyIdentityId?: number;

    constructor(data?: IUpdateInstrumentTaxValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correlationId = _data["CorrelationId"];
            this.userEmail = _data["UserEmail"];
            this.taxValue = _data["TaxValue"];
            this.fromDate = _data["FromDate"];
            this.comment = _data["Comment"];
            this.companyIdentityId = _data["CompanyIdentityId"];
        }
    }

    static fromJS(data: any): UpdateInstrumentTaxValue {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInstrumentTaxValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CorrelationId"] = this.correlationId;
        data["UserEmail"] = this.userEmail;
        data["TaxValue"] = this.taxValue;
        data["FromDate"] = this.fromDate;
        data["Comment"] = this.comment;
        data["CompanyIdentityId"] = this.companyIdentityId;
        return data;
    }
}

export interface IUpdateInstrumentTaxValue {
    correlationId?: string;
    userEmail?: string;
    taxValue?: number;
    fromDate?: string;
    comment?: string | undefined;
    companyIdentityId?: number;
}

export class IsinTaxableConfiguration implements IIsinTaxableConfiguration {
    id?: number;
    isin?: string | undefined;
    taxable?: boolean;

    constructor(data?: IIsinTaxableConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.isin = _data["Isin"];
            this.taxable = _data["Taxable"];
        }
    }

    static fromJS(data: any): IsinTaxableConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new IsinTaxableConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Isin"] = this.isin;
        data["Taxable"] = this.taxable;
        return data;
    }
}

export interface IIsinTaxableConfiguration {
    id?: number;
    isin?: string | undefined;
    taxable?: boolean;
}

export class Mandate implements IMandate {
    id?: string;
    customerId?: string;
    customer?: Customer | undefined;
    instrumentType?: InstrumentTypeEnum | undefined;
    categoryId?: number | undefined;
    category?: Category | undefined;
    percentage?: number;
    created?: string;
    createdById?: number;
    createdBy?: User | undefined;

    constructor(data?: IMandate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.customerId = _data["CustomerId"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            this.instrumentType = _data["InstrumentType"];
            this.categoryId = _data["CategoryId"];
            this.category = _data["Category"] ? Category.fromJS(_data["Category"]) : undefined as any;
            this.percentage = _data["Percentage"];
            this.created = _data["Created"];
            this.createdById = _data["CreatedById"];
            this.createdBy = _data["CreatedBy"] ? User.fromJS(_data["CreatedBy"]) : undefined as any;
        }
    }

    static fromJS(data: any): Mandate {
        data = typeof data === 'object' ? data : {};
        let result = new Mandate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CustomerId"] = this.customerId;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["InstrumentType"] = this.instrumentType;
        data["CategoryId"] = this.categoryId;
        data["Category"] = this.category ? this.category.toJSON() : undefined as any;
        data["Percentage"] = this.percentage;
        data["Created"] = this.created;
        data["CreatedById"] = this.createdById;
        data["CreatedBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        return data;
    }
}

export interface IMandate {
    id?: string;
    customerId?: string;
    customer?: Customer | undefined;
    instrumentType?: InstrumentTypeEnum | undefined;
    categoryId?: number | undefined;
    category?: Category | undefined;
    percentage?: number;
    created?: string;
    createdById?: number;
    createdBy?: User | undefined;
}

export class AgGridResponseOfPriceViewModel implements IAgGridResponseOfPriceViewModel {
    rowData?: PriceViewModel[];
    rowCount?: number;

    constructor(data?: IAgGridResponseOfPriceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["RowData"])) {
                this.rowData = [] as any;
                for (let item of _data["RowData"])
                    this.rowData!.push(PriceViewModel.fromJS(item));
            }
            this.rowCount = _data["RowCount"];
        }
    }

    static fromJS(data: any): AgGridResponseOfPriceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgGridResponseOfPriceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rowData)) {
            data["RowData"] = [];
            for (let item of this.rowData)
                data["RowData"].push(item ? item.toJSON() : undefined as any);
        }
        data["RowCount"] = this.rowCount;
        return data;
    }
}

export interface IAgGridResponseOfPriceViewModel {
    rowData?: PriceViewModel[];
    rowCount?: number;
}

export class PriceViewModel implements IPriceViewModel {
    id?: number;
    instrumentId?: number | undefined;
    symbol?: string | undefined;
    sellPrice?: number;
    currencyCode?: string;
    fromDate?: string;
    toDate?: string | undefined;
    sellPriceAdjusted?: number;
    comment?: string | undefined;
    created?: string;
    createdBy?: string;
    updated?: string | undefined;
    updatedBy?: string | undefined;
    hasDocuments?: boolean;

    constructor(data?: IPriceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.instrumentId = _data["InstrumentId"];
            this.symbol = _data["Symbol"];
            this.sellPrice = _data["SellPrice"];
            this.currencyCode = _data["CurrencyCode"];
            this.fromDate = _data["FromDate"];
            this.toDate = _data["ToDate"];
            this.sellPriceAdjusted = _data["SellPriceAdjusted"];
            this.comment = _data["Comment"];
            this.created = _data["Created"];
            this.createdBy = _data["CreatedBy"];
            this.updated = _data["Updated"];
            this.updatedBy = _data["UpdatedBy"];
            this.hasDocuments = _data["HasDocuments"];
        }
    }

    static fromJS(data: any): PriceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["InstrumentId"] = this.instrumentId;
        data["Symbol"] = this.symbol;
        data["SellPrice"] = this.sellPrice;
        data["CurrencyCode"] = this.currencyCode;
        data["FromDate"] = this.fromDate;
        data["ToDate"] = this.toDate;
        data["SellPriceAdjusted"] = this.sellPriceAdjusted;
        data["Comment"] = this.comment;
        data["Created"] = this.created;
        data["CreatedBy"] = this.createdBy;
        data["Updated"] = this.updated;
        data["UpdatedBy"] = this.updatedBy;
        data["HasDocuments"] = this.hasDocuments;
        return data;
    }
}

export interface IPriceViewModel {
    id?: number;
    instrumentId?: number | undefined;
    symbol?: string | undefined;
    sellPrice?: number;
    currencyCode?: string;
    fromDate?: string;
    toDate?: string | undefined;
    sellPriceAdjusted?: number;
    comment?: string | undefined;
    created?: string;
    createdBy?: string;
    updated?: string | undefined;
    updatedBy?: string | undefined;
    hasDocuments?: boolean;
}

export class ManualValueMinMaxDateViewModel implements IManualValueMinMaxDateViewModel {
    id?: number;
    fromDate?: string | undefined;
    toDate?: string | undefined;

    constructor(data?: IManualValueMinMaxDateViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fromDate = _data["FromDate"];
            this.toDate = _data["ToDate"];
        }
    }

    static fromJS(data: any): ManualValueMinMaxDateViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ManualValueMinMaxDateViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FromDate"] = this.fromDate;
        data["ToDate"] = this.toDate;
        return data;
    }
}

export interface IManualValueMinMaxDateViewModel {
    id?: number;
    fromDate?: string | undefined;
    toDate?: string | undefined;
}

export class InstrumentsViewModelOfInstrumentViewModel implements IInstrumentsViewModelOfInstrumentViewModel {
    rowCount?: number;
    rows?: InstrumentViewModel[];

    constructor(data?: IInstrumentsViewModelOfInstrumentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowCount = _data["RowCount"];
            if (Array.isArray(_data["Rows"])) {
                this.rows = [] as any;
                for (let item of _data["Rows"])
                    this.rows!.push(InstrumentViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstrumentsViewModelOfInstrumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InstrumentsViewModelOfInstrumentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RowCount"] = this.rowCount;
        if (Array.isArray(this.rows)) {
            data["Rows"] = [];
            for (let item of this.rows)
                data["Rows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInstrumentsViewModelOfInstrumentViewModel {
    rowCount?: number;
    rows?: InstrumentViewModel[];
}

export class OverViewRequestViewModel implements IOverViewRequestViewModel {
    toDate?: string;
    showAll?: boolean;
    portfolio?: string | undefined;

    constructor(data?: IOverViewRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toDate = _data["ToDate"];
            this.showAll = _data["ShowAll"];
            this.portfolio = _data["Portfolio"];
        }
    }

    static fromJS(data: any): OverViewRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OverViewRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ToDate"] = this.toDate;
        data["ShowAll"] = this.showAll;
        data["Portfolio"] = this.portfolio;
        return data;
    }
}

export interface IOverViewRequestViewModel {
    toDate?: string;
    showAll?: boolean;
    portfolio?: string | undefined;
}

/** Represents a line in the response for the latest instrument account. */
export class LatestInstrumentAccountResponseLine implements ILatestInstrumentAccountResponseLine {
    instrumentUuid?: string;
    latestAccountNumber?: number;

    constructor(data?: ILatestInstrumentAccountResponseLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instrumentUuid = _data["InstrumentUuid"];
            this.latestAccountNumber = _data["LatestAccountNumber"];
        }
    }

    static fromJS(data: any): LatestInstrumentAccountResponseLine {
        data = typeof data === 'object' ? data : {};
        let result = new LatestInstrumentAccountResponseLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InstrumentUuid"] = this.instrumentUuid;
        data["LatestAccountNumber"] = this.latestAccountNumber;
        return data;
    }
}

/** Represents a line in the response for the latest instrument account. */
export interface ILatestInstrumentAccountResponseLine {
    instrumentUuid?: string;
    latestAccountNumber?: number;
}

export class JobStateResponse implements IJobStateResponse {
    jobId?: string;
    submitted?: string | undefined;
    started?: string | undefined;
    completed?: string | undefined;
    duration?: string | undefined;
    faulted?: string | undefined;
    reason?: string | undefined;
    lastRetryAttempt?: number;
    currentState?: string;
    progressValue?: number | undefined;
    progressLimit?: number | undefined;
    jobState?: { [key: string]: any; } | undefined;
    nextStartDate?: string | undefined;
    isRecurring?: boolean;
    startDate?: string | undefined;
    endDate?: string | undefined;

    constructor(data?: IJobStateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["JobId"];
            this.submitted = _data["Submitted"];
            this.started = _data["Started"];
            this.completed = _data["Completed"];
            this.duration = _data["Duration"];
            this.faulted = _data["Faulted"];
            this.reason = _data["Reason"];
            this.lastRetryAttempt = _data["LastRetryAttempt"];
            this.currentState = _data["CurrentState"];
            this.progressValue = _data["ProgressValue"];
            this.progressLimit = _data["ProgressLimit"];
            if (_data["JobState"]) {
                this.jobState = {} as any;
                for (let key in _data["JobState"]) {
                    if (_data["JobState"].hasOwnProperty(key))
                        (this.jobState as any)![key] = _data["JobState"][key];
                }
            }
            this.nextStartDate = _data["NextStartDate"];
            this.isRecurring = _data["IsRecurring"];
            this.startDate = _data["StartDate"];
            this.endDate = _data["EndDate"];
        }
    }

    static fromJS(data: any): JobStateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new JobStateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["JobId"] = this.jobId;
        data["Submitted"] = this.submitted;
        data["Started"] = this.started;
        data["Completed"] = this.completed;
        data["Duration"] = this.duration;
        data["Faulted"] = this.faulted;
        data["Reason"] = this.reason;
        data["LastRetryAttempt"] = this.lastRetryAttempt;
        data["CurrentState"] = this.currentState;
        data["ProgressValue"] = this.progressValue;
        data["ProgressLimit"] = this.progressLimit;
        if (this.jobState) {
            data["JobState"] = {};
            for (let key in this.jobState) {
                if (this.jobState.hasOwnProperty(key))
                    (data["JobState"] as any)[key] = (this.jobState as any)[key];
            }
        }
        data["NextStartDate"] = this.nextStartDate;
        data["IsRecurring"] = this.isRecurring;
        data["StartDate"] = this.startDate;
        data["EndDate"] = this.endDate;
        return data;
    }
}

export interface IJobStateResponse {
    jobId?: string;
    submitted?: string | undefined;
    started?: string | undefined;
    completed?: string | undefined;
    duration?: string | undefined;
    faulted?: string | undefined;
    reason?: string | undefined;
    lastRetryAttempt?: number;
    currentState?: string;
    progressValue?: number | undefined;
    progressLimit?: number | undefined;
    jobState?: { [key: string]: any; } | undefined;
    nextStartDate?: string | undefined;
    isRecurring?: boolean;
    startDate?: string | undefined;
    endDate?: string | undefined;
}

export class InsightReconcileSummaryResponse implements IInsightReconcileSummaryResponse {
    accountNumber?: number | undefined;
    incomingBalance?: number | undefined;
    postedAmount?: number | undefined;
    createdAmount?: number | undefined;
    balance?: number | undefined;

    constructor(data?: IInsightReconcileSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["AccountNumber"];
            this.incomingBalance = _data["IncomingBalance"];
            this.postedAmount = _data["PostedAmount"];
            this.createdAmount = _data["CreatedAmount"];
            this.balance = _data["Balance"];
        }
    }

    static fromJS(data: any): InsightReconcileSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsightReconcileSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountNumber"] = this.accountNumber;
        data["IncomingBalance"] = this.incomingBalance;
        data["PostedAmount"] = this.postedAmount;
        data["CreatedAmount"] = this.createdAmount;
        data["Balance"] = this.balance;
        return data;
    }
}

export interface IInsightReconcileSummaryResponse {
    accountNumber?: number | undefined;
    incomingBalance?: number | undefined;
    postedAmount?: number | undefined;
    createdAmount?: number | undefined;
    balance?: number | undefined;
}

export class TaxValuesImport implements ITaxValuesImport {
    id?: number;
    date?: string;
    fileName?: string | undefined;
    type?: TaxValuesImportType;
    customerId?: number | undefined;
    customer?: Customer | undefined;
    rows?: TaxValuesImportRow[] | undefined;

    constructor(data?: ITaxValuesImport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.date = _data["Date"];
            this.fileName = _data["FileName"];
            this.type = _data["Type"];
            this.customerId = _data["CustomerId"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            if (Array.isArray(_data["Rows"])) {
                this.rows = [] as any;
                for (let item of _data["Rows"])
                    this.rows!.push(TaxValuesImportRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxValuesImport {
        data = typeof data === 'object' ? data : {};
        let result = new TaxValuesImport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Date"] = this.date;
        data["FileName"] = this.fileName;
        data["Type"] = this.type;
        data["CustomerId"] = this.customerId;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        if (Array.isArray(this.rows)) {
            data["Rows"] = [];
            for (let item of this.rows)
                data["Rows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaxValuesImport {
    id?: number;
    date?: string;
    fileName?: string | undefined;
    type?: TaxValuesImportType;
    customerId?: number | undefined;
    customer?: Customer | undefined;
    rows?: TaxValuesImportRow[] | undefined;
}

export enum TaxValuesImportType {
    Vpff = 0,
}

export class TaxValuesImportRow implements ITaxValuesImportRow {
    id?: number;
    taxValuesImportId?: number;
    import?: TaxValuesImport | undefined;
    isin?: string | undefined;
    name?: string | undefined;
    price?: number;
    worksheetName?: string | undefined;
    comment?: string | undefined;

    constructor(data?: ITaxValuesImportRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.taxValuesImportId = _data["TaxValuesImportId"];
            this.import = _data["Import"] ? TaxValuesImport.fromJS(_data["Import"]) : undefined as any;
            this.isin = _data["Isin"];
            this.name = _data["Name"];
            this.price = _data["Price"];
            this.worksheetName = _data["WorksheetName"];
            this.comment = _data["Comment"];
        }
    }

    static fromJS(data: any): TaxValuesImportRow {
        data = typeof data === 'object' ? data : {};
        let result = new TaxValuesImportRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["TaxValuesImportId"] = this.taxValuesImportId;
        data["Import"] = this.import ? this.import.toJSON() : undefined as any;
        data["Isin"] = this.isin;
        data["Name"] = this.name;
        data["Price"] = this.price;
        data["WorksheetName"] = this.worksheetName;
        data["Comment"] = this.comment;
        return data;
    }
}

export interface ITaxValuesImportRow {
    id?: number;
    taxValuesImportId?: number;
    import?: TaxValuesImport | undefined;
    isin?: string | undefined;
    name?: string | undefined;
    price?: number;
    worksheetName?: string | undefined;
    comment?: string | undefined;
}

export class GroupedTransactionsViewModel implements IGroupedTransactionsViewModel {
    documentMetaId?: number | undefined;
    quantity?: number | undefined;
    dividend?: number | undefined;
    interests?: number | undefined;
    amount?: number | undefined;
    currencyAmount?: number | undefined;
    currencyCode?: string | undefined;
    portfolioName?: string | undefined;
    portfolioTicker?: string;
    portfolioId?: number | undefined;
    companyName?: string;
    companyId?: number | undefined;
    lastTransactionDate?: string | undefined;
    lastActionType?: number;
    profit?: number | undefined;
    documentId?: string | undefined;
    avgProfit?: number | undefined;
    legacyRetractable?: boolean;
    hasRetractedTransactions?: boolean;
    created?: string | undefined;
    externalDocumentId?: number | undefined;
    externalRowId?: number | undefined;
    voucherId?: string | undefined;
    activityType?: string | undefined;
    lastDetail?: TransactionsGroupedDetailViewModel | undefined;
    groupKey?: string;
    legacySendToGlable?: boolean;
    legacySendToGlableInt?: number;
    canCreateGlTransactions?: boolean;
    canPostGlTransactions?: boolean;
    voucherNr?: string | undefined;
    canRetractTransactions?: boolean;
    glDocumentUploadFailed?: boolean;
    canPostGlRetractTransactions?: boolean;
    canConfirmGlPosting?: boolean;
    canChangeBankAccount?: boolean;
    transactionDate?: string | undefined;
    transactionComment?: string | undefined;
    retractPostingOverrideDate?: string | undefined;

    constructor(data?: IGroupedTransactionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentMetaId = _data["DocumentMetaId"];
            this.quantity = _data["Quantity"];
            this.dividend = _data["Dividend"];
            this.interests = _data["Interests"];
            this.amount = _data["Amount"];
            this.currencyAmount = _data["CurrencyAmount"];
            this.currencyCode = _data["CurrencyCode"];
            this.portfolioName = _data["PortfolioName"];
            this.portfolioTicker = _data["PortfolioTicker"];
            this.portfolioId = _data["PortfolioId"];
            this.companyName = _data["CompanyName"];
            this.companyId = _data["CompanyId"];
            this.lastTransactionDate = _data["LastTransactionDate"];
            this.lastActionType = _data["LastActionType"];
            this.profit = _data["Profit"];
            this.documentId = _data["DocumentId"];
            this.avgProfit = _data["AvgProfit"];
            this.legacyRetractable = _data["LegacyRetractable"];
            this.hasRetractedTransactions = _data["HasRetractedTransactions"];
            this.created = _data["Created"];
            this.externalDocumentId = _data["ExternalDocumentId"];
            this.externalRowId = _data["ExternalRowId"];
            this.voucherId = _data["VoucherId"];
            this.activityType = _data["ActivityType"];
            this.lastDetail = _data["LastDetail"] ? TransactionsGroupedDetailViewModel.fromJS(_data["LastDetail"]) : undefined as any;
            this.groupKey = _data["GroupKey"];
            this.legacySendToGlable = _data["LegacySendToGlable"];
            this.legacySendToGlableInt = _data["LegacySendToGlableInt"];
            this.canCreateGlTransactions = _data["CanCreateGlTransactions"];
            this.canPostGlTransactions = _data["CanPostGlTransactions"];
            this.voucherNr = _data["VoucherNr"];
            this.canRetractTransactions = _data["CanRetractTransactions"];
            this.glDocumentUploadFailed = _data["GlDocumentUploadFailed"];
            this.canPostGlRetractTransactions = _data["CanPostGlRetractTransactions"];
            this.canConfirmGlPosting = _data["CanConfirmGlPosting"];
            this.canChangeBankAccount = _data["CanChangeBankAccount"];
            this.transactionDate = _data["TransactionDate"];
            this.transactionComment = _data["TransactionComment"];
            this.retractPostingOverrideDate = _data["RetractPostingOverrideDate"];
        }
    }

    static fromJS(data: any): GroupedTransactionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedTransactionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DocumentMetaId"] = this.documentMetaId;
        data["Quantity"] = this.quantity;
        data["Dividend"] = this.dividend;
        data["Interests"] = this.interests;
        data["Amount"] = this.amount;
        data["CurrencyAmount"] = this.currencyAmount;
        data["CurrencyCode"] = this.currencyCode;
        data["PortfolioName"] = this.portfolioName;
        data["PortfolioTicker"] = this.portfolioTicker;
        data["PortfolioId"] = this.portfolioId;
        data["CompanyName"] = this.companyName;
        data["CompanyId"] = this.companyId;
        data["LastTransactionDate"] = this.lastTransactionDate;
        data["LastActionType"] = this.lastActionType;
        data["Profit"] = this.profit;
        data["DocumentId"] = this.documentId;
        data["AvgProfit"] = this.avgProfit;
        data["LegacyRetractable"] = this.legacyRetractable;
        data["HasRetractedTransactions"] = this.hasRetractedTransactions;
        data["Created"] = this.created;
        data["ExternalDocumentId"] = this.externalDocumentId;
        data["ExternalRowId"] = this.externalRowId;
        data["VoucherId"] = this.voucherId;
        data["ActivityType"] = this.activityType;
        data["LastDetail"] = this.lastDetail ? this.lastDetail.toJSON() : undefined as any;
        data["GroupKey"] = this.groupKey;
        data["LegacySendToGlable"] = this.legacySendToGlable;
        data["LegacySendToGlableInt"] = this.legacySendToGlableInt;
        data["CanCreateGlTransactions"] = this.canCreateGlTransactions;
        data["CanPostGlTransactions"] = this.canPostGlTransactions;
        data["VoucherNr"] = this.voucherNr;
        data["CanRetractTransactions"] = this.canRetractTransactions;
        data["GlDocumentUploadFailed"] = this.glDocumentUploadFailed;
        data["CanPostGlRetractTransactions"] = this.canPostGlRetractTransactions;
        data["CanConfirmGlPosting"] = this.canConfirmGlPosting;
        data["CanChangeBankAccount"] = this.canChangeBankAccount;
        data["TransactionDate"] = this.transactionDate;
        data["TransactionComment"] = this.transactionComment;
        data["RetractPostingOverrideDate"] = this.retractPostingOverrideDate;
        return data;
    }
}

export interface IGroupedTransactionsViewModel {
    documentMetaId?: number | undefined;
    quantity?: number | undefined;
    dividend?: number | undefined;
    interests?: number | undefined;
    amount?: number | undefined;
    currencyAmount?: number | undefined;
    currencyCode?: string | undefined;
    portfolioName?: string | undefined;
    portfolioTicker?: string;
    portfolioId?: number | undefined;
    companyName?: string;
    companyId?: number | undefined;
    lastTransactionDate?: string | undefined;
    lastActionType?: number;
    profit?: number | undefined;
    documentId?: string | undefined;
    avgProfit?: number | undefined;
    legacyRetractable?: boolean;
    hasRetractedTransactions?: boolean;
    created?: string | undefined;
    externalDocumentId?: number | undefined;
    externalRowId?: number | undefined;
    voucherId?: string | undefined;
    activityType?: string | undefined;
    lastDetail?: TransactionsGroupedDetailViewModel | undefined;
    groupKey?: string;
    legacySendToGlable?: boolean;
    legacySendToGlableInt?: number;
    canCreateGlTransactions?: boolean;
    canPostGlTransactions?: boolean;
    voucherNr?: string | undefined;
    canRetractTransactions?: boolean;
    glDocumentUploadFailed?: boolean;
    canPostGlRetractTransactions?: boolean;
    canConfirmGlPosting?: boolean;
    canChangeBankAccount?: boolean;
    transactionDate?: string | undefined;
    transactionComment?: string | undefined;
    retractPostingOverrideDate?: string | undefined;
}

export class TransactionViewmodel implements ITransactionViewmodel {
    id?: number | undefined;
    actionType?: ActionType | undefined;
    name?: string;
    reportName?: string;
    quantity?: number | undefined;
    amount?: number | undefined;
    interests?: number | undefined;
    sellPrice?: number | undefined;
    eventDate?: string | undefined;
    createdBy?: string | undefined;
    voucherNr?: string;
    gLId?: string | undefined;
    fee?: number | undefined;
    broker?: string;
    retractable?: boolean;
    glTransactionStatus?: GlStatus;
    glRetractedStatus?: GlStatus;
    failCount?: number | undefined;
    manualPriceUpdate?: boolean;
    companyName?: string;
    companyId?: number;
    documentMetaId?: number;
    externalGeneralledgerId?: string | undefined;
    retracted?: boolean;
    retractedDate?: string | undefined;
    categories?: CategoryViewModel[];
    instrument?: InstrumentViewModel;
    currencyAmount?: number | undefined;
    created?: string | undefined;
    externalDocumentId?: number | undefined;
    externalRowId?: number | undefined;
    documentId?: string | undefined;
    voucherId?: string | undefined;
    transactionComment?: string | undefined;
    currencyCode?: string;
    account?: string | undefined;
    glDocumentStatusFailed?: boolean;
    sendGlTransactionsJobId?: string | undefined;
    sendGlRetractTransactionsJobId?: string | undefined;
    parentId?: number | undefined;
    parentVoucher?: string | undefined;
    parentTransactionDate?: string | undefined;
    grandParentId?: number | undefined;
    grandParentVoucher?: string | undefined;
    grandParentTransactionDate?: string | undefined;
    parentGlAccounts?: string | undefined;
    grandParentGlAccounts?: string | undefined;
    parentGlTransactionStatus?: GlStatus | undefined;
    grandParentGlTransactionStatus?: GlStatus | undefined;

    constructor(data?: ITransactionViewmodel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.actionType = _data["ActionType"];
            this.name = _data["Name"];
            this.reportName = _data["ReportName"];
            this.quantity = _data["Quantity"];
            this.amount = _data["Amount"];
            this.interests = _data["Interests"];
            this.sellPrice = _data["SellPrice"];
            this.eventDate = _data["EventDate"];
            this.createdBy = _data["CreatedBy"];
            this.voucherNr = _data["VoucherNr"];
            this.gLId = _data["GLId"];
            this.fee = _data["Fee"];
            this.broker = _data["Broker"];
            this.retractable = _data["Retractable"];
            this.glTransactionStatus = _data["GlTransactionStatus"];
            this.glRetractedStatus = _data["GlRetractedStatus"];
            this.failCount = _data["FailCount"];
            this.manualPriceUpdate = _data["ManualPriceUpdate"];
            this.companyName = _data["CompanyName"];
            this.companyId = _data["CompanyId"];
            this.documentMetaId = _data["DocumentMetaId"];
            this.externalGeneralledgerId = _data["ExternalGeneralledgerId"];
            this.retracted = _data["Retracted"];
            this.retractedDate = _data["RetractedDate"];
            if (Array.isArray(_data["Categories"])) {
                this.categories = [] as any;
                for (let item of _data["Categories"])
                    this.categories!.push(CategoryViewModel.fromJS(item));
            }
            this.instrument = _data["Instrument"] ? InstrumentViewModel.fromJS(_data["Instrument"]) : undefined as any;
            this.currencyAmount = _data["CurrencyAmount"];
            this.created = _data["Created"];
            this.externalDocumentId = _data["ExternalDocumentId"];
            this.externalRowId = _data["ExternalRowId"];
            this.documentId = _data["DocumentId"];
            this.voucherId = _data["VoucherId"];
            this.transactionComment = _data["TransactionComment"];
            this.currencyCode = _data["CurrencyCode"];
            this.account = _data["Account"];
            this.glDocumentStatusFailed = _data["GlDocumentStatusFailed"];
            this.sendGlTransactionsJobId = _data["SendGlTransactionsJobId"];
            this.sendGlRetractTransactionsJobId = _data["SendGlRetractTransactionsJobId"];
            this.parentId = _data["ParentId"];
            this.parentVoucher = _data["ParentVoucher"];
            this.parentTransactionDate = _data["ParentTransactionDate"];
            this.grandParentId = _data["GrandParentId"];
            this.grandParentVoucher = _data["GrandParentVoucher"];
            this.grandParentTransactionDate = _data["GrandParentTransactionDate"];
            this.parentGlAccounts = _data["ParentGlAccounts"];
            this.grandParentGlAccounts = _data["GrandParentGlAccounts"];
            this.parentGlTransactionStatus = _data["ParentGlTransactionStatus"];
            this.grandParentGlTransactionStatus = _data["GrandParentGlTransactionStatus"];
        }
    }

    static fromJS(data: any): TransactionViewmodel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionViewmodel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ActionType"] = this.actionType;
        data["Name"] = this.name;
        data["ReportName"] = this.reportName;
        data["Quantity"] = this.quantity;
        data["Amount"] = this.amount;
        data["Interests"] = this.interests;
        data["SellPrice"] = this.sellPrice;
        data["EventDate"] = this.eventDate;
        data["CreatedBy"] = this.createdBy;
        data["VoucherNr"] = this.voucherNr;
        data["GLId"] = this.gLId;
        data["Fee"] = this.fee;
        data["Broker"] = this.broker;
        data["Retractable"] = this.retractable;
        data["GlTransactionStatus"] = this.glTransactionStatus;
        data["GlRetractedStatus"] = this.glRetractedStatus;
        data["FailCount"] = this.failCount;
        data["ManualPriceUpdate"] = this.manualPriceUpdate;
        data["CompanyName"] = this.companyName;
        data["CompanyId"] = this.companyId;
        data["DocumentMetaId"] = this.documentMetaId;
        data["ExternalGeneralledgerId"] = this.externalGeneralledgerId;
        data["Retracted"] = this.retracted;
        data["RetractedDate"] = this.retractedDate;
        if (Array.isArray(this.categories)) {
            data["Categories"] = [];
            for (let item of this.categories)
                data["Categories"].push(item ? item.toJSON() : undefined as any);
        }
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["CurrencyAmount"] = this.currencyAmount;
        data["Created"] = this.created;
        data["ExternalDocumentId"] = this.externalDocumentId;
        data["ExternalRowId"] = this.externalRowId;
        data["DocumentId"] = this.documentId;
        data["VoucherId"] = this.voucherId;
        data["TransactionComment"] = this.transactionComment;
        data["CurrencyCode"] = this.currencyCode;
        data["Account"] = this.account;
        data["GlDocumentStatusFailed"] = this.glDocumentStatusFailed;
        data["SendGlTransactionsJobId"] = this.sendGlTransactionsJobId;
        data["SendGlRetractTransactionsJobId"] = this.sendGlRetractTransactionsJobId;
        data["ParentId"] = this.parentId;
        data["ParentVoucher"] = this.parentVoucher;
        data["ParentTransactionDate"] = this.parentTransactionDate;
        data["GrandParentId"] = this.grandParentId;
        data["GrandParentVoucher"] = this.grandParentVoucher;
        data["GrandParentTransactionDate"] = this.grandParentTransactionDate;
        data["ParentGlAccounts"] = this.parentGlAccounts;
        data["GrandParentGlAccounts"] = this.grandParentGlAccounts;
        data["ParentGlTransactionStatus"] = this.parentGlTransactionStatus;
        data["GrandParentGlTransactionStatus"] = this.grandParentGlTransactionStatus;
        return data;
    }
}

export interface ITransactionViewmodel {
    id?: number | undefined;
    actionType?: ActionType | undefined;
    name?: string;
    reportName?: string;
    quantity?: number | undefined;
    amount?: number | undefined;
    interests?: number | undefined;
    sellPrice?: number | undefined;
    eventDate?: string | undefined;
    createdBy?: string | undefined;
    voucherNr?: string;
    gLId?: string | undefined;
    fee?: number | undefined;
    broker?: string;
    retractable?: boolean;
    glTransactionStatus?: GlStatus;
    glRetractedStatus?: GlStatus;
    failCount?: number | undefined;
    manualPriceUpdate?: boolean;
    companyName?: string;
    companyId?: number;
    documentMetaId?: number;
    externalGeneralledgerId?: string | undefined;
    retracted?: boolean;
    retractedDate?: string | undefined;
    categories?: CategoryViewModel[];
    instrument?: InstrumentViewModel;
    currencyAmount?: number | undefined;
    created?: string | undefined;
    externalDocumentId?: number | undefined;
    externalRowId?: number | undefined;
    documentId?: string | undefined;
    voucherId?: string | undefined;
    transactionComment?: string | undefined;
    currencyCode?: string;
    account?: string | undefined;
    glDocumentStatusFailed?: boolean;
    sendGlTransactionsJobId?: string | undefined;
    sendGlRetractTransactionsJobId?: string | undefined;
    parentId?: number | undefined;
    parentVoucher?: string | undefined;
    parentTransactionDate?: string | undefined;
    grandParentId?: number | undefined;
    grandParentVoucher?: string | undefined;
    grandParentTransactionDate?: string | undefined;
    parentGlAccounts?: string | undefined;
    grandParentGlAccounts?: string | undefined;
    parentGlTransactionStatus?: GlStatus | undefined;
    grandParentGlTransactionStatus?: GlStatus | undefined;
}

export class TransactionsGroupedDetailViewModel implements ITransactionsGroupedDetailViewModel {
    ticker?: string | undefined;
    isin?: string | undefined;
    orgNr?: string | undefined;
    instrumentId?: number | undefined;
    instrumentUuid?: string | undefined;
    created?: string;
    retractable?: boolean;
    name?: string | undefined;
    reportName?: string | undefined;
    lastTransactionDate?: string | undefined;
    description?: string | undefined;
    currencyCode?: string | undefined;
    glVoucherId?: string | undefined;
    portfolio?: string | undefined;
    broker?: string | undefined;
    fee?: number | undefined;
    voucherId?: string | undefined;
    voucherState?: string | undefined;
    documentId?: string | undefined;
    sendGlTransactionsJobId?: string | undefined;
    sendGlRetractTransactionsJobId?: string | undefined;

    constructor(data?: ITransactionsGroupedDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticker = _data["Ticker"];
            this.isin = _data["Isin"];
            this.orgNr = _data["OrgNr"];
            this.instrumentId = _data["InstrumentId"];
            this.instrumentUuid = _data["InstrumentUuid"];
            this.created = _data["Created"];
            this.retractable = _data["Retractable"];
            this.name = _data["Name"];
            this.reportName = _data["ReportName"];
            this.lastTransactionDate = _data["LastTransactionDate"];
            this.description = _data["Description"];
            this.currencyCode = _data["CurrencyCode"];
            this.glVoucherId = _data["GlVoucherId"];
            this.portfolio = _data["Portfolio"];
            this.broker = _data["Broker"];
            this.fee = _data["Fee"];
            this.voucherId = _data["VoucherId"];
            this.voucherState = _data["VoucherState"];
            this.documentId = _data["DocumentId"];
            this.sendGlTransactionsJobId = _data["SendGlTransactionsJobId"];
            this.sendGlRetractTransactionsJobId = _data["SendGlRetractTransactionsJobId"];
        }
    }

    static fromJS(data: any): TransactionsGroupedDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionsGroupedDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Ticker"] = this.ticker;
        data["Isin"] = this.isin;
        data["OrgNr"] = this.orgNr;
        data["InstrumentId"] = this.instrumentId;
        data["InstrumentUuid"] = this.instrumentUuid;
        data["Created"] = this.created;
        data["Retractable"] = this.retractable;
        data["Name"] = this.name;
        data["ReportName"] = this.reportName;
        data["LastTransactionDate"] = this.lastTransactionDate;
        data["Description"] = this.description;
        data["CurrencyCode"] = this.currencyCode;
        data["GlVoucherId"] = this.glVoucherId;
        data["Portfolio"] = this.portfolio;
        data["Broker"] = this.broker;
        data["Fee"] = this.fee;
        data["VoucherId"] = this.voucherId;
        data["VoucherState"] = this.voucherState;
        data["DocumentId"] = this.documentId;
        data["SendGlTransactionsJobId"] = this.sendGlTransactionsJobId;
        data["SendGlRetractTransactionsJobId"] = this.sendGlRetractTransactionsJobId;
        return data;
    }
}

export interface ITransactionsGroupedDetailViewModel {
    ticker?: string | undefined;
    isin?: string | undefined;
    orgNr?: string | undefined;
    instrumentId?: number | undefined;
    instrumentUuid?: string | undefined;
    created?: string;
    retractable?: boolean;
    name?: string | undefined;
    reportName?: string | undefined;
    lastTransactionDate?: string | undefined;
    description?: string | undefined;
    currencyCode?: string | undefined;
    glVoucherId?: string | undefined;
    portfolio?: string | undefined;
    broker?: string | undefined;
    fee?: number | undefined;
    voucherId?: string | undefined;
    voucherState?: string | undefined;
    documentId?: string | undefined;
    sendGlTransactionsJobId?: string | undefined;
    sendGlRetractTransactionsJobId?: string | undefined;
}

export class TransactionCountViewModel implements ITransactionCountViewModel {
    companyIdentityId?: number | undefined;
    transactionCount?: number;
    transactionCountRetracted?: number;
    companyName?: string | undefined;
    instrumentName?: string | undefined;
    transactionCountThisMonth?: number;
    transactionCountThisYear?: number;
    transactionCountLastYear?: number;
    transactionCountThisPeriod?: number;
    transactionCreatedCountThisMonth?: number;
    transactionCreatedCountThisYear?: number;
    transactionCreatedCountThisPeriod?: number;
    lastCreatedTransactionDate?: string | undefined;

    constructor(data?: ITransactionCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyIdentityId = _data["CompanyIdentityId"];
            this.transactionCount = _data["TransactionCount"];
            this.transactionCountRetracted = _data["TransactionCountRetracted"];
            this.companyName = _data["CompanyName"];
            this.instrumentName = _data["InstrumentName"];
            this.transactionCountThisMonth = _data["TransactionCountThisMonth"];
            this.transactionCountThisYear = _data["TransactionCountThisYear"];
            this.transactionCountLastYear = _data["TransactionCountLastYear"];
            this.transactionCountThisPeriod = _data["TransactionCountThisPeriod"];
            this.transactionCreatedCountThisMonth = _data["TransactionCreatedCountThisMonth"];
            this.transactionCreatedCountThisYear = _data["TransactionCreatedCountThisYear"];
            this.transactionCreatedCountThisPeriod = _data["TransactionCreatedCountThisPeriod"];
            this.lastCreatedTransactionDate = _data["LastCreatedTransactionDate"];
        }
    }

    static fromJS(data: any): TransactionCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CompanyIdentityId"] = this.companyIdentityId;
        data["TransactionCount"] = this.transactionCount;
        data["TransactionCountRetracted"] = this.transactionCountRetracted;
        data["CompanyName"] = this.companyName;
        data["InstrumentName"] = this.instrumentName;
        data["TransactionCountThisMonth"] = this.transactionCountThisMonth;
        data["TransactionCountThisYear"] = this.transactionCountThisYear;
        data["TransactionCountLastYear"] = this.transactionCountLastYear;
        data["TransactionCountThisPeriod"] = this.transactionCountThisPeriod;
        data["TransactionCreatedCountThisMonth"] = this.transactionCreatedCountThisMonth;
        data["TransactionCreatedCountThisYear"] = this.transactionCreatedCountThisYear;
        data["TransactionCreatedCountThisPeriod"] = this.transactionCreatedCountThisPeriod;
        data["LastCreatedTransactionDate"] = this.lastCreatedTransactionDate;
        return data;
    }
}

export interface ITransactionCountViewModel {
    companyIdentityId?: number | undefined;
    transactionCount?: number;
    transactionCountRetracted?: number;
    companyName?: string | undefined;
    instrumentName?: string | undefined;
    transactionCountThisMonth?: number;
    transactionCountThisYear?: number;
    transactionCountLastYear?: number;
    transactionCountThisPeriod?: number;
    transactionCreatedCountThisMonth?: number;
    transactionCreatedCountThisYear?: number;
    transactionCreatedCountThisPeriod?: number;
    lastCreatedTransactionDate?: string | undefined;
}

export class DoesCurrencyMatchCustomerGlAccountsRequest implements IDoesCurrencyMatchCustomerGlAccountsRequest {
    instrumentId?: string | undefined;
    instrumentTypeId?: InstrumentTypeEnum;
    taxable?: boolean;
    longTerm?: boolean;
    lowerOfCostOrMarket?: boolean;
    currencyCode?: string | undefined;
    portfolioId?: number | undefined;
    voucherCustomerGlAccountIds?: number[];

    constructor(data?: IDoesCurrencyMatchCustomerGlAccountsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instrumentId = _data["InstrumentId"];
            this.instrumentTypeId = _data["InstrumentTypeId"];
            this.taxable = _data["Taxable"];
            this.longTerm = _data["LongTerm"];
            this.lowerOfCostOrMarket = _data["LowerOfCostOrMarket"];
            this.currencyCode = _data["CurrencyCode"];
            this.portfolioId = _data["PortfolioId"];
            if (Array.isArray(_data["VoucherCustomerGlAccountIds"])) {
                this.voucherCustomerGlAccountIds = [] as any;
                for (let item of _data["VoucherCustomerGlAccountIds"])
                    this.voucherCustomerGlAccountIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DoesCurrencyMatchCustomerGlAccountsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoesCurrencyMatchCustomerGlAccountsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InstrumentId"] = this.instrumentId;
        data["InstrumentTypeId"] = this.instrumentTypeId;
        data["Taxable"] = this.taxable;
        data["LongTerm"] = this.longTerm;
        data["LowerOfCostOrMarket"] = this.lowerOfCostOrMarket;
        data["CurrencyCode"] = this.currencyCode;
        data["PortfolioId"] = this.portfolioId;
        if (Array.isArray(this.voucherCustomerGlAccountIds)) {
            data["VoucherCustomerGlAccountIds"] = [];
            for (let item of this.voucherCustomerGlAccountIds)
                data["VoucherCustomerGlAccountIds"].push(item);
        }
        return data;
    }
}

export interface IDoesCurrencyMatchCustomerGlAccountsRequest {
    instrumentId?: string | undefined;
    instrumentTypeId?: InstrumentTypeEnum;
    taxable?: boolean;
    longTerm?: boolean;
    lowerOfCostOrMarket?: boolean;
    currencyCode?: string | undefined;
    portfolioId?: number | undefined;
    voucherCustomerGlAccountIds?: number[];
}

export class AgGridResponseOfUpvGrouping implements IAgGridResponseOfUpvGrouping {
    rowData?: UpvGrouping[];
    rowCount?: number;

    constructor(data?: IAgGridResponseOfUpvGrouping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["RowData"])) {
                this.rowData = [] as any;
                for (let item of _data["RowData"])
                    this.rowData!.push(UpvGrouping.fromJS(item));
            }
            this.rowCount = _data["RowCount"];
        }
    }

    static fromJS(data: any): AgGridResponseOfUpvGrouping {
        data = typeof data === 'object' ? data : {};
        let result = new AgGridResponseOfUpvGrouping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rowData)) {
            data["RowData"] = [];
            for (let item of this.rowData)
                data["RowData"].push(item ? item.toJSON() : undefined as any);
        }
        data["RowCount"] = this.rowCount;
        return data;
    }
}

export interface IAgGridResponseOfUpvGrouping {
    rowData?: UpvGrouping[];
    rowCount?: number;
}

export class UpvAgGridResponse extends AgGridResponseOfUpvGrouping implements IUpvAgGridResponse {
    duplicateCount?: number;
    noBankAccountCount?: number;
    noInstrumentIdCount?: number;
    unknownCount?: number;
    unprocessedCount?: number;
    processedCount?: number;
    noSubFilterCount?: number;

    constructor(data?: IUpvAgGridResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.duplicateCount = _data["DuplicateCount"];
            this.noBankAccountCount = _data["NoBankAccountCount"];
            this.noInstrumentIdCount = _data["NoInstrumentIdCount"];
            this.unknownCount = _data["UnknownCount"];
            this.unprocessedCount = _data["UnprocessedCount"];
            this.processedCount = _data["ProcessedCount"];
            this.noSubFilterCount = _data["NoSubFilterCount"];
        }
    }

    static override fromJS(data: any): UpvAgGridResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpvAgGridResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DuplicateCount"] = this.duplicateCount;
        data["NoBankAccountCount"] = this.noBankAccountCount;
        data["NoInstrumentIdCount"] = this.noInstrumentIdCount;
        data["UnknownCount"] = this.unknownCount;
        data["UnprocessedCount"] = this.unprocessedCount;
        data["ProcessedCount"] = this.processedCount;
        data["NoSubFilterCount"] = this.noSubFilterCount;
        super.toJSON(data);
        return data;
    }
}

export interface IUpvAgGridResponse extends IAgGridResponseOfUpvGrouping {
    duplicateCount?: number;
    noBankAccountCount?: number;
    noInstrumentIdCount?: number;
    unknownCount?: number;
    unprocessedCount?: number;
    processedCount?: number;
    noSubFilterCount?: number;
}

export class UpvGrouping implements IUpvGrouping {
    voucher?: VoucherState | undefined;
    prms?: ProcessRespondMessageViewModel[] | undefined;
    id?: string | undefined;
    prmsCount?: number;
    unprocessedDuplicateCount?: number;
    totalCount?: number;

    constructor(data?: IUpvGrouping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voucher = _data["Voucher"] ? VoucherState.fromJS(_data["Voucher"]) : undefined as any;
            if (Array.isArray(_data["Prms"])) {
                this.prms = [] as any;
                for (let item of _data["Prms"])
                    this.prms!.push(ProcessRespondMessageViewModel.fromJS(item));
            }
            this.id = _data["Id"];
            this.prmsCount = _data["PrmsCount"];
            this.unprocessedDuplicateCount = _data["UnprocessedDuplicateCount"];
            this.totalCount = _data["TotalCount"];
        }
    }

    static fromJS(data: any): UpvGrouping {
        data = typeof data === 'object' ? data : {};
        let result = new UpvGrouping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Voucher"] = this.voucher ? this.voucher.toJSON() : undefined as any;
        if (Array.isArray(this.prms)) {
            data["Prms"] = [];
            for (let item of this.prms)
                data["Prms"].push(item ? item.toJSON() : undefined as any);
        }
        data["Id"] = this.id;
        data["PrmsCount"] = this.prmsCount;
        data["UnprocessedDuplicateCount"] = this.unprocessedDuplicateCount;
        data["TotalCount"] = this.totalCount;
        return data;
    }
}

export interface IUpvGrouping {
    voucher?: VoucherState | undefined;
    prms?: ProcessRespondMessageViewModel[] | undefined;
    id?: string | undefined;
    prmsCount?: number;
    unprocessedDuplicateCount?: number;
    totalCount?: number;
}

export class ProcessRespondMessageViewModel implements IProcessRespondMessageViewModel {
    id?: number;
    documentId?: number | undefined;
    voucherId?: string | undefined;
    rowId?: number | undefined;
    state?: string | undefined;
    user?: string | undefined;
    message?: string | undefined;
    date?: string;
    dismissed?: boolean;

    constructor(data?: IProcessRespondMessageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.documentId = _data["DocumentId"];
            this.voucherId = _data["VoucherId"];
            this.rowId = _data["RowId"];
            this.state = _data["State"];
            this.user = _data["User"];
            this.message = _data["Message"];
            this.date = _data["Date"];
            this.dismissed = _data["Dismissed"];
        }
    }

    static fromJS(data: any): ProcessRespondMessageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessRespondMessageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["DocumentId"] = this.documentId;
        data["VoucherId"] = this.voucherId;
        data["RowId"] = this.rowId;
        data["State"] = this.state;
        data["User"] = this.user;
        data["Message"] = this.message;
        data["Date"] = this.date;
        data["Dismissed"] = this.dismissed;
        return data;
    }
}

export interface IProcessRespondMessageViewModel {
    id?: number;
    documentId?: number | undefined;
    voucherId?: string | undefined;
    rowId?: number | undefined;
    state?: string | undefined;
    user?: string | undefined;
    message?: string | undefined;
    date?: string;
    dismissed?: boolean;
}

export class GetVouchersAgGridPageRequest extends AgGridPageRequest implements IGetVouchersAgGridPageRequest {
    documentIds?: string[] | undefined;
    quickSearch?: string | undefined;
    advancedFilter?: AdvancedFilterModel | undefined;

    constructor(data?: IGetVouchersAgGridPageRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["DocumentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["DocumentIds"])
                    this.documentIds!.push(item);
            }
            this.quickSearch = _data["QuickSearch"];
            this.advancedFilter = _data["AdvancedFilter"] ? AdvancedFilterModel.fromJS(_data["AdvancedFilter"]) : undefined as any;
        }
    }

    static override fromJS(data: any): GetVouchersAgGridPageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetVouchersAgGridPageRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentIds)) {
            data["DocumentIds"] = [];
            for (let item of this.documentIds)
                data["DocumentIds"].push(item);
        }
        data["QuickSearch"] = this.quickSearch;
        data["AdvancedFilter"] = this.advancedFilter ? this.advancedFilter.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetVouchersAgGridPageRequest extends IAgGridPageRequest {
    documentIds?: string[] | undefined;
    quickSearch?: string | undefined;
    advancedFilter?: AdvancedFilterModel | undefined;
}

export class AdvancedFilterModel implements IAdvancedFilterModel {
    filterType?: string;
    type?: string | undefined;
    colId?: string | undefined;
    filter?: string | undefined;
    conditions?: AdvancedFilterModel[] | undefined;

    constructor(data?: IAdvancedFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterType = _data["FilterType"];
            this.type = _data["Type"];
            this.colId = _data["ColId"];
            this.filter = _data["Filter"];
            if (Array.isArray(_data["Conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["Conditions"])
                    this.conditions!.push(AdvancedFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdvancedFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FilterType"] = this.filterType;
        data["Type"] = this.type;
        data["ColId"] = this.colId;
        data["Filter"] = this.filter;
        if (Array.isArray(this.conditions)) {
            data["Conditions"] = [];
            for (let item of this.conditions)
                data["Conditions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdvancedFilterModel {
    filterType?: string;
    type?: string | undefined;
    colId?: string | undefined;
    filter?: string | undefined;
    conditions?: AdvancedFilterModel[] | undefined;
}

export class GetVoucherInputResponse extends InsightBaseContract implements IGetVoucherInputResponse {
    voucher?: VoucherContractBase;

    constructor(data?: IGetVoucherInputResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.voucher = _data["Voucher"] ? VoucherContractBase.fromJS(_data["Voucher"]) : undefined as any;
        }
    }

    static override fromJS(data: any): GetVoucherInputResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherInputResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Voucher"] = this.voucher ? this.voucher.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IGetVoucherInputResponse extends IInsightBaseContract {
    voucher?: VoucherContractBase;
}

export class VoucherContractBase extends InsightBaseContract implements IVoucherContractBase {
    currentState?: string | undefined;
    flaggedFields?: FlaggedField[] | undefined;
    ticker?: string | undefined;
    orgNr?: string | undefined;
    isin?: string | undefined;
    items?: VoucherItem[];
    correlationId?: string;
    unknownActivityType?: boolean;
    tradeDate?: string | undefined;
    settlementDate?: string | undefined;
    settlementAmount?: number | undefined;
    settlementAmountCurrency?: number | undefined;
    totalQuantity?: number | undefined;
    broker?: string | undefined;
    brokerFee?: number | undefined;
    brokerFeeCurrencyAmount?: number | undefined;
    brokerFeeCurrencyCode?: string | undefined;
    totalAmount?: number | undefined;
    totalAmountCurrency?: number | undefined;
    totalAmountCurrencyCode?: string | undefined;
    description?: string | undefined;
    settlementAmountCurrencyCode?: string | undefined;
    exchangeRate?: number | undefined;
    amount?: number | undefined;
    voucherNr?: string | undefined;
    rowId?: number | undefined;
    transactionComment?: string | undefined;
    createdBy?: string | undefined;
    updatedAt?: string | undefined;
    updatedBy?: string | undefined;
    activityType?: string | undefined;
    sourceActivityType?: string | undefined;
    instrumentName?: string | undefined;
    importedInstrumentTypeId?: number | undefined;
    instrument?: InstrumentContract | undefined;
    dueDate?: string | undefined;
    multipleInstrumentMatches?: boolean;
    parsedBankAccount?: string | undefined;
    parsedVpsAccount?: string | undefined;
    parsedPortfolioAccount?: string | undefined;
    parsedCustomerId?: string | undefined;
    bankAccountId?: number | undefined;
    vpsAccountId?: number | undefined;
    portfolioId?: number | undefined;
    importedInstrumentCurrencyCode?: string | undefined;
    splitMergeFactor?: number | undefined;
    customerGlAccountIds?: string | undefined;
    interest?: number | undefined;
    currencyInterests?: number | undefined;
    documentId?: string;
    fileSource?: FileSources;
    duplicateOfVoucherId?: string | undefined;
    duplicateStatus?: VoucherDuplicateStatus | undefined;
    processingFailedReason?: string | undefined;
    creatingGlFailedReason?: string | undefined;
    sendingGlFailedReason?: string | undefined;

    constructor(data?: IVoucherContractBase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.currentState = _data["CurrentState"];
            if (Array.isArray(_data["FlaggedFields"])) {
                this.flaggedFields = [] as any;
                for (let item of _data["FlaggedFields"])
                    this.flaggedFields!.push(FlaggedField.fromJS(item));
            }
            this.ticker = _data["Ticker"];
            this.orgNr = _data["OrgNr"];
            this.isin = _data["Isin"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(VoucherItem.fromJS(item));
            }
            this.correlationId = _data["CorrelationId"];
            this.unknownActivityType = _data["UnknownActivityType"];
            this.tradeDate = _data["TradeDate"];
            this.settlementDate = _data["SettlementDate"];
            this.settlementAmount = _data["SettlementAmount"];
            this.settlementAmountCurrency = _data["SettlementAmountCurrency"];
            this.totalQuantity = _data["TotalQuantity"];
            this.broker = _data["Broker"];
            this.brokerFee = _data["BrokerFee"];
            this.brokerFeeCurrencyAmount = _data["BrokerFeeCurrencyAmount"];
            this.brokerFeeCurrencyCode = _data["BrokerFeeCurrencyCode"];
            this.totalAmount = _data["TotalAmount"];
            this.totalAmountCurrency = _data["TotalAmountCurrency"];
            this.totalAmountCurrencyCode = _data["TotalAmountCurrencyCode"];
            this.description = _data["Description"];
            this.settlementAmountCurrencyCode = _data["SettlementAmountCurrencyCode"];
            this.exchangeRate = _data["ExchangeRate"];
            this.amount = _data["Amount"];
            this.voucherNr = _data["VoucherNr"];
            this.rowId = _data["RowId"];
            this.transactionComment = _data["TransactionComment"];
            this.createdBy = _data["CreatedBy"];
            this.updatedAt = _data["UpdatedAt"];
            this.updatedBy = _data["UpdatedBy"];
            this.activityType = _data["ActivityType"];
            this.sourceActivityType = _data["SourceActivityType"];
            this.instrumentName = _data["InstrumentName"];
            this.importedInstrumentTypeId = _data["ImportedInstrumentTypeId"];
            this.instrument = _data["Instrument"] ? InstrumentContract.fromJS(_data["Instrument"]) : undefined as any;
            this.dueDate = _data["DueDate"];
            this.multipleInstrumentMatches = _data["MultipleInstrumentMatches"];
            this.parsedBankAccount = _data["ParsedBankAccount"];
            this.parsedVpsAccount = _data["ParsedVpsAccount"];
            this.parsedPortfolioAccount = _data["ParsedPortfolioAccount"];
            this.parsedCustomerId = _data["ParsedCustomerId"];
            this.bankAccountId = _data["BankAccountId"];
            this.vpsAccountId = _data["VpsAccountId"];
            this.portfolioId = _data["PortfolioId"];
            this.importedInstrumentCurrencyCode = _data["ImportedInstrumentCurrencyCode"];
            this.splitMergeFactor = _data["SplitMergeFactor"];
            this.customerGlAccountIds = _data["CustomerGlAccountIds"];
            this.interest = _data["Interest"];
            this.currencyInterests = _data["CurrencyInterests"];
            this.documentId = _data["DocumentId"];
            this.fileSource = _data["FileSource"];
            this.duplicateOfVoucherId = _data["DuplicateOfVoucherId"];
            this.duplicateStatus = _data["DuplicateStatus"];
            this.processingFailedReason = _data["ProcessingFailedReason"];
            this.creatingGlFailedReason = _data["CreatingGlFailedReason"];
            this.sendingGlFailedReason = _data["SendingGlFailedReason"];
        }
    }

    static override fromJS(data: any): VoucherContractBase {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherContractBase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CurrentState"] = this.currentState;
        if (Array.isArray(this.flaggedFields)) {
            data["FlaggedFields"] = [];
            for (let item of this.flaggedFields)
                data["FlaggedFields"].push(item ? item.toJSON() : undefined as any);
        }
        data["Ticker"] = this.ticker;
        data["OrgNr"] = this.orgNr;
        data["Isin"] = this.isin;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        data["CorrelationId"] = this.correlationId;
        data["UnknownActivityType"] = this.unknownActivityType;
        data["TradeDate"] = this.tradeDate;
        data["SettlementDate"] = this.settlementDate;
        data["SettlementAmount"] = this.settlementAmount;
        data["SettlementAmountCurrency"] = this.settlementAmountCurrency;
        data["TotalQuantity"] = this.totalQuantity;
        data["Broker"] = this.broker;
        data["BrokerFee"] = this.brokerFee;
        data["BrokerFeeCurrencyAmount"] = this.brokerFeeCurrencyAmount;
        data["BrokerFeeCurrencyCode"] = this.brokerFeeCurrencyCode;
        data["TotalAmount"] = this.totalAmount;
        data["TotalAmountCurrency"] = this.totalAmountCurrency;
        data["TotalAmountCurrencyCode"] = this.totalAmountCurrencyCode;
        data["Description"] = this.description;
        data["SettlementAmountCurrencyCode"] = this.settlementAmountCurrencyCode;
        data["ExchangeRate"] = this.exchangeRate;
        data["Amount"] = this.amount;
        data["VoucherNr"] = this.voucherNr;
        data["RowId"] = this.rowId;
        data["TransactionComment"] = this.transactionComment;
        data["CreatedBy"] = this.createdBy;
        data["UpdatedAt"] = this.updatedAt;
        data["UpdatedBy"] = this.updatedBy;
        data["ActivityType"] = this.activityType;
        data["SourceActivityType"] = this.sourceActivityType;
        data["InstrumentName"] = this.instrumentName;
        data["ImportedInstrumentTypeId"] = this.importedInstrumentTypeId;
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        data["DueDate"] = this.dueDate;
        data["MultipleInstrumentMatches"] = this.multipleInstrumentMatches;
        data["ParsedBankAccount"] = this.parsedBankAccount;
        data["ParsedVpsAccount"] = this.parsedVpsAccount;
        data["ParsedPortfolioAccount"] = this.parsedPortfolioAccount;
        data["ParsedCustomerId"] = this.parsedCustomerId;
        data["BankAccountId"] = this.bankAccountId;
        data["VpsAccountId"] = this.vpsAccountId;
        data["PortfolioId"] = this.portfolioId;
        data["ImportedInstrumentCurrencyCode"] = this.importedInstrumentCurrencyCode;
        data["SplitMergeFactor"] = this.splitMergeFactor;
        data["CustomerGlAccountIds"] = this.customerGlAccountIds;
        data["Interest"] = this.interest;
        data["CurrencyInterests"] = this.currencyInterests;
        data["DocumentId"] = this.documentId;
        data["FileSource"] = this.fileSource;
        data["DuplicateOfVoucherId"] = this.duplicateOfVoucherId;
        data["DuplicateStatus"] = this.duplicateStatus;
        data["ProcessingFailedReason"] = this.processingFailedReason;
        data["CreatingGlFailedReason"] = this.creatingGlFailedReason;
        data["SendingGlFailedReason"] = this.sendingGlFailedReason;
        super.toJSON(data);
        return data;
    }
}

export interface IVoucherContractBase extends IInsightBaseContract {
    currentState?: string | undefined;
    flaggedFields?: FlaggedField[] | undefined;
    ticker?: string | undefined;
    orgNr?: string | undefined;
    isin?: string | undefined;
    items?: VoucherItem[];
    correlationId?: string;
    unknownActivityType?: boolean;
    tradeDate?: string | undefined;
    settlementDate?: string | undefined;
    settlementAmount?: number | undefined;
    settlementAmountCurrency?: number | undefined;
    totalQuantity?: number | undefined;
    broker?: string | undefined;
    brokerFee?: number | undefined;
    brokerFeeCurrencyAmount?: number | undefined;
    brokerFeeCurrencyCode?: string | undefined;
    totalAmount?: number | undefined;
    totalAmountCurrency?: number | undefined;
    totalAmountCurrencyCode?: string | undefined;
    description?: string | undefined;
    settlementAmountCurrencyCode?: string | undefined;
    exchangeRate?: number | undefined;
    amount?: number | undefined;
    voucherNr?: string | undefined;
    rowId?: number | undefined;
    transactionComment?: string | undefined;
    createdBy?: string | undefined;
    updatedAt?: string | undefined;
    updatedBy?: string | undefined;
    activityType?: string | undefined;
    sourceActivityType?: string | undefined;
    instrumentName?: string | undefined;
    importedInstrumentTypeId?: number | undefined;
    instrument?: InstrumentContract | undefined;
    dueDate?: string | undefined;
    multipleInstrumentMatches?: boolean;
    parsedBankAccount?: string | undefined;
    parsedVpsAccount?: string | undefined;
    parsedPortfolioAccount?: string | undefined;
    parsedCustomerId?: string | undefined;
    bankAccountId?: number | undefined;
    vpsAccountId?: number | undefined;
    portfolioId?: number | undefined;
    importedInstrumentCurrencyCode?: string | undefined;
    splitMergeFactor?: number | undefined;
    customerGlAccountIds?: string | undefined;
    interest?: number | undefined;
    currencyInterests?: number | undefined;
    documentId?: string;
    fileSource?: FileSources;
    duplicateOfVoucherId?: string | undefined;
    duplicateStatus?: VoucherDuplicateStatus | undefined;
    processingFailedReason?: string | undefined;
    creatingGlFailedReason?: string | undefined;
    sendingGlFailedReason?: string | undefined;
}

export enum FileSources {
    Pdf = 0,
    ParetoPortfolioReport = 1,
    VpsExcelNO = 2,
    SB1Markets = 3,
    ParetoJson = 4,
    VpsExcelEN = 5,
    Insight = 6,
    NordnetTransactions = 7,
    ParetoXml = 8,
    NordnetXml = 9,
    HandelsBankenExcel = 10,
    HandelsBankenJSON = 11,
    OdinJson = 12,
    StorebrandExcel = 13,
    VpsPDf = 14,
    SAndPartners = 15,
    Sb1Forvaltning = 16,
    VpsNO = 21,
    VpsEN = 22,
    Pareto = 23,
    Nordnet = 24,
    HandelsBanken = 25,
    Odin = 26,
    Storebrand = 27,
    Dnb = 28,
    SaxoBank = 29,
    Industrifinans = 30,
    Non = 99,
}

export class VoucherGroup implements IVoucherGroup {
    count?: number;
    tradeDate?: string | undefined;
    totalAmount?: number | undefined;
    totalQuantity?: number | undefined;
    brokerFee?: number | undefined;
    vpsAccountId?: number | undefined;
    bankAccountId?: number | undefined;
    portfolioId?: number | undefined;
    isin?: string | undefined;
    name?: string | undefined;
    ticker?: string | undefined;
    activityType?: string | undefined;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    settlementDate?: string | undefined;
    currentState?: string | undefined;
    documentId?: string | undefined;
    importedCurrency?: string | undefined;
    instrumentId?: string | undefined;
    instrument?: Instrument | undefined;

    constructor(data?: IVoucherGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["Count"];
            this.tradeDate = _data["TradeDate"];
            this.totalAmount = _data["TotalAmount"];
            this.totalQuantity = _data["TotalQuantity"];
            this.brokerFee = _data["BrokerFee"];
            this.vpsAccountId = _data["VpsAccountId"];
            this.bankAccountId = _data["BankAccountId"];
            this.portfolioId = _data["PortfolioId"];
            this.isin = _data["Isin"];
            this.name = _data["Name"];
            this.ticker = _data["Ticker"];
            this.activityType = _data["ActivityType"];
            this.instrumentTypeId = _data["InstrumentTypeId"];
            this.settlementDate = _data["SettlementDate"];
            this.currentState = _data["CurrentState"];
            this.documentId = _data["DocumentId"];
            this.importedCurrency = _data["ImportedCurrency"];
            this.instrumentId = _data["InstrumentId"];
            this.instrument = _data["Instrument"] ? Instrument.fromJS(_data["Instrument"]) : undefined as any;
        }
    }

    static fromJS(data: any): VoucherGroup {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        data["TradeDate"] = this.tradeDate;
        data["TotalAmount"] = this.totalAmount;
        data["TotalQuantity"] = this.totalQuantity;
        data["BrokerFee"] = this.brokerFee;
        data["VpsAccountId"] = this.vpsAccountId;
        data["BankAccountId"] = this.bankAccountId;
        data["PortfolioId"] = this.portfolioId;
        data["Isin"] = this.isin;
        data["Name"] = this.name;
        data["Ticker"] = this.ticker;
        data["ActivityType"] = this.activityType;
        data["InstrumentTypeId"] = this.instrumentTypeId;
        data["SettlementDate"] = this.settlementDate;
        data["CurrentState"] = this.currentState;
        data["DocumentId"] = this.documentId;
        data["ImportedCurrency"] = this.importedCurrency;
        data["InstrumentId"] = this.instrumentId;
        data["Instrument"] = this.instrument ? this.instrument.toJSON() : undefined as any;
        return data;
    }
}

export interface IVoucherGroup {
    count?: number;
    tradeDate?: string | undefined;
    totalAmount?: number | undefined;
    totalQuantity?: number | undefined;
    brokerFee?: number | undefined;
    vpsAccountId?: number | undefined;
    bankAccountId?: number | undefined;
    portfolioId?: number | undefined;
    isin?: string | undefined;
    name?: string | undefined;
    ticker?: string | undefined;
    activityType?: string | undefined;
    instrumentTypeId?: InstrumentTypeEnum | undefined;
    settlementDate?: string | undefined;
    currentState?: string | undefined;
    documentId?: string | undefined;
    importedCurrency?: string | undefined;
    instrumentId?: string | undefined;
    instrument?: Instrument | undefined;
}

export class BatchProcessingCompleteEvent implements IBatchProcessingCompleteEvent {
    correlationId?: string;
    newVoucherId?: string | undefined;

    constructor(data?: IBatchProcessingCompleteEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.correlationId = _data["CorrelationId"];
            this.newVoucherId = _data["NewVoucherId"];
        }
    }

    static fromJS(data: any): BatchProcessingCompleteEvent {
        data = typeof data === 'object' ? data : {};
        let result = new BatchProcessingCompleteEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CorrelationId"] = this.correlationId;
        data["NewVoucherId"] = this.newVoucherId;
        return data;
    }
}

export interface IBatchProcessingCompleteEvent {
    correlationId?: string;
    newVoucherId?: string | undefined;
}

export class PostSimilarRequest implements IPostSimilarRequest {
    instrumentName?: string | undefined;
    isin?: string | undefined;
    documentIds?: string[] | undefined;
    onlySameNameAndIsin?: boolean;
    updateField?: SimilarVouchersUpdateField | undefined;
    modelVoucher?: VoucherContractBase | undefined;

    constructor(data?: IPostSimilarRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instrumentName = _data["InstrumentName"];
            this.isin = _data["Isin"];
            if (Array.isArray(_data["DocumentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["DocumentIds"])
                    this.documentIds!.push(item);
            }
            this.onlySameNameAndIsin = _data["OnlySameNameAndIsin"];
            this.updateField = _data["UpdateField"];
            this.modelVoucher = _data["ModelVoucher"] ? VoucherContractBase.fromJS(_data["ModelVoucher"]) : undefined as any;
        }
    }

    static fromJS(data: any): PostSimilarRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostSimilarRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InstrumentName"] = this.instrumentName;
        data["Isin"] = this.isin;
        if (Array.isArray(this.documentIds)) {
            data["DocumentIds"] = [];
            for (let item of this.documentIds)
                data["DocumentIds"].push(item);
        }
        data["OnlySameNameAndIsin"] = this.onlySameNameAndIsin;
        data["UpdateField"] = this.updateField;
        data["ModelVoucher"] = this.modelVoucher ? this.modelVoucher.toJSON() : undefined as any;
        return data;
    }
}

export interface IPostSimilarRequest {
    instrumentName?: string | undefined;
    isin?: string | undefined;
    documentIds?: string[] | undefined;
    onlySameNameAndIsin?: boolean;
    updateField?: SimilarVouchersUpdateField | undefined;
    modelVoucher?: VoucherContractBase | undefined;
}

export enum SimilarVouchersUpdateField {
    Instrument = 1,
    BankAccount = 2,
    VpsAccount = 3,
    Portfolio = 4,
}

export class SendGlBatchRequest implements ISendGlBatchRequest {
    voucherIds?: string[];

    constructor(data?: ISendGlBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["VoucherIds"])) {
                this.voucherIds = [] as any;
                for (let item of _data["VoucherIds"])
                    this.voucherIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SendGlBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendGlBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.voucherIds)) {
            data["VoucherIds"] = [];
            for (let item of this.voucherIds)
                data["VoucherIds"].push(item);
        }
        return data;
    }
}

export interface ISendGlBatchRequest {
    voucherIds?: string[];
}

export class VoucherStateHistory extends VoucherState implements IVoucherStateHistory {
    id?: string;

    constructor(data?: IVoucherStateHistory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
        }
    }

    static override fromJS(data: any): VoucherStateHistory {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherStateHistory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IVoucherStateHistory extends IVoucherState {
    id?: string;
}

/** Available statuses:<br/>0: Enriching<br/>1: CreatingInstrument<br/>2: ValidationFailed<br/>3: Validated<br/>4: Processing<br/>5: ProcessingTimedOut<br/>6: ProcessingFailed<br/>7: Processed<br/>8: DocumentArchived<br/>9: RetractingAndCreatingGl<br/>10: RetractingAndCreatingGlFailed<br/>11: RetractingAndCreatingGlTimedOut<br/>12: RetractingAndDeletingGl<br/>13: RetractingAndDeletingGlFailed<br/>14: RetractingAndDeletingGlTimedOut<br/>15: SendingRetractGl<br/>16: SendingRetractGlFailed<br/>17: SendingRetractGlTimedOut<br/>18: SendingRetractGlFailedConfirmed<br/>19: GlRetracted<br/>20: LegacyRetracted<br/>21: Retracted<br/>22: CreatingGl<br/>23: CreatingGlFailed<br/>24: CreatingGlTimedOut<br/>25: GlCreated<br/>26: SendingGl<br/>27: WaitingForDocumentPath<br/>28: SendingGlFailed<br/>29: SendingGlTimedOut<br/>30: SendingGlFailedConfirmed<br/>31: GlPosted<br/>32: GlPostedAndDocumentUploaded<br/>33: GlPostedAndDocUploadFailed<br/>34: GlRetractedAndDocumentUploaded<br/>35: GlRetractedAndDocUploadFailed<br/>36: Initial<br/>37: Final */
export enum VoucherStateMachineStatus {
    Enriching = "Enriching",
    CreatingInstrument = "CreatingInstrument",
    ValidationFailed = "ValidationFailed",
    Validated = "Validated",
    Processing = "Processing",
    ProcessingTimedOut = "ProcessingTimedOut",
    ProcessingFailed = "ProcessingFailed",
    Processed = "Processed",
    DocumentArchived = "DocumentArchived",
    RetractingAndCreatingGl = "RetractingAndCreatingGl",
    RetractingAndCreatingGlFailed = "RetractingAndCreatingGlFailed",
    RetractingAndCreatingGlTimedOut = "RetractingAndCreatingGlTimedOut",
    RetractingAndDeletingGl = "RetractingAndDeletingGl",
    RetractingAndDeletingGlFailed = "RetractingAndDeletingGlFailed",
    RetractingAndDeletingGlTimedOut = "RetractingAndDeletingGlTimedOut",
    SendingRetractGl = "SendingRetractGl",
    SendingRetractGlFailed = "SendingRetractGlFailed",
    SendingRetractGlTimedOut = "SendingRetractGlTimedOut",
    SendingRetractGlFailedConfirmed = "SendingRetractGlFailedConfirmed",
    GlRetracted = "GlRetracted",
    LegacyRetracted = "LegacyRetracted",
    Retracted = "Retracted",
    CreatingGl = "CreatingGl",
    CreatingGlFailed = "CreatingGlFailed",
    CreatingGlTimedOut = "CreatingGlTimedOut",
    GlCreated = "GlCreated",
    SendingGl = "SendingGl",
    WaitingForDocumentPath = "WaitingForDocumentPath",
    SendingGlFailed = "SendingGlFailed",
    SendingGlTimedOut = "SendingGlTimedOut",
    SendingGlFailedConfirmed = "SendingGlFailedConfirmed",
    GlPosted = "GlPosted",
    GlPostedAndDocumentUploaded = "GlPostedAndDocumentUploaded",
    GlPostedAndDocUploadFailed = "GlPostedAndDocUploadFailed",
    GlRetractedAndDocumentUploaded = "GlRetractedAndDocumentUploaded",
    GlRetractedAndDocUploadFailed = "GlRetractedAndDocUploadFailed",
    Initial = "Initial",
    Final = "Final",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function getTraceParent(span: Span) {
  return `00-${span.spanContext().traceId}-${span.spanContext().spanId}-0${Number(span.spanContext().traceFlags || TraceFlags.NONE).toString(16)}`;
}